import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any; }
  Blob: { input: any; output: any; }
  /** A datetime type, encoded in ISO 8601 string in JSON, or timestamp type in MessagePack */
  DateTime: { input: any; output: any; }
};

/** Personal access tokens */
export type AccessToken = Node & {
  readonly __typename?: 'AccessToken';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly descriptionHtml: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  /** It returns true if (1) the access token is not revoked, and (2) the author of the access token is alive. */
  readonly isActive: Scalars['Boolean']['output'];
  readonly isRevoked: Scalars['Boolean']['output'];
  readonly lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly logs: AccessTokenLogConnection;
  readonly path: Scalars['String']['output'];
  readonly scopes: ReadonlyArray<AccessTokenScope>;
  readonly title: Scalars['String']['output'];
  /** The secret token value, which is only available via `createAccessToken` mutation. */
  readonly token?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  /** The author of the access token */
  readonly user: User;
};


/** Personal access tokens */
export type AccessTokenLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for AccessToken. */
export type AccessTokenConnection = {
  readonly __typename?: 'AccessTokenConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AccessTokenEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<AccessToken>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccessTokenEdge = {
  readonly __typename?: 'AccessTokenEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<AccessToken>;
};

/** Usage logs for personal access tokens */
export type AccessTokenLog = Node & {
  readonly __typename?: 'AccessTokenLog';
  readonly accessToken: AccessToken;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly ipAddress: Scalars['String']['output'];
  readonly operationType: Scalars['String']['output'];
  readonly query: Scalars['String']['output'];
  readonly user: User;
  readonly userAgent: Scalars['String']['output'];
};

/** The connection type for AccessTokenLog. */
export type AccessTokenLogConnection = {
  readonly __typename?: 'AccessTokenLogConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AccessTokenLogEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<AccessTokenLog>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AccessTokenLogEdge = {
  readonly __typename?: 'AccessTokenLogEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<AccessTokenLog>;
};

export enum AccessTokenScope {
  /** @deprecated Not yet implemented */
  Administer = 'ADMINISTER',
  Read = 'READ',
  Write = 'WRITE'
}

/** Autogenerated input type of ArchiveFolder */
export type ArchiveFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveFolder. */
export type ArchiveFolderPayload = {
  readonly __typename?: 'ArchiveFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly folder: Folder;
  /** @deprecated This is an internal feature. */
  readonly foldersCacheKey: Scalars['String']['output'];
};

/** Autogenerated input type of ArchiveFolders */
export type ArchiveFoldersInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ids: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of ArchiveFolders. */
export type ArchiveFoldersPayload = {
  readonly __typename?: 'ArchiveFoldersPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly folders: ReadonlyArray<Folder>;
  /** @deprecated This is an internal feature. */
  readonly foldersCacheKey: Scalars['String']['output'];
};

/** Autogenerated input type of ArchiveGroup */
export type ArchiveGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveGroup. */
export type ArchiveGroupPayload = {
  readonly __typename?: 'ArchiveGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly group: Group;
};

/** Autogenerated input type of ArchiveNote */
export type ArchiveNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveNote. */
export type ArchiveNotePayload = {
  readonly __typename?: 'ArchiveNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** Autogenerated input type of ArchiveNotes */
export type ArchiveNotesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ids: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of ArchiveNotes. */
export type ArchiveNotesPayload = {
  readonly __typename?: 'ArchiveNotesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly notes: ReadonlyArray<Note>;
};

export type AssistantMessage = {
  readonly __typename?: 'AssistantMessage';
  readonly assistantReferenceDocuments: AssistantReferenceDocumentConnection;
  readonly content?: Maybe<Scalars['String']['output']>;
  readonly contentHtml?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly status: AssistantMessageStatus;
};


export type AssistantMessageAssistantReferenceDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export enum AssistantMessageStatus {
  /** Message has been spoken */
  Ended = 'ENDED',
  /** Message has been interupted */
  Interupted = 'INTERUPTED',
  /** Message is pending */
  Pending = 'PENDING',
  /** Message is being spoken */
  Speaking = 'SPEAKING'
}

export type AssistantReferenceDocument = Node & {
  readonly __typename?: 'AssistantReferenceDocument';
  readonly id: Scalars['ID']['output'];
  readonly source: AssistantReferenceSource;
};

/** The connection type for AssistantReferenceDocument. */
export type AssistantReferenceDocumentConnection = {
  readonly __typename?: 'AssistantReferenceDocumentConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<AssistantReferenceDocumentEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<AssistantReferenceDocument>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssistantReferenceDocumentEdge = {
  readonly __typename?: 'AssistantReferenceDocumentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<AssistantReferenceDocument>;
};

export type AssistantReferenceSource = Node & {
  readonly __typename?: 'AssistantReferenceSource';
  readonly author: User;
  readonly id: Scalars['ID']['output'];
  readonly path: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

/** Autogenerated input type of AttachNoteToFolder */
export type AttachNoteToFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly folder: FolderInput;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of AttachNoteToFolder. */
export type AttachNoteToFolderPayload = {
  readonly __typename?: 'AttachNoteToFolderPayload';
  readonly attachedFolder: Folder;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This is an internal feature. */
  readonly foldersCacheKey: Scalars['String']['output'];
  readonly note: Note;
};

export type Attachment = Node & {
  readonly __typename?: 'Attachment';
  readonly author: User;
  readonly createdAt: Scalars['DateTime']['output'];
  /** The data of the attachment in binary. Prefer `data_url` if you use JSON for serializers */
  readonly data: Scalars['Blob']['output'];
  /** The same value as `data` but encoded in data URL schema */
  readonly dataUrl: Scalars['String']['output'];
  readonly filePreview?: Maybe<AttachmentFilePreview>;
  readonly id: Scalars['ID']['output'];
  readonly key: Scalars['String']['output'];
  readonly kind: AttachmentKind;
  /** A MIME type detected from its data and name */
  readonly mimeType: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly path: Scalars['String']['output'];
  /** The file size */
  readonly size: Scalars['Int']['output'];
  readonly url: Scalars['String']['output'];
};

export type AttachmentFilePreview = Node & {
  readonly __typename?: 'AttachmentFilePreview';
  readonly asset?: Maybe<AttachmentFilePreviewAsset>;
  readonly attemptsCount: Scalars['Int']['output'];
  readonly conversionState: AttachmentFilePreviewConversionState;
  readonly id: Scalars['ID']['output'];
  readonly lastPreviewedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AttachmentFilePreviewAsset = Node & {
  readonly __typename?: 'AttachmentFilePreviewAsset';
  readonly height: Scalars['Int']['output'];
  readonly id: Scalars['ID']['output'];
  readonly width: Scalars['Int']['output'];
};

export enum AttachmentFilePreviewConversionState {
  Failed = 'FAILED',
  LimitExceeded = 'LIMIT_EXCEEDED',
  None = 'NONE',
  Processing = 'PROCESSING',
  Success = 'SUCCESS'
}

/** How and where the attachment is used. */
export enum AttachmentKind {
  General = 'GENERAL',
  GroupCoverImage = 'GROUP_COVER_IMAGE',
  UserAvatarImage = 'USER_AVATAR_IMAGE',
  UserCoverImage = 'USER_COVER_IMAGE'
}

/** Kibela Web API budget like RateLimit of RESTful API */
export type Budget = {
  readonly __typename?: 'Budget';
  readonly consumed: Scalars['BigInt']['output'];
  /** The point cost for the current query counting against the budget. */
  readonly cost: Scalars['BigInt']['output'];
  readonly remaining: Scalars['BigInt']['output'];
};

export type ChatgptMessage = {
  readonly content: Scalars['String']['input'];
  readonly role: Scalars['String']['input'];
};

/** Autogenerated input type of CloseAnnouncement */
export type CloseAnnouncementInput = {
  readonly announcementKey: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CloseAnnouncement. */
export type CloseAnnouncementPayload = {
  readonly __typename?: 'CloseAnnouncementPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** The Note coedit room type */
export type CoeditRoom = Node & {
  readonly __typename?: 'CoeditRoom';
  readonly activeUserAccounts: ReadonlyArray<Scalars['String']['output']>;
  /** ID of the object. */
  readonly id: Scalars['ID']['output'];
};

/** The contents of Note being edited in collab mode. */
export type CollabModeData = {
  readonly __typename?: 'CollabModeData';
  readonly content: Scalars['String']['output'];
  readonly contentHtml: Scalars['String']['output'];
  readonly contentTocHtml: Scalars['String']['output'];
  readonly folders?: Maybe<FolderConnection>;
  readonly groups?: Maybe<ReadonlyArray<Group>>;
  readonly memberCount: Scalars['Int']['output'];
  readonly publishPlacesChanged: Scalars['Boolean']['output'];
  readonly title: Scalars['String']['output'];
};


/** The contents of Note being edited in collab mode. */
export type CollabModeDataFoldersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A comment that belongs to a Note */
export type Comment = Node & {
  readonly __typename?: 'Comment';
  readonly anchor: Scalars['String']['output'];
  readonly author: User;
  readonly canBeLiked: Scalars['Boolean']['output'];
  readonly canBeUpdated: Scalars['Boolean']['output'];
  readonly content: Scalars['String']['output'];
  readonly contentHtml: Scalars['String']['output'];
  readonly contentSummaryHtml: Scalars['String']['output'];
  readonly contentUpdatedAt: Scalars['DateTime']['output'];
  readonly contributors: UserConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly editedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isEdited: Scalars['Boolean']['output'];
  readonly isLikedByCurrentUser: Scalars['Boolean']['output'];
  readonly likers: UserConnection;
  readonly path: Scalars['String']['output'];
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly replies: CommentReplyConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
};


/** A comment that belongs to a Note */
export type CommentContributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributorOrder>;
};


/** A comment that belongs to a Note */
export type CommentLikersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A comment that belongs to a Note */
export type CommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Comment. */
export type CommentConnection = {
  readonly __typename?: 'CommentConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CommentEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Comment>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommentEdge = {
  readonly __typename?: 'CommentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Comment>;
};

/** The Comment Reply type */
export type CommentReply = Node & {
  readonly __typename?: 'CommentReply';
  readonly anchor: Scalars['String']['output'];
  readonly author: User;
  readonly canBeLiked: Scalars['Boolean']['output'];
  readonly canBeUpdated: Scalars['Boolean']['output'];
  readonly content: Scalars['String']['output'];
  readonly contentHtml: Scalars['String']['output'];
  readonly contentSummaryHtml: Scalars['String']['output'];
  readonly contentUpdatedAt: Scalars['DateTime']['output'];
  readonly contributors: UserConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly editedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isEdited: Scalars['Boolean']['output'];
  readonly isLikedByCurrentUser: Scalars['Boolean']['output'];
  readonly likers: UserConnection;
  readonly path: Scalars['String']['output'];
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};


/** The Comment Reply type */
export type CommentReplyContributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributorOrder>;
};


/** The Comment Reply type */
export type CommentReplyLikersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for CommentReply. */
export type CommentReplyConnection = {
  readonly __typename?: 'CommentReplyConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CommentReplyEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<CommentReply>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommentReplyEdge = {
  readonly __typename?: 'CommentReplyEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CommentReply>;
};

/** A contributor in the coedit mode */
export type ContributorInput = {
  readonly account: Scalars['String']['input'];
  readonly joinOrder: Scalars['Int']['input'];
};

export type ContributorOrder = {
  readonly direction?: InputMaybe<OrderDirection>;
  readonly field?: InputMaybe<ContributorOrderField>;
};

/** Properties by which contributors can be ordered. */
export enum ContributorOrderField {
  ContributedAt = 'CONTRIBUTED_AT'
}

/** Autogenerated input type of CreateAccessToken */
export type CreateAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description: Scalars['String']['input'];
  readonly scopes: ReadonlyArray<AccessTokenScope>;
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateAccessToken. */
export type CreateAccessTokenPayload = {
  readonly __typename?: 'CreateAccessTokenPayload';
  /** It includes the secret `token`, which you never see again. */
  readonly accessToken: AccessToken;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateAssistantMessage */
export type CreateAssistantMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly messages: ReadonlyArray<ChatgptMessage>;
};

/** Autogenerated return type of CreateAssistantMessage. */
export type CreateAssistantMessagePayload = {
  readonly __typename?: 'CreateAssistantMessagePayload';
  readonly assistantMessage: AssistantMessage;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateComment */
export type CreateCommentInput = {
  /**
   * You can set any user as the author.
   * The default is the user who executes this mutation.
   * Note that the contributors still include the user who executes this mutation in order to avoid spoofing.
   */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly commentableId: Scalars['ID']['input'];
  readonly content: Scalars['String']['input'];
  /** The time when the comment is published. If not specified, `createdAt` is set to `publishedAt` */
  readonly publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Autogenerated return type of CreateComment. */
export type CreateCommentPayload = {
  readonly __typename?: 'CreateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment: Comment;
};

/** Autogenerated input type of CreateCommentReply */
export type CreateCommentReplyInput = {
  /**
   * You can set any user as the author.
   * The default is the user who executes this mutation.
   * Note that the contributors still include the user who executes this mutation in order to avoid spoofing.
   */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly commentId: Scalars['ID']['input'];
  readonly content: Scalars['String']['input'];
  /** The time when the comment is published. If not specified, `createdAt` is set to `publishedAt` */
  readonly publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Autogenerated return type of CreateCommentReply. */
export type CreateCommentReplyPayload = {
  readonly __typename?: 'CreateCommentReplyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly reply: CommentReply;
};

/** Autogenerated input type of CreateCustomEmoji */
export type CreateCustomEmojiInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Up to 50 alphanumeric characters and underscores(_) can be used. */
  readonly emojiCode: Scalars['String']['input'];
  /** BASE64 encoded image data URL */
  readonly imageDataUrl: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCustomEmoji. */
export type CreateCustomEmojiPayload = {
  readonly __typename?: 'CreateCustomEmojiPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly customEmoji: CustomEmoji;
};

/** Autogenerated input type of CreateDisabledUser */
export type CreateDisabledUserInput = {
  /** `account` must be unique in the team */
  readonly account: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** `email` must be unique in the team */
  readonly email: Scalars['String']['input'];
  readonly realName: Scalars['String']['input'];
  readonly role?: InputMaybe<Role>;
};

/** Autogenerated return type of CreateDisabledUser. */
export type CreateDisabledUserPayload = {
  readonly __typename?: 'CreateDisabledUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user: User;
};

/** Autogenerated input type of CreateFolder */
export type CreateFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly folder?: InputMaybe<FolderInput>;
};

/** Autogenerated return type of CreateFolder. */
export type CreateFolderPayload = {
  readonly __typename?: 'CreateFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly folder: Folder;
  /** @deprecated This is an internal feature. */
  readonly foldersCacheKey: Scalars['String']['output'];
};

/** Autogenerated input type of CreateFolderPin */
export type CreateFolderPinInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Target folder. It is required when the note has 2 or more associated folders. */
  readonly folder?: InputMaybe<FolderInput>;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFolderPin. */
export type CreateFolderPinPayload = {
  readonly __typename?: 'CreateFolderPinPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly folder: Folder;
};

/** Autogenerated input type of CreateGroup */
export type CreateGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coverImageKey?: InputMaybe<Scalars['String']['input']>;
  readonly description: Scalars['String']['input'];
  readonly isPrivate: Scalars['Boolean']['input'];
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateGroup. */
export type CreateGroupPayload = {
  readonly __typename?: 'CreateGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly group: Group;
};

/** Autogenerated input type of CreateGroupPin */
export type CreateGroupPinInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupId: Scalars['ID']['input'];
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateGroupPin. */
export type CreateGroupPinPayload = {
  readonly __typename?: 'CreateGroupPinPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly group: Group;
};

/** Autogenerated input type of CreateNote */
export type CreateNoteInput = {
  /**
   * You can set any user as the author.
   * The default is the user who executes this mutation.
   * Note that the contributors still include the user who executes this mutation in order to avoid spoofing.
   */
  readonly authorId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coediting: Scalars['Boolean']['input'];
  readonly content: Scalars['String']['input'];
  readonly draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Note can now have multiple folders, use folders instead. */
  readonly folderName?: InputMaybe<Scalars['String']['input']>;
  readonly folders?: InputMaybe<ReadonlyArray<FolderInput>>;
  readonly groupIds: ReadonlyArray<Scalars['ID']['input']>;
  /** The time when the note is published. If `draft: true` is specified, the param is ignored. */
  readonly publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateNote. */
export type CreateNotePayload = {
  readonly __typename?: 'CreateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** Autogenerated input type of CreateNoteTemplate */
export type CreateNoteTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coediting: Scalars['Boolean']['input'];
  readonly content: Scalars['String']['input'];
  readonly folders?: InputMaybe<ReadonlyArray<FolderInput>>;
  readonly groupIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateNoteTemplate. */
export type CreateNoteTemplatePayload = {
  readonly __typename?: 'CreateNoteTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly noteTemplate: NoteTemplate;
};

/** Autogenerated input type of CreateReviewableDraftComment */
export type CreateReviewableDraftCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly content: Scalars['String']['input'];
  readonly reviewableDraftId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateReviewableDraftComment. */
export type CreateReviewableDraftCommentPayload = {
  readonly __typename?: 'CreateReviewableDraftCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment: ReviewableDraftComment;
};

/** Autogenerated input type of CreateSearchFilterSet */
export type CreateSearchFilterSetInput = {
  readonly authorUserIds: ReadonlyArray<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dateGte?: InputMaybe<Scalars['String']['input']>;
  readonly excludeKeywords: ReadonlyArray<Scalars['String']['input']>;
  readonly folderIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly groupIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly isArchived: Scalars['Boolean']['input'];
  readonly isLikedByMe: Scalars['Boolean']['input'];
  readonly resourceTypes: ReadonlyArray<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSearchFilterSet. */
export type CreateSearchFilterSetPayload = {
  readonly __typename?: 'CreateSearchFilterSetPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** The Custom Emoji type */
export type CustomEmoji = Node & {
  readonly __typename?: 'CustomEmoji';
  readonly createUser: User;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly emojiCode: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly imageUrl: Scalars['String']['output'];
};

/** The connection type for CustomEmoji. */
export type CustomEmojiConnection = {
  readonly __typename?: 'CustomEmojiConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<CustomEmojiEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<CustomEmoji>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CustomEmojiEdge = {
  readonly __typename?: 'CustomEmojiEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<CustomEmoji>;
};

/** A dashboard of a group */
export type Dashboard = Node & {
  readonly __typename?: 'Dashboard';
  readonly content: Scalars['String']['output'];
  readonly contentHtml: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly group: Group;
  readonly id: Scalars['ID']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** Autogenerated input type of DeleteAttachment */
export type DeleteAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAttachment. */
export type DeleteAttachmentPayload = {
  readonly __typename?: 'DeleteAttachmentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteComment */
export type DeleteCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteComment. */
export type DeleteCommentPayload = {
  readonly __typename?: 'DeleteCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteCommentReply */
export type DeleteCommentReplyInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCommentReply. */
export type DeleteCommentReplyPayload = {
  readonly __typename?: 'DeleteCommentReplyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteCustomEmoji */
export type DeleteCustomEmojiInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly customEmojiId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCustomEmoji. */
export type DeleteCustomEmojiPayload = {
  readonly __typename?: 'DeleteCustomEmojiPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteNote */
export type DeleteNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteNote. */
export type DeleteNotePayload = {
  readonly __typename?: 'DeleteNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteNoteVersion */
export type DeleteNoteVersionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteNoteVersion. */
export type DeleteNoteVersionPayload = {
  readonly __typename?: 'DeleteNoteVersionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteSearchFilterSet */
export type DeleteSearchFilterSetInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteSearchFilterSet. */
export type DeleteSearchFilterSetPayload = {
  readonly __typename?: 'DeleteSearchFilterSetPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteSearchHistoryEntry */
export type DeleteSearchHistoryEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

/** Autogenerated return type of DeleteSearchHistoryEntry. */
export type DeleteSearchHistoryEntryPayload = {
  readonly __typename?: 'DeleteSearchHistoryEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DetachNoteFromFolder */
export type DetachNoteFromFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly folder: FolderInput;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of DetachNoteFromFolder. */
export type DetachNoteFromFolderPayload = {
  readonly __typename?: 'DetachNoteFromFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly detachedFolder: Folder;
  readonly note: Note;
};

/** Autogenerated input type of DisableCollabModeStartDialog */
export type DisableCollabModeStartDialogInput = {
  readonly account: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If specified, it will be used in preference to `account` */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of DisableCollabModeStartDialog. */
export type DisableCollabModeStartDialogPayload = {
  readonly __typename?: 'DisableCollabModeStartDialogPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user: User;
};

/** Autogenerated input type of DisableDraftReview */
export type DisableDraftReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of DisableDraftReview. */
export type DisableDraftReviewPayload = {
  readonly __typename?: 'DisableDraftReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly reviewableDraft: ReviewableDraft;
};

/** Autogenerated input type of DisableOutgoingWebhook */
export type DisableOutgoingWebhookInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DisableOutgoingWebhook. */
export type DisableOutgoingWebhookPayload = {
  readonly __typename?: 'DisableOutgoingWebhookPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly outgoingWebhook: OutgoingWebhook;
};

/** Autogenerated input type of DisableSharedNoteCommentsFeature */
export type DisableSharedNoteCommentsFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DisableSharedNoteCommentsFeature. */
export type DisableSharedNoteCommentsFeaturePayload = {
  readonly __typename?: 'DisableSharedNoteCommentsFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DisableSharedNotesFeature */
export type DisableSharedNotesFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DisableSharedNotesFeature. */
export type DisableSharedNotesFeaturePayload = {
  readonly __typename?: 'DisableSharedNotesFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DisableUser */
export type DisableUserInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of DisableUser. */
export type DisableUserPayload = {
  readonly __typename?: 'DisableUserPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DisableUsers */
export type DisableUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ids: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of DisableUsers. */
export type DisableUsersPayload = {
  readonly __typename?: 'DisableUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of EnableCollabModeStartDialog */
export type EnableCollabModeStartDialogInput = {
  readonly account: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** If specified, it will be used in preference to `account` */
  readonly userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of EnableCollabModeStartDialog. */
export type EnableCollabModeStartDialogPayload = {
  readonly __typename?: 'EnableCollabModeStartDialogPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user: User;
};

/** Autogenerated input type of EnableDraftReview */
export type EnableDraftReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnableDraftReview. */
export type EnableDraftReviewPayload = {
  readonly __typename?: 'EnableDraftReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly reviewableDraft: ReviewableDraft;
};

/** Autogenerated input type of EnableOutgoingWebhook */
export type EnableOutgoingWebhookInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of EnableOutgoingWebhook. */
export type EnableOutgoingWebhookPayload = {
  readonly __typename?: 'EnableOutgoingWebhookPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly outgoingWebhook: OutgoingWebhook;
};

/** Autogenerated input type of EnableSharedNoteCommentsFeature */
export type EnableSharedNoteCommentsFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EnableSharedNoteCommentsFeature. */
export type EnableSharedNoteCommentsFeaturePayload = {
  readonly __typename?: 'EnableSharedNoteCommentsFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of EnableSharedNotesFeature */
export type EnableSharedNotesFeatureInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EnableSharedNotesFeature. */
export type EnableSharedNotesFeaturePayload = {
  readonly __typename?: 'EnableSharedNotesFeaturePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** External URL's data for rich text editor. */
export type ExternalUrlData = {
  readonly __typename?: 'ExternalUrlData';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly favicon?: Maybe<Scalars['String']['output']>;
  readonly og?: Maybe<OpenGraph>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

/** A section of a feed, which includes notes in a folder */
export type FeedFolderParcel = {
  readonly __typename?: 'FeedFolderParcel';
  readonly date: Scalars['DateTime']['output'];
  readonly folder: Folder;
  readonly notes: NoteConnection;
};


/** A section of a feed, which includes notes in a folder */
export type FeedFolderParcelNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The kind to indicate what the feed is */
export enum FeedKind {
  All = 'ALL',
  Group = 'GROUP',
  MyFeed = 'MY_FEED'
}

/** The kind to indicate what the feed is */
export enum FeedKindWithoutGroup {
  All = 'ALL',
  MyFeed = 'MY_FEED'
}

/** A section of feed, which includes a note */
export type FeedNote = {
  readonly __typename?: 'FeedNote';
  readonly date: Scalars['DateTime']['output'];
  readonly note: Note;
};

/** A section of feed, which includes one or more notes */
export type FeedSection = FeedFolderParcel | FeedNote | FeedUserParcel;

export type FeedSectionSimpleConnection = {
  readonly __typename?: 'FeedSectionSimpleConnection';
  readonly edges: ReadonlyArray<FeedSectionSimpleEdge>;
  readonly pageInfo: FeedSectionSimplePageInfo;
};

export type FeedSectionSimpleEdge = {
  readonly __typename?: 'FeedSectionSimpleEdge';
  readonly node: FeedSection;
};

export type FeedSectionSimplePageInfo = {
  readonly __typename?: 'FeedSectionSimplePageInfo';
  readonly endCursor: Scalars['String']['output'];
  readonly hasNextPage?: Maybe<Scalars['Boolean']['output']>;
};

/** A section of feed, which includes notes written by a user */
export type FeedUserParcel = {
  readonly __typename?: 'FeedUserParcel';
  readonly date: Scalars['DateTime']['output'];
  readonly notes: NoteConnection;
  readonly user: User;
};


/** A section of feed, which includes notes written by a user */
export type FeedUserParcelNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Folder = Node & {
  readonly __typename?: 'Folder';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly canBeManaged: Scalars['Boolean']['output'];
  readonly components: ReadonlyArray<Folder>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly descendantNotes: NoteConnection;
  readonly fixedPath: Scalars['String']['output'];
  readonly folders: FolderConnection;
  readonly fullName: Scalars['String']['output'];
  readonly group: Group;
  readonly id: Scalars['ID']['output'];
  readonly lastModifiedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly name: Scalars['String']['output'];
  readonly newNotePath: Scalars['String']['output'];
  readonly notes: NoteConnection;
  readonly parent?: Maybe<Folder>;
  readonly path: Scalars['String']['output'];
  readonly pinnedNotes: NoteConnection;
  readonly unarchivableDescendantNoteTitles: ReadonlyArray<Scalars['String']['output']>;
  readonly unarchivableDescendantNotes: NoteConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type FolderDescendantNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FolderFoldersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FolderNotesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyCoediting?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<NoteOrder>;
};


export type FolderPinnedNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type FolderUnarchivableDescendantNoteTitlesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type FolderUnarchivableDescendantNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Folder. */
export type FolderConnection = {
  readonly __typename?: 'FolderConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<FolderEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Folder>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type FolderEdge = {
  readonly __typename?: 'FolderEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Folder>;
};

/** Input folder with group struct */
export type FolderInput = {
  readonly folderName: Scalars['String']['input'];
  readonly groupId: Scalars['ID']['input'];
};

export type Group = Node & {
  readonly __typename?: 'Group';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly canBeJoined: Scalars['Boolean']['output'];
  readonly canBeManaged: Scalars['Boolean']['output'];
  readonly coverImage: GroupCoverImage;
  readonly coverImageKey?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  /** @deprecated Provided only for legacy frontend. */
  readonly databaseId: Scalars['Int']['output'];
  readonly description: Scalars['String']['output'];
  readonly feedUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly folders: FolderConnection;
  readonly id: Scalars['ID']['output'];
  readonly isArchived: Scalars['Boolean']['output'];
  readonly isDefault: Scalars['Boolean']['output'];
  readonly isJoined: Scalars['Boolean']['output'];
  readonly isPrivate: Scalars['Boolean']['output'];
  readonly isVisibilityChangeable: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes: NoteConnection;
  readonly path: Scalars['String']['output'];
  readonly pinnedNotes: ReadonlyArray<Note>;
  readonly todayContributors: UserConnection;
  readonly trendNotes: NoteConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly users: UserConnection;
};


export type GroupCoverImageArgs = {
  density: Scalars['Int']['input'];
  size: GroupCoverImageSize;
};


export type GroupFoldersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
  parentFolderIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  withChildren?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GroupNotesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyNotAttachedFolder?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<NoteOrder>;
};


export type GroupTodayContributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupTrendNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type GroupUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Abilities for groups. */
export enum GroupAbility {
  AssociationManageable = 'ASSOCIATION_MANAGEABLE',
  Readable = 'READABLE'
}

/** The connection type for Group. */
export type GroupConnection = {
  readonly __typename?: 'GroupConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<GroupEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Group>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** Cover image of a group */
export type GroupCoverImage = {
  readonly __typename?: 'GroupCoverImage';
  readonly density: Scalars['Int']['output'];
  readonly height: Scalars['Int']['output'];
  readonly url: Scalars['String']['output'];
  readonly width: Scalars['Int']['output'];
};

/** The size class of group cover images */
export enum GroupCoverImageSize {
  Large = 'LARGE',
  Medium = 'MEDIUM'
}

/** An edge in a connection. */
export type GroupEdge = {
  readonly __typename?: 'GroupEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Group>;
};

/** Autogenerated input type of IgnoreMultiFactorAuthnForMultipleUsers */
export type IgnoreMultiFactorAuthnForMultipleUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly userIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of IgnoreMultiFactorAuthnForMultipleUsers. */
export type IgnoreMultiFactorAuthnForMultipleUsersPayload = {
  readonly __typename?: 'IgnoreMultiFactorAuthnForMultipleUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of IgnoreMultiFactorAuthn */
export type IgnoreMultiFactorAuthnInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of IgnoreMultiFactorAuthn. */
export type IgnoreMultiFactorAuthnPayload = {
  readonly __typename?: 'IgnoreMultiFactorAuthnPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** A user representation from importable services */
export type ImportableUser = {
  readonly __typename?: 'ImportableUser';
  readonly account: Scalars['String']['output'];
  readonly avatarUrl: Scalars['String']['output'];
  readonly realName: Scalars['String']['output'];
};

/** Internal URL's data for rich text editor. */
export type InternalUrlData = {
  readonly __typename?: 'InternalUrlData';
  readonly avatar1xUrl?: Maybe<Scalars['String']['output']>;
  readonly avatar2xUrl?: Maybe<Scalars['String']['output']>;
  readonly isCoediting: Scalars['Boolean']['output'];
  readonly linkType: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
};

/** Message hints that suggest what happens in sending invitations */
export enum InvitationHint {
  /** They is already a member of the team. Nothing is done. */
  AlreadyJoined = 'ALREADY_JOINED',
  /** The invitation has been sent to them. */
  Invited = 'INVITED',
  /** Those who is disabled before is now re-enabled. Nothing is done. */
  ReEnabled = 'RE_ENABLED'
}

/** Autogenerated input type of Invite */
export type InviteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  /** The group IDs to invite */
  readonly groupIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  /** This message is displayed in the mail content of the user who received the invitation. */
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly role?: InputMaybe<Role>;
};

/** Autogenerated return type of Invite. */
export type InvitePayload = {
  readonly __typename?: 'InvitePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  readonly hint: InvitationHint;
  readonly role: Role;
};

/** Autogenerated input type of JoinGroup */
export type JoinGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupId: Scalars['ID']['input'];
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of JoinGroup. */
export type JoinGroupPayload = {
  readonly __typename?: 'JoinGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly group: Group;
};

/** Autogenerated input type of LeaveGroup */
export type LeaveGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupId: Scalars['ID']['input'];
  readonly userId: Scalars['ID']['input'];
};

/** Autogenerated return type of LeaveGroup. */
export type LeaveGroupPayload = {
  readonly __typename?: 'LeaveGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly group: Group;
};

/** Autogenerated input type of Like */
export type LikeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly likableId: Scalars['ID']['input'];
};

/** Autogenerated return type of Like. */
export type LikePayload = {
  readonly __typename?: 'LikePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly likers: UserConnection;
};


/** Autogenerated return type of Like. */
export type LikePayloadLikersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of MarkNotificationsAsRead */
export type MarkNotificationsAsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MarkNotificationsAsRead. */
export type MarkNotificationsAsReadPayload = {
  readonly __typename?: 'MarkNotificationsAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MarkServiceNotificationsAsRead */
export type MarkServiceNotificationsAsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly serviceNotificationIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of MarkServiceNotificationsAsRead. */
export type MarkServiceNotificationsAsReadPayload = {
  readonly __typename?: 'MarkServiceNotificationsAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MoveNoteToAnotherFolder */
export type MoveNoteToAnotherFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set folderName field to empty string if the note is not attached to any folder */
  readonly fromFolder: FolderInput;
  readonly noteId: Scalars['ID']['input'];
  readonly toFolder: FolderInput;
};

/** Autogenerated return type of MoveNoteToAnotherFolder. */
export type MoveNoteToAnotherFolderPayload = {
  readonly __typename?: 'MoveNoteToAnotherFolderPayload';
  readonly afterFolder: Folder;
  /** Null when fromFolder.folderName argument is empty string */
  readonly beforeFolder?: Maybe<Folder>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** @deprecated This is an internal feature. */
  readonly foldersCacheKey: Scalars['String']['output'];
  readonly note: Note;
};

/** Autogenerated input type of MoveNoteToAnotherGroup */
export type MoveNoteToAnotherGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly fromFolderId?: InputMaybe<Scalars['ID']['input']>;
  readonly fromGroupId: Scalars['ID']['input'];
  readonly noteId: Scalars['ID']['input'];
  readonly toGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of MoveNoteToAnotherGroup. */
export type MoveNoteToAnotherGroupPayload = {
  readonly __typename?: 'MoveNoteToAnotherGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** The top-level mutation type to mutate resources */
export type Mutation = {
  readonly __typename?: 'Mutation';
  /** Archive a folder */
  readonly archiveFolder: ArchiveFolderPayload;
  /** Archive folders */
  readonly archiveFolders: ArchiveFoldersPayload;
  /** Archive a group */
  readonly archiveGroup: ArchiveGroupPayload;
  /** Archive a note */
  readonly archiveNote: ArchiveNotePayload;
  /** Archive notes */
  readonly archiveNotes: ArchiveNotesPayload;
  /** Attach a note to folder */
  readonly attachNoteToFolder: AttachNoteToFolderPayload;
  /** Close an announcement */
  readonly closeAnnouncement: CloseAnnouncementPayload;
  /** It creates an access token */
  readonly createAccessToken: CreateAccessTokenPayload;
  /** Create a new assistant message */
  readonly createAssistantMessage: CreateAssistantMessagePayload;
  /** Creates a comment */
  readonly createComment: CreateCommentPayload;
  /** Creates a reply to the comment */
  readonly createCommentReply: CreateCommentReplyPayload;
  /** Creates a custom emoji */
  readonly createCustomEmoji: CreateCustomEmojiPayload;
  /** It creates a disabled user with the specified profile. It requires  **administrative privileges**. */
  readonly createDisabledUser: CreateDisabledUserPayload;
  /** Creates a folder */
  readonly createFolder: CreateFolderPayload;
  /** Pin note to a folder */
  readonly createFolderPin: CreateFolderPinPayload;
  /**
   * Creates a group. The current user is added as a group member.
   *
   * It may fail with the `UPGRADE_REQUIRED` error code if the plan is free and there is no room to create a new group.
   */
  readonly createGroup: CreateGroupPayload;
  /** Pin note to a group */
  readonly createGroupPin: CreateGroupPinPayload;
  /** Creates a note */
  readonly createNote: CreateNotePayload;
  /** Create a note template */
  readonly createNoteTemplate: CreateNoteTemplatePayload;
  /** Creates a draft review comment */
  readonly createReviewableDraftComment: CreateReviewableDraftCommentPayload;
  /** It creates a search filter set. */
  readonly createSearchFilterSet: CreateSearchFilterSetPayload;
  /** It deletes an attachment that is owned by the current user. */
  readonly deleteAttachment: DeleteAttachmentPayload;
  /** Deletes a comment */
  readonly deleteComment: DeleteCommentPayload;
  /** Deletes a reply to comment */
  readonly deleteCommentReply: DeleteCommentReplyPayload;
  /** Deletes a custom emoji */
  readonly deleteCustomEmoji: DeleteCustomEmojiPayload;
  /** Deletes a note */
  readonly deleteNote: DeleteNotePayload;
  /** Deletes a note version */
  readonly deleteNoteVersion: DeleteNoteVersionPayload;
  /** It deletes a search filter set that is owned by the current user. */
  readonly deleteSearchFilterSet: DeleteSearchFilterSetPayload;
  /** It deletes a search history entry that is owned by the current user. */
  readonly deleteSearchHistoryEntry: DeleteSearchHistoryEntryPayload;
  /** Detach a note from folder */
  readonly detachNoteFromFolder: DetachNoteFromFolderPayload;
  /** Disable the confirmation dialog appears when the user starts the collaboration mode */
  readonly disableCollabModeStartDialog: DisableCollabModeStartDialogPayload;
  /** Disable draft review of the specified note. */
  readonly disableDraftReview: DisableDraftReviewPayload;
  /** Disable Outgoing Webhook */
  readonly disableOutgoingWebhook: DisableOutgoingWebhookPayload;
  /** Disable shared note comments feature in the team settings */
  readonly disableSharedNoteCommentsFeature: DisableSharedNoteCommentsFeaturePayload;
  /** Disable shared notes feature in the team settings */
  readonly disableSharedNotesFeature: DisableSharedNotesFeaturePayload;
  /** Disables a user. The current user must be an *admin* or *owner*. */
  readonly disableUser: DisableUserPayload;
  /** Disables multiple users. The current user must be an *admin* or *owner*. */
  readonly disableUsers: DisableUsersPayload;
  /** Enable the confirmation dialog appears when the user starts the collaboration mode */
  readonly enableCollabModeStartDialog: EnableCollabModeStartDialogPayload;
  /** Enable draft review of the specified note. */
  readonly enableDraftReview: EnableDraftReviewPayload;
  /** Enable Outgoing Webhook */
  readonly enableOutgoingWebhook: EnableOutgoingWebhookPayload;
  /** Enable shared note comments feature in the team settings */
  readonly enableSharedNoteCommentsFeature: EnableSharedNoteCommentsFeaturePayload;
  /** Enable shared notes feature in the team settings */
  readonly enableSharedNotesFeature: EnableSharedNotesFeaturePayload;
  /** Ignore multi factor authn for 1 day. */
  readonly ignoreMultiFactorAuthn: IgnoreMultiFactorAuthnPayload;
  /** Ignore multi factor authn for 1 day. */
  readonly ignoreMultiFactorAuthnForMultipleUsers: IgnoreMultiFactorAuthnForMultipleUsersPayload;
  /**
   * Invites a user with their email.
   * Only owners and admins can invite users.
   *
   * It may fail with the `UPGRADE_REQUIRED` error code if the plan is free and there is no room to create a new user.
   */
  readonly invite: InvitePayload;
  /** Join a group */
  readonly joinGroup: JoinGroupPayload;
  /** Leave a group */
  readonly leaveGroup: LeaveGroupPayload;
  /** Like a note or comment */
  readonly like: LikePayload;
  readonly markNotificationsAsRead: MarkNotificationsAsReadPayload;
  readonly markServiceNotificationsAsRead: MarkServiceNotificationsAsReadPayload;
  /** Move a note to another folder */
  readonly moveNoteToAnotherFolder: MoveNoteToAnotherFolderPayload;
  /** Move a note to another group */
  readonly moveNoteToAnotherGroup: MoveNoteToAnotherGroupPayload;
  /** Remove pinned note from a folder */
  readonly removeFolderPin: RemoveFolderPinPayload;
  /** Remove pinned note from a group */
  readonly removeGroupPin: RemoveGroupPinPayload;
  /** Request attachment to attachment file preview conversion */
  readonly requestAttachmentConversion: RequestAttachmentConversionPayload;
  /** Restore an archived folder */
  readonly restoreFolder: RestoreFolderPayload;
  /** Restore an archived group */
  readonly restoreGroup: RestoreGroupPayload;
  /** Restore an archived note */
  readonly restoreNote: RestoreNotePayload;
  /** It revokes an access token; the secret `token` is available after the access token is revoked. */
  readonly revokeAccessToken: RevokeAccessTokenPayload;
  /** Set feed to home */
  readonly setFeedToHome: SetFeedToHomePayload;
  /** Set group to home */
  readonly setGroupToHome: SetGroupToHomePayload;
  /** Share specified note with outside of the team */
  readonly shareNoteWithOutsideOfTeam: ShareNoteWithOutsideOfTeamPayload;
  /**
   * Sync last used editor for user
   * @deprecated This is beta and internal feature.
   */
  readonly syncUserLastUsedEditor: SyncUserLastUsedEditorPayload;
  /** Transfer notes of a group to another */
  readonly transferGroupNotes: TransferGroupNotesPayload;
  /** Unlike a note or comment */
  readonly unlike: UnlikePayload;
  /** Unshare specified note with outside of the team */
  readonly unshareNoteWithOutsideOfTeam: UnshareNoteWithOutsideOfTeamPayload;
  /** Unwatch a note */
  readonly unwatchNote: UnwatchNotePayload;
  /** It updates attributes of an access token */
  readonly updateAccessToken: UpdateAccessTokenPayload;
  /** Updates a comment */
  readonly updateComment: UpdateCommentPayload;
  /** Updates a reply to comment */
  readonly updateCommentReply: UpdateCommentReplyPayload;
  /** Update the content of dashboard without conflict-checking. Use updateDashboardContent to check conflict. */
  readonly updateDashboard: UpdateDashboardPayload;
  /** Update the content of a dashboard with simple conflict-checking */
  readonly updateDashboardContent: UpdateDashboardContentPayload;
  /** Update name of a folder */
  readonly updateFolderName: UpdateFolderNamePayload;
  /** Update the folder parent */
  readonly updateFolderParent: UpdateFolderParentPayload;
  /** Update a group */
  readonly updateGroup: UpdateGroupPayload;
  /** Update a note, trying to merge conflicts with the 3-way diff algorithm */
  readonly updateNote: UpdateNotePayload;
  /** Update the content of a note with conflict-checking, trying 3-way merging on conflicts */
  readonly updateNoteContent: UpdateNoteContentPayload;
  /** Replace all groups associated with the specified note */
  readonly updateNoteGroups: UpdateNoteGroupsPayload;
  /** Update a note template */
  readonly updateNoteTemplate: UpdateNoteTemplatePayload;
  /** Update title of a note */
  readonly updateNoteTitle: UpdateNoteTitlePayload;
  /** Update SAML2 single sign-on setting */
  readonly updateSaml2SsoSetting: UpdateSaml2SsoSettingPayload;
  /** Update team setting */
  readonly updateTeamSetting: UpdateTeamSettingPayload;
  /** Update notification setting of current user */
  readonly updateUserNotificationSetting: UpdateUserNotificationSettingPayload;
  /** Update groups for users */
  readonly updateUsersGroups: UpdateUsersGroupsPayload;
  /** Upload an attachment as files in markdown contents, avatars, or cover images. */
  readonly uploadAttachment: UploadAttachmentPayload;
  /** Upload an attachment as files in markdown contents, avatars, or cover images. */
  readonly uploadAttachmentWithDataUrl: UploadAttachmentWithDataUrlPayload;
  /** Watch a note */
  readonly watchNote: WatchNotePayload;
};


/** The top-level mutation type to mutate resources */
export type MutationArchiveFolderArgs = {
  input: ArchiveFolderInput;
};


/** The top-level mutation type to mutate resources */
export type MutationArchiveFoldersArgs = {
  input: ArchiveFoldersInput;
};


/** The top-level mutation type to mutate resources */
export type MutationArchiveGroupArgs = {
  input: ArchiveGroupInput;
};


/** The top-level mutation type to mutate resources */
export type MutationArchiveNoteArgs = {
  input: ArchiveNoteInput;
};


/** The top-level mutation type to mutate resources */
export type MutationArchiveNotesArgs = {
  input: ArchiveNotesInput;
};


/** The top-level mutation type to mutate resources */
export type MutationAttachNoteToFolderArgs = {
  input: AttachNoteToFolderInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCloseAnnouncementArgs = {
  input: CloseAnnouncementInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateAccessTokenArgs = {
  input: CreateAccessTokenInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateAssistantMessageArgs = {
  input: CreateAssistantMessageInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateCommentReplyArgs = {
  input: CreateCommentReplyInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateCustomEmojiArgs = {
  input: CreateCustomEmojiInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateDisabledUserArgs = {
  input: CreateDisabledUserInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateFolderPinArgs = {
  input: CreateFolderPinInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateGroupPinArgs = {
  input: CreateGroupPinInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateNoteArgs = {
  input: CreateNoteInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateNoteTemplateArgs = {
  input: CreateNoteTemplateInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateReviewableDraftCommentArgs = {
  input: CreateReviewableDraftCommentInput;
};


/** The top-level mutation type to mutate resources */
export type MutationCreateSearchFilterSetArgs = {
  input: CreateSearchFilterSetInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDeleteCommentReplyArgs = {
  input: DeleteCommentReplyInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDeleteCustomEmojiArgs = {
  input: DeleteCustomEmojiInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDeleteNoteArgs = {
  input: DeleteNoteInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDeleteNoteVersionArgs = {
  input: DeleteNoteVersionInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDeleteSearchFilterSetArgs = {
  input: DeleteSearchFilterSetInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDeleteSearchHistoryEntryArgs = {
  input: DeleteSearchHistoryEntryInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDetachNoteFromFolderArgs = {
  input: DetachNoteFromFolderInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDisableCollabModeStartDialogArgs = {
  input: DisableCollabModeStartDialogInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDisableDraftReviewArgs = {
  input: DisableDraftReviewInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDisableOutgoingWebhookArgs = {
  input: DisableOutgoingWebhookInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDisableSharedNoteCommentsFeatureArgs = {
  input: DisableSharedNoteCommentsFeatureInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDisableSharedNotesFeatureArgs = {
  input: DisableSharedNotesFeatureInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDisableUserArgs = {
  input: DisableUserInput;
};


/** The top-level mutation type to mutate resources */
export type MutationDisableUsersArgs = {
  input: DisableUsersInput;
};


/** The top-level mutation type to mutate resources */
export type MutationEnableCollabModeStartDialogArgs = {
  input: EnableCollabModeStartDialogInput;
};


/** The top-level mutation type to mutate resources */
export type MutationEnableDraftReviewArgs = {
  input: EnableDraftReviewInput;
};


/** The top-level mutation type to mutate resources */
export type MutationEnableOutgoingWebhookArgs = {
  input: EnableOutgoingWebhookInput;
};


/** The top-level mutation type to mutate resources */
export type MutationEnableSharedNoteCommentsFeatureArgs = {
  input: EnableSharedNoteCommentsFeatureInput;
};


/** The top-level mutation type to mutate resources */
export type MutationEnableSharedNotesFeatureArgs = {
  input: EnableSharedNotesFeatureInput;
};


/** The top-level mutation type to mutate resources */
export type MutationIgnoreMultiFactorAuthnArgs = {
  input: IgnoreMultiFactorAuthnInput;
};


/** The top-level mutation type to mutate resources */
export type MutationIgnoreMultiFactorAuthnForMultipleUsersArgs = {
  input: IgnoreMultiFactorAuthnForMultipleUsersInput;
};


/** The top-level mutation type to mutate resources */
export type MutationInviteArgs = {
  input: InviteInput;
};


/** The top-level mutation type to mutate resources */
export type MutationJoinGroupArgs = {
  input: JoinGroupInput;
};


/** The top-level mutation type to mutate resources */
export type MutationLeaveGroupArgs = {
  input: LeaveGroupInput;
};


/** The top-level mutation type to mutate resources */
export type MutationLikeArgs = {
  input: LikeInput;
};


/** The top-level mutation type to mutate resources */
export type MutationMarkNotificationsAsReadArgs = {
  input: MarkNotificationsAsReadInput;
};


/** The top-level mutation type to mutate resources */
export type MutationMarkServiceNotificationsAsReadArgs = {
  input: MarkServiceNotificationsAsReadInput;
};


/** The top-level mutation type to mutate resources */
export type MutationMoveNoteToAnotherFolderArgs = {
  input: MoveNoteToAnotherFolderInput;
};


/** The top-level mutation type to mutate resources */
export type MutationMoveNoteToAnotherGroupArgs = {
  input: MoveNoteToAnotherGroupInput;
};


/** The top-level mutation type to mutate resources */
export type MutationRemoveFolderPinArgs = {
  input: RemoveFolderPinInput;
};


/** The top-level mutation type to mutate resources */
export type MutationRemoveGroupPinArgs = {
  input: RemoveGroupPinInput;
};


/** The top-level mutation type to mutate resources */
export type MutationRequestAttachmentConversionArgs = {
  input: RequestAttachmentConversionInput;
};


/** The top-level mutation type to mutate resources */
export type MutationRestoreFolderArgs = {
  input: RestoreFolderInput;
};


/** The top-level mutation type to mutate resources */
export type MutationRestoreGroupArgs = {
  input: RestoreGroupInput;
};


/** The top-level mutation type to mutate resources */
export type MutationRestoreNoteArgs = {
  input: RestoreNoteInput;
};


/** The top-level mutation type to mutate resources */
export type MutationRevokeAccessTokenArgs = {
  input: RevokeAccessTokenInput;
};


/** The top-level mutation type to mutate resources */
export type MutationSetFeedToHomeArgs = {
  input: SetFeedToHomeInput;
};


/** The top-level mutation type to mutate resources */
export type MutationSetGroupToHomeArgs = {
  input: SetGroupToHomeInput;
};


/** The top-level mutation type to mutate resources */
export type MutationShareNoteWithOutsideOfTeamArgs = {
  input: ShareNoteWithOutsideOfTeamInput;
};


/** The top-level mutation type to mutate resources */
export type MutationSyncUserLastUsedEditorArgs = {
  input: SyncUserLastUsedEditorInput;
};


/** The top-level mutation type to mutate resources */
export type MutationTransferGroupNotesArgs = {
  input: TransferGroupNotesInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUnlikeArgs = {
  input: UnlikeInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUnshareNoteWithOutsideOfTeamArgs = {
  input: UnshareNoteWithOutsideOfTeamInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUnwatchNoteArgs = {
  input: UnwatchNoteInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateAccessTokenArgs = {
  input: UpdateAccessTokenInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateCommentReplyArgs = {
  input: UpdateCommentReplyInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateDashboardArgs = {
  input: UpdateDashboardInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateDashboardContentArgs = {
  input: UpdateDashboardContentInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateFolderNameArgs = {
  input: UpdateFolderNameInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateFolderParentArgs = {
  input: UpdateFolderParentInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateNoteContentArgs = {
  input: UpdateNoteContentInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateNoteGroupsArgs = {
  input: UpdateNoteGroupsInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateNoteTemplateArgs = {
  input: UpdateNoteTemplateInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateNoteTitleArgs = {
  input: UpdateNoteTitleInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateSaml2SsoSettingArgs = {
  input: UpdateSaml2SsoSettingInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateTeamSettingArgs = {
  input: UpdateTeamSettingInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateUserNotificationSettingArgs = {
  input: UpdateUserNotificationSettingInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUpdateUsersGroupsArgs = {
  input: UpdateUsersGroupsInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUploadAttachmentArgs = {
  input: UploadAttachmentInput;
};


/** The top-level mutation type to mutate resources */
export type MutationUploadAttachmentWithDataUrlArgs = {
  input: UploadAttachmentWithDataUrlInput;
};


/** The top-level mutation type to mutate resources */
export type MutationWatchNoteArgs = {
  input: WatchNoteInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  readonly id: Scalars['ID']['output'];
};

/** The Note type */
export type Note = Node & {
  readonly __typename?: 'Note';
  readonly author?: Maybe<User>;
  readonly canBeArchived: Scalars['Boolean']['output'];
  readonly canBeCommented: Scalars['Boolean']['output'];
  readonly canBeDestroyed: Scalars['Boolean']['output'];
  readonly canBeLiked: Scalars['Boolean']['output'];
  readonly canBeUpdated: Scalars['Boolean']['output'];
  /** @deprecated This is beta and internal feature. */
  readonly coeditRoom?: Maybe<CoeditRoom>;
  readonly coediting: Scalars['Boolean']['output'];
  readonly comments: CommentConnection;
  readonly commentsCount: Scalars['Int']['output'];
  readonly content: Scalars['String']['output'];
  readonly contentHtml: Scalars['String']['output'];
  readonly contentSummaryHtml: Scalars['String']['output'];
  readonly contentTocHtml: Scalars['String']['output'];
  readonly contentUpdatedAt: Scalars['DateTime']['output'];
  readonly contributors: UserConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  /** @deprecated Provided only for legacy frontend. */
  readonly databaseId: Scalars['Int']['output'];
  readonly editPath: Scalars['String']['output'];
  /** @deprecated Note can now have multiple folders, use folders. */
  readonly folderName?: Maybe<Scalars['String']['output']>;
  readonly folders: FolderConnection;
  readonly groups: ReadonlyArray<Group>;
  readonly hasCollabHistory: Scalars['Boolean']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isArchived: Scalars['Boolean']['output'];
  readonly isLikedByCurrentUser: Scalars['Boolean']['output'];
  readonly likers: UserConnection;
  readonly path: Scalars['String']['output'];
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly relatedNotes: SearchResultConnection;
  readonly reviewableDraft?: Maybe<ReviewableDraft>;
  readonly selectableGroups: GroupConnection;
  readonly sharedNote?: Maybe<SharedNote>;
  readonly title: Scalars['String']['output'];
  readonly trackbackNotes: NoteConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly url: Scalars['String']['output'];
};


/** The Note type */
export type NoteCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The Note type */
export type NoteContributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributorOrder>;
};


/** The Note type */
export type NoteFoldersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The Note type */
export type NoteLikersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The Note type */
export type NoteRelatedNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The Note type */
export type NoteSelectableGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The Note type */
export type NoteTrackbackNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Browsing history of notes */
export type NoteBrowsingHistory = Node & {
  readonly __typename?: 'NoteBrowsingHistory';
  readonly id: Scalars['ID']['output'];
  readonly note?: Maybe<Note>;
};

/** The connection type for NoteBrowsingHistory. */
export type NoteBrowsingHistoryConnection = {
  readonly __typename?: 'NoteBrowsingHistoryConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<NoteBrowsingHistoryEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<NoteBrowsingHistory>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NoteBrowsingHistoryEdge = {
  readonly __typename?: 'NoteBrowsingHistoryEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<NoteBrowsingHistory>;
};

/** The connection type for Note. */
export type NoteConnection = {
  readonly __typename?: 'NoteConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<NoteEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Note>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NoteEdge = {
  readonly __typename?: 'NoteEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Note>;
};

/** Note input struct, used to updateNote mutation */
export type NoteInput = {
  readonly coediting: Scalars['Boolean']['input'];
  readonly content: Scalars['String']['input'];
  readonly folders?: InputMaybe<ReadonlyArray<FolderInput>>;
  readonly groupIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly title: Scalars['String']['input'];
};

export type NoteOrder = {
  readonly direction?: InputMaybe<OrderDirection>;
  readonly field?: InputMaybe<NoteOrderField>;
};

/** Properties by which notes can be ordered. */
export enum NoteOrderField {
  ContentUpdatedAt = 'CONTENT_UPDATED_AT',
  PublishedAt = 'PUBLISHED_AT',
  Title = 'TITLE'
}

/** Template of note */
export type NoteTemplate = Node & {
  readonly __typename?: 'NoteTemplate';
  readonly content: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly evaluatedTitle: Scalars['String']['output'];
  readonly folders: ReadonlyArray<NoteTemplateFolder>;
  readonly groups: ReadonlyArray<Group>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for NoteTemplate. */
export type NoteTemplateConnection = {
  readonly __typename?: 'NoteTemplateConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<NoteTemplateEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<NoteTemplate>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NoteTemplateEdge = {
  readonly __typename?: 'NoteTemplateEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<NoteTemplate>;
};

/** Folder for note template. */
export type NoteTemplateFolder = Node & {
  readonly __typename?: 'NoteTemplateFolder';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly evaluatedFullName: Scalars['String']['output'];
  readonly fullName: Scalars['String']['output'];
  readonly group: Group;
  readonly id: Scalars['ID']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** Notifications you get in a Kibela team */
export type Notification = Node & {
  readonly __typename?: 'Notification';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly messageHtml: Scalars['String']['output'];
  readonly sender: User;
  readonly sourcePath: Scalars['String']['output'];
  readonly state: NotificationState;
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for Notification. */
export type NotificationConnection = {
  readonly __typename?: 'NotificationConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<Notification>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  readonly __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<Notification>;
};

/** The state of notifications */
export enum NotificationState {
  Read = 'READ',
  Unread = 'UNREAD'
}

/** OpenGraph data. */
export type OpenGraph = {
  readonly __typename?: 'OpenGraph';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly image?: Maybe<OpenGraphImage>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

/** OpenGraph Image */
export type OpenGraphImage = {
  readonly __typename?: 'OpenGraphImage';
  readonly alt?: Maybe<Scalars['String']['output']>;
  readonly height?: Maybe<Scalars['Int']['output']>;
  readonly secureUrl?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly width?: Maybe<Scalars['Int']['output']>;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Kind of the organization */
export enum OrganizationKind {
  Company = 'COMPANY',
  Other = 'OTHER',
  Personal = 'PERSONAL',
  Unknown = 'UNKNOWN'
}

/** A outgoing_webhook */
export type OutgoingWebhook = Node & {
  readonly __typename?: 'OutgoingWebhook';
  readonly disabledAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['ID']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

/** The top-level query type to Kibela resources */
export type Query = {
  readonly __typename?: 'Query';
  readonly accessToken: AccessToken;
  readonly accessTokens: AccessTokenConnection;
  /** The archived groups in the team including private ones */
  readonly archivedGroups: GroupConnection;
  readonly assistantMessage?: Maybe<AssistantMessage>;
  readonly attachmentFromPath: Attachment;
  readonly budget: Budget;
  /** @deprecated This is beta and internal feature. */
  readonly coeditToken: Scalars['String']['output'];
  /** @deprecated This is an internal field. */
  readonly collabModeData?: Maybe<CollabModeData>;
  readonly comment: Comment;
  /** The current user of the session */
  readonly currentUser: User;
  readonly customEmojiFromCode: CustomEmoji;
  readonly customEmojis: CustomEmojiConnection;
  /** @deprecated This is an internal feature. */
  readonly customEmojisCacheKey: Scalars['String']['output'];
  readonly defaultGroup?: Maybe<Group>;
  /** @deprecated This is beta and internal feature. */
  readonly externalUrlData: ExternalUrlData;
  readonly feedSections: FeedSectionSimpleConnection;
  readonly folder: Folder;
  readonly folderFromPath: Folder;
  /**
   * Returns all folders.
   * Note that the field does not distinguish groups.
   * If you need to fetch folders that is related a specific group, use GroupType.folders field.
   */
  readonly folders: FolderConnection;
  /** @deprecated This is an internal feature. */
  readonly foldersCacheKey: Scalars['String']['output'];
  readonly group: Group;
  /** The active groups in the team. */
  readonly groups: GroupConnection;
  /** @deprecated This is an internal and deprecated field. */
  readonly importableUsers: ReadonlyArray<ImportableUser>;
  /** @deprecated This is beta and internal feature. */
  readonly internalUrlData?: Maybe<InternalUrlData>;
  /** Fetches an object given its ID. */
  readonly node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  readonly nodes: ReadonlyArray<Maybe<Node>>;
  readonly note: Note;
  readonly noteBrowsingHistories: NoteBrowsingHistoryConnection;
  readonly noteFromPath: Note;
  readonly noteTemplate: NoteTemplate;
  readonly noteTemplates: NoteTemplateConnection;
  /** The connection of all the notes in the team. You *should* specify `orderBy` in production. */
  readonly notes: NoteConnection;
  readonly notifications: NotificationConnection;
  readonly renderMarkdownToHtml: Scalars['String']['output'];
  readonly reviewableDraft: ReviewableDraft;
  /** Search note/comment */
  readonly search: SearchResultConnection;
  readonly searchFilterSets: SearchFilterSetConnection;
  /** Search folder */
  readonly searchFolder: SearchFolderResultConnection;
  readonly searchHistory: SearchHistory;
  readonly serviceNotifications: ServiceNotificationConnection;
  readonly sharedNote: SharedNote;
  /** All the shared notes in the team. */
  readonly sharedNotes: SharedNoteConnection;
  /** All the access token logs in the team. This feature requires the administrative privileges */
  readonly teamAccessTokenLogs: AccessTokenLogConnection;
  readonly user: User;
  readonly userFromAccount: User;
  readonly users: UserConnection;
  readonly usersFromAccounts: UserConnection;
  /** @deprecated This is internal feature. */
  readonly validateToMove: Scalars['Boolean']['output'];
};


/** The top-level query type to Kibela resources */
export type QueryAccessTokenArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryAccessTokensArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  revoked?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryArchivedGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryAssistantMessageArgs = {
  id: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryAttachmentFromPathArgs = {
  path: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryCoeditTokenArgs = {
  noteId: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryCollabModeDataArgs = {
  noteId: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryCommentArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryCustomEmojiFromCodeArgs = {
  code: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryCustomEmojisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryExternalUrlDataArgs = {
  url: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryFeedSectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  groupId?: InputMaybe<Scalars['ID']['input']>;
  kind?: InputMaybe<FeedKind>;
};


/** The top-level query type to Kibela resources */
export type QueryFolderArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryFolderFromPathArgs = {
  path: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryFoldersArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  parentFolderId?: InputMaybe<Scalars['ID']['input']>;
  parentFolderIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The top-level query type to Kibela resources */
export type QueryGroupArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryGroupsArgs = {
  ability?: InputMaybe<GroupAbility>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryImportableUsersArgs = {
  encryptedAccessToken: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  serviceType: Scalars['String']['input'];
  teamName: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryInternalUrlDataArgs = {
  url: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryNodesArgs = {
  ids: ReadonlyArray<Scalars['ID']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryNoteArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryNoteBrowsingHistoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryNoteFromPathArgs = {
  path: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryNoteTemplateArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryNoteTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryNotesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<NoteOrder>;
};


/** The top-level query type to Kibela resources */
export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<NotificationState>;
};


/** The top-level query type to Kibela resources */
export type QueryRenderMarkdownToHtmlArgs = {
  content: Scalars['String']['input'];
  isMain: Scalars['Boolean']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryReviewableDraftArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  coediting?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  folderIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  groupIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  likerIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  query: Scalars['String']['input'];
  resources?: InputMaybe<ReadonlyArray<SearchResourceKind>>;
  sortBy?: InputMaybe<SearchSortKind>;
  updated?: InputMaybe<SearchDate>;
  userIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};


/** The top-level query type to Kibela resources */
export type QuerySearchFilterSetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QuerySearchFolderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryServiceNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QuerySharedNoteArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QuerySharedNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryTeamAccessTokenLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryUserFromAccountArgs = {
  account: Scalars['String']['input'];
};


/** The top-level query type to Kibela resources */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryUsersFromAccountsArgs = {
  accounts: ReadonlyArray<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The top-level query type to Kibela resources */
export type QueryValidateToMoveArgs = {
  folderIds: ReadonlyArray<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated input type of RemoveFolderPin */
export type RemoveFolderPinInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Target folder. It is required when the note has 2 or more associated folders. */
  readonly folder?: InputMaybe<FolderInput>;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveFolderPin. */
export type RemoveFolderPinPayload = {
  readonly __typename?: 'RemoveFolderPinPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly folder: Folder;
};

/** Autogenerated input type of RemoveGroupPin */
export type RemoveGroupPinInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupId: Scalars['ID']['input'];
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveGroupPin. */
export type RemoveGroupPinPayload = {
  readonly __typename?: 'RemoveGroupPinPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly group: Group;
};

/** Autogenerated input type of RequestAttachmentConversion */
export type RequestAttachmentConversionInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestAttachmentConversion. */
export type RequestAttachmentConversionPayload = {
  readonly __typename?: 'RequestAttachmentConversionPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversionState: AttachmentFilePreviewConversionState;
};

/** Autogenerated input type of RestoreFolder */
export type RestoreFolderInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of RestoreFolder. */
export type RestoreFolderPayload = {
  readonly __typename?: 'RestoreFolderPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly folder: Folder;
  /** @deprecated This is an internal feature. */
  readonly foldersCacheKey: Scalars['String']['output'];
};

/** Autogenerated input type of RestoreGroup */
export type RestoreGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of RestoreGroup. */
export type RestoreGroupPayload = {
  readonly __typename?: 'RestoreGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly group: Group;
};

/** Autogenerated input type of RestoreNote */
export type RestoreNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of RestoreNote. */
export type RestoreNotePayload = {
  readonly __typename?: 'RestoreNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** The Reviewable Draft type */
export type ReviewableDraft = {
  readonly __typename?: 'ReviewableDraft';
  readonly comments: ReviewableDraftCommentConnection;
  readonly id: Scalars['ID']['output'];
  readonly isEnabled: Scalars['Boolean']['output'];
  readonly url: Scalars['String']['output'];
};


/** The Reviewable Draft type */
export type ReviewableDraftCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A comment that belongs to a reviewable drarft */
export type ReviewableDraftComment = Node & {
  readonly __typename?: 'ReviewableDraftComment';
  readonly anchor: Scalars['String']['output'];
  readonly author: User;
  readonly content: Scalars['String']['output'];
  readonly contentHtml: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly path: Scalars['String']['output'];
};

/** The connection type for ReviewableDraftComment. */
export type ReviewableDraftCommentConnection = {
  readonly __typename?: 'ReviewableDraftCommentConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ReviewableDraftCommentEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<ReviewableDraftComment>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReviewableDraftCommentEdge = {
  readonly __typename?: 'ReviewableDraftCommentEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ReviewableDraftComment>;
};

/** Autogenerated input type of RevokeAccessToken */
export type RevokeAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** AccessToken ID */
  readonly id: Scalars['ID']['input'];
};

/** Autogenerated return type of RevokeAccessToken. */
export type RevokeAccessTokenPayload = {
  readonly __typename?: 'RevokeAccessTokenPayload';
  readonly accessToken: AccessToken;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** A role of a user */
export enum Role {
  Admin = 'ADMIN',
  FullMember = 'FULL_MEMBER',
  Guest = 'GUEST',
  Owner = 'OWNER',
  ReadOnly = 'READ_ONLY'
}

export enum Saml2SsoMode {
  ModeDisabled = 'MODE_DISABLED',
  ModeMigration = 'MODE_MIGRATION',
  ModeSso = 'MODE_SSO'
}

export enum SearchDate {
  All = 'ALL',
  Within_1Month = 'WITHIN_1_MONTH',
  Within_1Week = 'WITHIN_1_WEEK',
  Within_1Year = 'WITHIN_1_YEAR',
  Within_3Days = 'WITHIN_3_DAYS',
  Within_6Months = 'WITHIN_6_MONTHS'
}

export type SearchFilterSet = {
  readonly __typename?: 'SearchFilterSet';
  readonly authorUsers: ReadonlyArray<User>;
  readonly dateGte?: Maybe<Scalars['String']['output']>;
  readonly excludeKeywords: ReadonlyArray<Scalars['String']['output']>;
  readonly folders: ReadonlyArray<Folder>;
  readonly groups: ReadonlyArray<Group>;
  readonly id: Scalars['ID']['output'];
  readonly isArchived: Scalars['Boolean']['output'];
  readonly isLikedByMe: Scalars['Boolean']['output'];
  readonly resourceTypes: ReadonlyArray<Scalars['String']['output']>;
};

/** The connection type for SearchFilterSet. */
export type SearchFilterSetConnection = {
  readonly __typename?: 'SearchFilterSetConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<SearchFilterSetEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<SearchFilterSet>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SearchFilterSetEdge = {
  readonly __typename?: 'SearchFilterSetEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<SearchFilterSet>;
};

export type SearchFolderResult = {
  readonly __typename?: 'SearchFolderResult';
  readonly fixedPath: Scalars['String']['output'];
  readonly group: Group;
  readonly name: Scalars['String']['output'];
};

/** The connection type for SearchFolderResult. */
export type SearchFolderResultConnection = {
  readonly __typename?: 'SearchFolderResultConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<SearchFolderResultEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<SearchFolderResult>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SearchFolderResultEdge = {
  readonly __typename?: 'SearchFolderResultEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<SearchFolderResult>;
};

export type SearchHistory = {
  readonly __typename?: 'SearchHistory';
  readonly entries: ReadonlyArray<SearchHistoryEntry>;
};

export type SearchHistoryEntry = {
  readonly __typename?: 'SearchHistoryEntry';
  readonly authorUsers: ReadonlyArray<User>;
  readonly dateGte?: Maybe<Scalars['String']['output']>;
  readonly excludeKeywords: ReadonlyArray<Scalars['String']['output']>;
  readonly folders: ReadonlyArray<Folder>;
  readonly groups: ReadonlyArray<Group>;
  readonly hasCustomFilterSet: Scalars['Boolean']['output'];
  readonly id: Scalars['String']['output'];
  readonly isArchived: Scalars['Boolean']['output'];
  readonly isLikedByMe: Scalars['Boolean']['output'];
  readonly keywords: ReadonlyArray<Scalars['String']['output']>;
  readonly resourceTypes: ReadonlyArray<Scalars['String']['output']>;
};

/** Search target model type */
export enum SearchResourceKind {
  Comment = 'COMMENT',
  Note = 'NOTE'
}

/** A search result that refers to a document */
export type SearchResult = {
  readonly __typename?: 'SearchResult';
  readonly author: User;
  readonly contentSummaryHtml: Scalars['String']['output'];
  readonly contentUpdatedAt: Scalars['DateTime']['output'];
  readonly contributors: UserConnection;
  /** The original searchable document */
  readonly document: SearchableDocument;
  readonly path: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly titleHtml: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};


/** A search result that refers to a document */
export type SearchResultContributorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for SearchResult. */
export type SearchResultConnection = {
  readonly __typename?: 'SearchResultConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<SearchResultEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<SearchResult>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SearchResultEdge = {
  readonly __typename?: 'SearchResultEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<SearchResult>;
};

export enum SearchSortKind {
  Recent = 'RECENT',
  Relevant = 'RELEVANT'
}

export type SearchableDocument = Comment | CommentReply | Note;

/** Get the latest news and useful information from Kibela */
export type ServiceNotification = Node & {
  readonly __typename?: 'ServiceNotification';
  readonly id: Scalars['ID']['output'];
  readonly messageEn?: Maybe<Scalars['String']['output']>;
  readonly messageJa: Scalars['String']['output'];
  readonly notificationKind: ServiceNotificationKind;
  readonly read: Scalars['Boolean']['output'];
  readonly startAt: Scalars['DateTime']['output'];
  readonly titleEn?: Maybe<Scalars['String']['output']>;
  readonly titleJa: Scalars['String']['output'];
  readonly urlEn?: Maybe<Scalars['String']['output']>;
  readonly urlJa?: Maybe<Scalars['String']['output']>;
};

/** The connection type for ServiceNotification. */
export type ServiceNotificationConnection = {
  readonly __typename?: 'ServiceNotificationConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<ServiceNotificationEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<ServiceNotification>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ServiceNotificationEdge = {
  readonly __typename?: 'ServiceNotificationEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<ServiceNotification>;
};

/** The kind of ServiceNotifications */
export enum ServiceNotificationKind {
  Guide = 'GUIDE',
  Maintenance = 'MAINTENANCE',
  Marketing = 'MARKETING',
  NewFeature = 'NEW_FEATURE',
  Success = 'SUCCESS'
}

/** Autogenerated input type of SetFeedToHome */
export type SetFeedToHomeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly feed: FeedKindWithoutGroup;
};

/** Autogenerated return type of SetFeedToHome. */
export type SetFeedToHomePayload = {
  readonly __typename?: 'SetFeedToHomePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly feed: FeedKindWithoutGroup;
};

/** Autogenerated input type of SetGroupToHome */
export type SetGroupToHomeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetGroupToHome. */
export type SetGroupToHomePayload = {
  readonly __typename?: 'SetGroupToHomePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly group: Group;
};

/** Autogenerated input type of ShareNoteWithOutsideOfTeam */
export type ShareNoteWithOutsideOfTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of ShareNoteWithOutsideOfTeam. */
export type ShareNoteWithOutsideOfTeamPayload = {
  readonly __typename?: 'ShareNoteWithOutsideOfTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** The Shared Note type */
export type SharedNote = Node & {
  readonly __typename?: 'SharedNote';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['ID']['output'];
  readonly note: Note;
  readonly totalPageviews: Scalars['Int']['output'];
  readonly url: Scalars['String']['output'];
};

/** The connection type for SharedNote. */
export type SharedNoteConnection = {
  readonly __typename?: 'SharedNoteConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<SharedNoteEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<SharedNote>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SharedNoteEdge = {
  readonly __typename?: 'SharedNoteEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<SharedNote>;
};

/** Autogenerated input type of SyncUserLastUsedEditor */
export type SyncUserLastUsedEditorInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly kind: UserLastUsedEditorKind;
};

/** Autogenerated return type of SyncUserLastUsedEditor. */
export type SyncUserLastUsedEditorPayload = {
  readonly __typename?: 'SyncUserLastUsedEditorPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of TransferGroupNotes */
export type TransferGroupNotesInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly fromGroupId: Scalars['ID']['input'];
  readonly toGroupId: Scalars['ID']['input'];
};

/** Autogenerated return type of TransferGroupNotes. */
export type TransferGroupNotesPayload = {
  readonly __typename?: 'TransferGroupNotesPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly from: Group;
  readonly to: Group;
};

/** Autogenerated input type of Unlike */
export type UnlikeInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly likableId: Scalars['ID']['input'];
};

/** Autogenerated return type of Unlike. */
export type UnlikePayload = {
  readonly __typename?: 'UnlikePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly likers: UserConnection;
};


/** Autogenerated return type of Unlike. */
export type UnlikePayloadLikersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of UnshareNoteWithOutsideOfTeam */
export type UnshareNoteWithOutsideOfTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnshareNoteWithOutsideOfTeam. */
export type UnshareNoteWithOutsideOfTeamPayload = {
  readonly __typename?: 'UnshareNoteWithOutsideOfTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** Autogenerated input type of UnwatchNote */
export type UnwatchNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnwatchNote. */
export type UnwatchNotePayload = {
  readonly __typename?: 'UnwatchNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAccessToken */
export type UpdateAccessTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description: Scalars['String']['input'];
  readonly id: Scalars['ID']['input'];
  readonly scopes: ReadonlyArray<AccessTokenScope>;
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateAccessToken. */
export type UpdateAccessTokenPayload = {
  readonly __typename?: 'UpdateAccessTokenPayload';
  readonly accessToken: AccessToken;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateComment */
export type UpdateCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly content: Scalars['String']['input'];
  readonly id: Scalars['ID']['input'];
  readonly touch?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateComment. */
export type UpdateCommentPayload = {
  readonly __typename?: 'UpdateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment: Comment;
};

/** Autogenerated input type of UpdateCommentReply */
export type UpdateCommentReplyInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly content: Scalars['String']['input'];
  readonly id: Scalars['ID']['input'];
  readonly touch?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateCommentReply. */
export type UpdateCommentReplyPayload = {
  readonly __typename?: 'UpdateCommentReplyPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly reply: CommentReply;
};

/** Autogenerated input type of UpdateDashboardContent */
export type UpdateDashboardContentInput = {
  readonly baseContent: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A group ID for the dashboard */
  readonly groupId: Scalars['ID']['input'];
  readonly newContent: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateDashboardContent. */
export type UpdateDashboardContentPayload = {
  readonly __typename?: 'UpdateDashboardContentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dashboard: Dashboard;
};

/** Autogenerated input type of UpdateDashboard */
export type UpdateDashboardInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly content: Scalars['String']['input'];
  readonly groupId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateDashboard. */
export type UpdateDashboardPayload = {
  readonly __typename?: 'UpdateDashboardPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly dashboard: Dashboard;
};

/** Autogenerated input type of UpdateFolderName */
export type UpdateFolderNameInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateFolderName. */
export type UpdateFolderNamePayload = {
  readonly __typename?: 'UpdateFolderNamePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly folder: Folder;
  /** @deprecated This is an internal feature. */
  readonly foldersCacheKey: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateFolderParent */
export type UpdateFolderParentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** New parent folder path (ex. aaa/bbb) */
  readonly folderFullName?: InputMaybe<Scalars['String']['input']>;
  /** Target folder id */
  readonly folderId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateFolderParent. */
export type UpdateFolderParentPayload = {
  readonly __typename?: 'UpdateFolderParentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly folder: Folder;
  /** @deprecated This is an internal feature. */
  readonly foldersCacheKey: Scalars['String']['output'];
};

/** Autogenerated input type of UpdateGroup */
export type UpdateGroupInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coverImageKey?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateGroup. */
export type UpdateGroupPayload = {
  readonly __typename?: 'UpdateGroupPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly group: Group;
};

/** Autogenerated input type of UpdateNoteContent */
export type UpdateNoteContentInput = {
  readonly baseContent: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly newContent: Scalars['String']['input'];
  /** If false, content_updated_at is not touched. */
  readonly touch?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateNoteContent. */
export type UpdateNoteContentPayload = {
  readonly __typename?: 'UpdateNoteContentPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** Autogenerated input type of UpdateNoteGroups */
export type UpdateNoteGroupsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly noteId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateNoteGroups. */
export type UpdateNoteGroupsPayload = {
  readonly __typename?: 'UpdateNoteGroupsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** Autogenerated input type of UpdateNote */
export type UpdateNoteInput = {
  readonly baseNote: NoteInput;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated This argument is for internal use only. */
  readonly closeCoeditRoom?: InputMaybe<Scalars['Boolean']['input']>;
  readonly contributors?: InputMaybe<ReadonlyArray<ContributorInput>>;
  readonly draft: Scalars['Boolean']['input'];
  readonly id: Scalars['ID']['input'];
  readonly newNote: NoteInput;
  /** It will be truncated to 100 characters if exceeded. */
  readonly noteEditMemo?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateNote. */
export type UpdateNotePayload = {
  readonly __typename?: 'UpdateNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** Autogenerated input type of UpdateNoteTemplate */
export type UpdateNoteTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly coediting: Scalars['Boolean']['input'];
  readonly content: Scalars['String']['input'];
  readonly folders?: InputMaybe<ReadonlyArray<FolderInput>>;
  readonly groupIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly name: Scalars['String']['input'];
  readonly title: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateNoteTemplate. */
export type UpdateNoteTemplatePayload = {
  readonly __typename?: 'UpdateNoteTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly noteTemplate: NoteTemplate;
};

/** Autogenerated input type of UpdateNoteTitle */
export type UpdateNoteTitleInput = {
  readonly baseTitle: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly newTitle: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateNoteTitle. */
export type UpdateNoteTitlePayload = {
  readonly __typename?: 'UpdateNoteTitlePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly note: Note;
};

/** Autogenerated input type of UpdateSaml2SsoSetting */
export type UpdateSaml2SsoSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly mode: Saml2SsoMode;
  readonly readOnlyUserPasswordAuthnEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateSaml2SsoSetting. */
export type UpdateSaml2SsoSettingPayload = {
  readonly __typename?: 'UpdateSaml2SsoSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateTeamSetting */
export type UpdateTeamSettingInput = {
  readonly city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly country?: InputMaybe<Scalars['String']['input']>;
  readonly departmentName?: InputMaybe<Scalars['String']['input']>;
  readonly inChargeUserId?: InputMaybe<Scalars['ID']['input']>;
  readonly organizationKind?: InputMaybe<OrganizationKind>;
  readonly organizationName?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly postalCode?: InputMaybe<Scalars['String']['input']>;
  readonly state?: InputMaybe<Scalars['String']['input']>;
  readonly streetAddress?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateTeamSetting. */
export type UpdateTeamSettingPayload = {
  readonly __typename?: 'UpdateTeamSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateUserNotificationSetting */
export type UpdateUserNotificationSettingInput = {
  readonly checked: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly kind: UserNotificationSettingKind;
};

/** Autogenerated return type of UpdateUserNotificationSetting. */
export type UpdateUserNotificationSettingPayload = {
  readonly __typename?: 'UpdateUserNotificationSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateUsersGroups */
export type UpdateUsersGroupsInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupIds: ReadonlyArray<Scalars['ID']['input']>;
  readonly userIds: ReadonlyArray<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateUsersGroups. */
export type UpdateUsersGroupsPayload = {
  readonly __typename?: 'UpdateUsersGroupsPayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly groups: GroupConnection;
  readonly users: UserConnection;
};


/** Autogenerated return type of UpdateUsersGroups. */
export type UpdateUsersGroupsPayloadGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Autogenerated return type of UpdateUsersGroups. */
export type UpdateUsersGroupsPayloadUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of UploadAttachment */
export type UploadAttachmentInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly data: Scalars['Blob']['input'];
  /** It indicates how and where the attachment is used. */
  readonly kind: AttachmentKind;
  /** The name of attachment, typically a filename. */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of UploadAttachment. */
export type UploadAttachmentPayload = {
  readonly __typename?: 'UploadAttachmentPayload';
  readonly attachment: Attachment;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UploadAttachmentWithDataUrl */
export type UploadAttachmentWithDataUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The data which encoded in Data URL scheme defined in RFC 2397 */
  readonly dataUrl: Scalars['String']['input'];
  /** It indicates how and where the attachment is used. */
  readonly kind: AttachmentKind;
  /** The name of attachment, typically a filename. */
  readonly name: Scalars['String']['input'];
};

/** Autogenerated return type of UploadAttachmentWithDataUrl. */
export type UploadAttachmentWithDataUrlPayload = {
  readonly __typename?: 'UploadAttachmentWithDataUrlPayload';
  readonly attachment: Attachment;
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** A user, which is an individual account of a team */
export type User = Node & {
  readonly __typename?: 'User';
  readonly account: Scalars['String']['output'];
  readonly avatarImage: UserAvatarImage;
  readonly biography?: Maybe<Scalars['String']['output']>;
  readonly coverImage?: Maybe<UserCoverImage>;
  /** `email` requires administrative privileges because it is a kind of personal data. */
  readonly email: Scalars['String']['output'];
  readonly groups: GroupConnection;
  readonly id: Scalars['ID']['output'];
  readonly isOptOutCollabModeStartDialog: Scalars['Boolean']['output'];
  /** User's notes sorted by createdAt desc */
  readonly latestNotes: NoteConnection;
  readonly locale: Scalars['String']['output'];
  readonly path?: Maybe<Scalars['String']['output']>;
  /** User's popular notes */
  readonly popularNotes: NoteConnection;
  /** User's draft notes */
  readonly privateNotes: NoteConnection;
  readonly realName: Scalars['String']['output'];
  /** User's notes sorted by contentUpdatedAt desc */
  readonly recentNotes: NoteConnection;
  readonly role: Role;
  readonly shortBio?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};


/** A user, which is an individual account of a team */
export type UserAvatarImageArgs = {
  density?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<UserAvatarImageSize>;
};


/** A user, which is an individual account of a team */
export type UserCoverImageArgs = {
  density?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<UserCoverImageSize>;
};


/** A user, which is an individual account of a team */
export type UserGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user, which is an individual account of a team */
export type UserLatestNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user, which is an individual account of a team */
export type UserPopularNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user, which is an individual account of a team */
export type UserPrivateNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user, which is an individual account of a team */
export type UserRecentNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An avatar image of users */
export type UserAvatarImage = {
  readonly __typename?: 'UserAvatarImage';
  readonly density: Scalars['Int']['output'];
  readonly height: Scalars['Int']['output'];
  readonly url: Scalars['String']['output'];
  readonly width: Scalars['Int']['output'];
};

/** The size class of user avatar images */
export enum UserAvatarImageSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

/** The connection type for User. */
export type UserConnection = {
  readonly __typename?: 'UserConnection';
  /** A list of edges. */
  readonly edges?: Maybe<ReadonlyArray<Maybe<UserEdge>>>;
  /** A list of nodes. */
  readonly nodes: ReadonlyArray<User>;
  /** Information to aid in pagination. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A cover image of users */
export type UserCoverImage = {
  readonly __typename?: 'UserCoverImage';
  readonly density: Scalars['Int']['output'];
  readonly height: Scalars['Int']['output'];
  readonly key: Scalars['String']['output'];
  readonly size: UserCoverImageSize;
  readonly url: Scalars['String']['output'];
  readonly width: Scalars['Int']['output'];
};

/** The size class of user cover images */
export enum UserCoverImageSize {
  Medium = 'MEDIUM',
  Original = 'ORIGINAL',
  Small = 'SMALL'
}

/** An edge in a connection. */
export type UserEdge = {
  readonly __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  readonly node?: Maybe<User>;
};

/** The kind of user last used_editor */
export enum UserLastUsedEditorKind {
  MarkdownEditor = 'MARKDOWN_EDITOR',
  RichTextEditor = 'RICH_TEXT_EDITOR'
}

/** The kind of user notification settings */
export enum UserNotificationSettingKind {
  NewsletterMail = 'NEWSLETTER_MAIL',
  ServiceNotificationWeb = 'SERVICE_NOTIFICATION_WEB'
}

/** Autogenerated input type of WatchNote */
export type WatchNoteInput = {
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly noteId: Scalars['ID']['input'];
  /** note_update or comment. */
  readonly watchedAction: WatchState;
};

/** Autogenerated return type of WatchNote. */
export type WatchNotePayload = {
  readonly __typename?: 'WatchNotePayload';
  /** A unique identifier for the client performing the mutation. */
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** State of watching note */
export enum WatchState {
  WatchComment = 'WATCH_COMMENT',
  WatchNoteUpdate = 'WATCH_NOTE_UPDATE'
}

export type AttachmentWithFilePreviewQueryVariables = Exact<{
  path: Scalars['String']['input'];
}>;


export type AttachmentWithFilePreviewQuery = { readonly __typename?: 'Query', readonly attachmentFromPath: { readonly __typename?: 'Attachment', readonly id: string, readonly key: string, readonly filePreview?: { readonly __typename?: 'AttachmentFilePreview', readonly conversionState: AttachmentFilePreviewConversionState, readonly attemptsCount: number, readonly lastPreviewedAt?: any | null, readonly asset?: { readonly __typename?: 'AttachmentFilePreviewAsset', readonly id: string, readonly width: number, readonly height: number } | null } | null } };

export type RequestAttachmentConversionMutationVariables = Exact<{
  input: RequestAttachmentConversionInput;
}>;


export type RequestAttachmentConversionMutation = { readonly __typename?: 'Mutation', readonly requestAttachmentConversion: { readonly __typename?: 'RequestAttachmentConversionPayload', readonly conversionState: AttachmentFilePreviewConversionState } };

export type FolderForIndicatorWithReadMoreFragment = { readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } };

export type SetFeedToHomeMutationVariables = Exact<{
  input: SetFeedToHomeInput;
}>;


export type SetFeedToHomeMutation = { readonly __typename?: 'Mutation', readonly setFeedToHome: { readonly __typename?: 'SetFeedToHomePayload', readonly clientMutationId?: string | null, readonly feed: FeedKindWithoutGroup } };

export type SetGroupToHomeMutationVariables = Exact<{
  input: SetGroupToHomeInput;
}>;


export type SetGroupToHomeMutation = { readonly __typename?: 'Mutation', readonly setGroupToHome: { readonly __typename?: 'SetGroupToHomePayload', readonly clientMutationId?: string | null, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly path: string } } };

export type GroupSelectorGroupFragmentFragment = { readonly __typename?: 'Group', readonly id: string, readonly name: string };

export type FetchImportableUsersQueryVariables = Exact<{
  serviceType: Scalars['String']['input'];
  teamName: Scalars['String']['input'];
  encryptedAccessToken: Scalars['String']['input'];
  page: Scalars['Int']['input'];
}>;


export type FetchImportableUsersQuery = { readonly __typename?: 'Query', readonly importableUsers: ReadonlyArray<{ readonly __typename?: 'ImportableUser', readonly account: string }> };

export type FolderForNoteHeaderFragment = { readonly __typename?: 'Folder', readonly id: string, readonly newNotePath: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } };

export type GetNoteTemplateFolderQueryVariables = Exact<{
  noteTemplateId: Scalars['ID']['input'];
}>;


export type GetNoteTemplateFolderQuery = { readonly __typename?: 'Query', readonly noteTemplate: { readonly __typename?: 'NoteTemplate', readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean }>, readonly folders: ReadonlyArray<{ readonly __typename?: 'NoteTemplateFolder', readonly id: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly id: string } }> } };

export type UpdateSaml2SsoSettingMutationVariables = Exact<{
  mode: Saml2SsoMode;
  readOnlyUserPasswordAuthnEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateSaml2SsoSettingMutation = { readonly __typename?: 'Mutation', readonly updateSaml2SsoSetting: { readonly __typename?: 'UpdateSaml2SsoSettingPayload', readonly clientMutationId?: string | null } };

export type DisableCollabModeStartDialogMutationVariables = Exact<{
  account: Scalars['String']['input'];
}>;


export type DisableCollabModeStartDialogMutation = { readonly __typename?: 'Mutation', readonly disableCollabModeStartDialog: { readonly __typename?: 'DisableCollabModeStartDialogPayload', readonly clientMutationId?: string | null } };

export type EnableCollabModeStartDialogMutationVariables = Exact<{
  account: Scalars['String']['input'];
}>;


export type EnableCollabModeStartDialogMutation = { readonly __typename?: 'Mutation', readonly enableCollabModeStartDialog: { readonly __typename?: 'EnableCollabModeStartDialogPayload', readonly clientMutationId?: string | null } };

export type UpdateUserNotificationSettingMutationVariables = Exact<{
  input: UpdateUserNotificationSettingInput;
}>;


export type UpdateUserNotificationSettingMutation = { readonly __typename?: 'Mutation', readonly updateUserNotificationSetting: { readonly __typename?: 'UpdateUserNotificationSettingPayload', readonly clientMutationId?: string | null } };

export type GetAssistantMessageQueryVariables = Exact<{
  id: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type GetAssistantMessageQuery = { readonly __typename?: 'Query', readonly assistantMessage?: { readonly __typename?: 'AssistantMessage', readonly id: string, readonly content?: string | null, readonly contentHtml?: string | null, readonly status: AssistantMessageStatus, readonly assistantReferenceDocuments: { readonly __typename?: 'AssistantReferenceDocumentConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'AssistantReferenceDocument', readonly id: string, readonly source: { readonly __typename?: 'AssistantReferenceSource', readonly id: string, readonly title: string, readonly url: string, readonly path: string, readonly type: string, readonly author: { readonly __typename?: 'User', readonly account: string, readonly path?: string | null } } }> } } | null };

export type CreateAssistantMessageMutationVariables = Exact<{
  input: CreateAssistantMessageInput;
}>;


export type CreateAssistantMessageMutation = { readonly __typename?: 'Mutation', readonly createAssistantMessage: { readonly __typename?: 'CreateAssistantMessagePayload', readonly assistantMessage: { readonly __typename?: 'AssistantMessage', readonly id: string } } };

export type UpdateCommentReplyMutationVariables = Exact<{
  input: UpdateCommentReplyInput;
}>;


export type UpdateCommentReplyMutation = { readonly __typename?: 'Mutation', readonly updateCommentReply: { readonly __typename?: 'UpdateCommentReplyPayload', readonly reply: { readonly __typename?: 'CommentReply', readonly id: string, readonly content: string, readonly contentHtml: string, readonly isEdited: boolean } } };

export type LikeCommentMutationVariables = Exact<{
  input: LikeInput;
}>;


export type LikeCommentMutation = { readonly __typename?: 'Mutation', readonly like: { readonly __typename?: 'LikePayload', readonly likers: { readonly __typename?: 'UserConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges?: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly node?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null } | null> | null } } };

export type UnlikeCommentMutationVariables = Exact<{
  input: UnlikeInput;
}>;


export type UnlikeCommentMutation = { readonly __typename?: 'Mutation', readonly unlike: { readonly __typename?: 'UnlikePayload', readonly likers: { readonly __typename?: 'UserConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges?: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly node?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null } | null> | null } } };

export type MutateReviewableDraftFragment = { readonly __typename?: 'ReviewableDraft', readonly url: string, readonly isEnabled: boolean };

export type EnableDraftReviewMutationVariables = Exact<{
  input: EnableDraftReviewInput;
}>;


export type EnableDraftReviewMutation = { readonly __typename?: 'Mutation', readonly enableDraftReview: { readonly __typename?: 'EnableDraftReviewPayload', readonly reviewableDraft: { readonly __typename?: 'ReviewableDraft', readonly url: string, readonly isEnabled: boolean } } };

export type DisableDraftReviewMutationVariables = Exact<{
  input: DisableDraftReviewInput;
}>;


export type DisableDraftReviewMutation = { readonly __typename?: 'Mutation', readonly disableDraftReview: { readonly __typename?: 'DisableDraftReviewPayload', readonly reviewableDraft: { readonly __typename?: 'ReviewableDraft', readonly url: string, readonly isEnabled: boolean } } };

export type EditorCreateNoteMutationVariables = Exact<{
  note: CreateNoteInput;
  allCount: Scalars['Int']['input'];
}>;


export type EditorCreateNoteMutation = { readonly __typename?: 'Mutation', readonly createOrUpdateNote: { readonly __typename?: 'CreateNotePayload', readonly note: { readonly __typename?: 'Note', readonly id: string, readonly databaseId: number, readonly title: string, readonly content: string, readonly coediting: boolean, readonly path: string, readonly editPath: string, readonly updatedAt: any, readonly publishedAt?: any | null, readonly reviewableDraft?: { readonly __typename?: 'ReviewableDraft', readonly url: string, readonly isEnabled: boolean } | null, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly isPrivate: boolean } }> }, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly databaseId: number, readonly name: string }> } } };

export type EditorUpdateNoteMutationVariables = Exact<{
  input: UpdateNoteInput;
  allCount: Scalars['Int']['input'];
}>;


export type EditorUpdateNoteMutation = { readonly __typename?: 'Mutation', readonly createOrUpdateNote: { readonly __typename?: 'UpdateNotePayload', readonly note: { readonly __typename?: 'Note', readonly id: string, readonly databaseId: number, readonly title: string, readonly content: string, readonly coediting: boolean, readonly path: string, readonly editPath: string, readonly updatedAt: any, readonly publishedAt?: any | null, readonly reviewableDraft?: { readonly __typename?: 'ReviewableDraft', readonly url: string, readonly isEnabled: boolean } | null, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly isPrivate: boolean } }> }, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly databaseId: number, readonly name: string }> } } };

export type MutateNoteInEditorFragment = { readonly __typename?: 'Note', readonly id: string, readonly databaseId: number, readonly title: string, readonly content: string, readonly coediting: boolean, readonly path: string, readonly editPath: string, readonly updatedAt: any, readonly publishedAt?: any | null, readonly reviewableDraft?: { readonly __typename?: 'ReviewableDraft', readonly url: string, readonly isEnabled: boolean } | null, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly isPrivate: boolean } }> }, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly databaseId: number, readonly name: string }> };

export type GetRenderMarkdownToHtmlQueryVariables = Exact<{
  content: Scalars['String']['input'];
  isMain: Scalars['Boolean']['input'];
}>;


export type GetRenderMarkdownToHtmlQuery = { readonly __typename?: 'Query', readonly renderMarkdownToHtml: string };

export type AttachNoteToFolderForEntryActionDropdownMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  folder: FolderInput;
}>;


export type AttachNoteToFolderForEntryActionDropdownMutation = { readonly __typename?: 'Mutation', readonly attachNoteToFolder: { readonly __typename?: 'AttachNoteToFolderPayload', readonly clientMutationId?: string | null } };

export type DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutationVariables = Exact<{
  input: DeleteNoteVersionInput;
}>;


export type DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation = { readonly __typename?: 'Mutation', readonly deleteNoteVersion: { readonly __typename?: 'DeleteNoteVersionPayload', readonly clientMutationId?: string | null } };

export type FolderForIndicatorFragment = { readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } };

export type FeedCreateGroupPinMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  noteId: Scalars['ID']['input'];
}>;


export type FeedCreateGroupPinMutation = { readonly __typename?: 'Mutation', readonly createGroupPin: { readonly __typename?: 'CreateGroupPinPayload', readonly group: { readonly __typename?: 'Group', readonly pinnedNotes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly coediting: boolean, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> } }> } } };

export type FeedGroupPinFragment = { readonly __typename?: 'Group', readonly pinnedNotes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly coediting: boolean, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> } }> };

export type FeedRemoveGroupPinMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  noteId: Scalars['ID']['input'];
}>;


export type FeedRemoveGroupPinMutation = { readonly __typename?: 'Mutation', readonly removeGroupPin: { readonly __typename?: 'RemoveGroupPinPayload', readonly group: { readonly __typename?: 'Group', readonly pinnedNotes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly coediting: boolean, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> } }> } } };

export type FolderContainerCreateFolderMutationVariables = Exact<{
  folder?: InputMaybe<FolderInput>;
}>;


export type FolderContainerCreateFolderMutation = { readonly __typename?: 'Mutation', readonly createFolder: { readonly __typename?: 'CreateFolderPayload', readonly foldersCacheKey: string, readonly folder: { readonly __typename?: 'Folder', readonly id: string, readonly fixedPath: string, readonly name: string, readonly fullName: string, readonly newNotePath: string, readonly lastModifiedAt?: any | null, readonly archivedAt?: any | null, readonly canBeManaged: boolean, readonly parent?: { readonly __typename?: 'Folder', readonly id: string } | null, readonly group: { readonly __typename?: 'Group', readonly id: string }, readonly components: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly totalCount: number }, readonly notes: { readonly __typename?: 'NoteConnection', readonly totalCount: number } } } };

export type FolderContainerCreateFolderPinMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  folder?: InputMaybe<FolderInput>;
  allCount: Scalars['Int']['input'];
}>;


export type FolderContainerCreateFolderPinMutation = { readonly __typename?: 'Mutation', readonly createFolderPin: { readonly __typename?: 'CreateFolderPinPayload', readonly folder: { readonly __typename?: 'Folder', readonly id: string, readonly pinnedNotes: { readonly __typename?: 'NoteConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly fixedPath: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> }, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }> }> } } } };

export type FolderContainerFolderFragmentFragment = { readonly __typename?: 'Folder', readonly id: string, readonly fixedPath: string, readonly name: string, readonly fullName: string, readonly newNotePath: string, readonly lastModifiedAt?: any | null, readonly archivedAt?: any | null, readonly canBeManaged: boolean, readonly parent?: { readonly __typename?: 'Folder', readonly id: string } | null, readonly group: { readonly __typename?: 'Group', readonly id: string }, readonly components: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly totalCount: number }, readonly notes: { readonly __typename?: 'NoteConnection', readonly totalCount: number } };

export type GetDescendantNotesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDescendantNotesQuery = { readonly __typename?: 'Query', readonly folder: { readonly __typename?: 'Folder', readonly unarchivableDescendantNoteTitles: ReadonlyArray<string>, readonly descendantNotes: { readonly __typename?: 'NoteConnection', readonly totalCount: number }, readonly unarchivableDescendantNotes: { readonly __typename?: 'NoteConnection', readonly totalCount: number } } };

export type FolderContainerGetFoldersBySelectedNotesQueryVariables = Exact<{
  noteIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
  allCount: Scalars['Int']['input'];
}>;


export type FolderContainerGetFoldersBySelectedNotesQuery = { readonly __typename?: 'Query', readonly nodes: ReadonlyArray<{ readonly __typename?: 'AccessToken' } | { readonly __typename?: 'AccessTokenLog' } | { readonly __typename?: 'AssistantReferenceDocument' } | { readonly __typename?: 'AssistantReferenceSource' } | { readonly __typename?: 'Attachment' } | { readonly __typename?: 'AttachmentFilePreview' } | { readonly __typename?: 'AttachmentFilePreviewAsset' } | { readonly __typename?: 'CoeditRoom' } | { readonly __typename?: 'Comment' } | { readonly __typename?: 'CommentReply' } | { readonly __typename?: 'CustomEmoji' } | { readonly __typename?: 'Dashboard' } | { readonly __typename?: 'Folder' } | { readonly __typename?: 'Group' } | { readonly __typename?: 'Note', readonly id: string, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fixedPath: string, readonly name: string, readonly fullName: string, readonly newNotePath: string, readonly lastModifiedAt?: any | null, readonly archivedAt?: any | null, readonly canBeManaged: boolean, readonly parent?: { readonly __typename?: 'Folder', readonly id: string } | null, readonly group: { readonly __typename?: 'Group', readonly id: string }, readonly components: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly totalCount: number }, readonly notes: { readonly __typename?: 'NoteConnection', readonly totalCount: number } }> } } | { readonly __typename?: 'NoteBrowsingHistory' } | { readonly __typename?: 'NoteTemplate' } | { readonly __typename?: 'NoteTemplateFolder' } | { readonly __typename?: 'Notification' } | { readonly __typename?: 'OutgoingWebhook' } | { readonly __typename?: 'ReviewableDraftComment' } | { readonly __typename?: 'ServiceNotification' } | { readonly __typename?: 'SharedNote' } | { readonly __typename?: 'User' } | null> };

export type FolderContainerGetInitialFolderQueryVariables = Exact<{
  folderId: Scalars['ID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  foldersPerPage: Scalars['Int']['input'];
  allCount: Scalars['Int']['input'];
}>;


export type FolderContainerGetInitialFolderQuery = { readonly __typename?: 'Query', readonly folder: { readonly __typename?: 'Folder', readonly id: string, readonly fixedPath: string, readonly name: string, readonly fullName: string, readonly newNotePath: string, readonly lastModifiedAt?: any | null, readonly archivedAt?: any | null, readonly canBeManaged: boolean, readonly parent?: { readonly __typename?: 'Folder', readonly id: string } | null, readonly components: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string }>, readonly notes: { readonly __typename?: 'NoteConnection', readonly totalCount: number }, readonly pinnedNotes: { readonly __typename?: 'NoteConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly fixedPath: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> }, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }> }> }, readonly folders: { readonly __typename?: 'FolderConnection', readonly totalCount: number, readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fixedPath: string, readonly name: string, readonly fullName: string, readonly newNotePath: string, readonly lastModifiedAt?: any | null, readonly archivedAt?: any | null, readonly canBeManaged: boolean, readonly parent?: { readonly __typename?: 'Folder', readonly id: string } | null, readonly group: { readonly __typename?: 'Group', readonly id: string }, readonly components: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly totalCount: number }, readonly notes: { readonly __typename?: 'NoteConnection', readonly totalCount: number } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean } } } };

export type FolderContainerGetNotAttachedNotesQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy: NoteOrder;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FolderContainerGetNotAttachedNotesQuery = { readonly __typename?: 'Query', readonly group: { readonly __typename?: 'Group', readonly id: string, readonly notes: { readonly __typename?: 'NoteConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly editPath: string, readonly canBeUpdated: boolean, readonly canBeArchived: boolean, readonly contentUpdatedAt: any, readonly coediting: boolean, readonly isArchived: boolean, readonly isLikedByCurrentUser: boolean, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly isPrivate: boolean, readonly isArchived: boolean, readonly path: string }>, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly likers: { readonly __typename?: 'UserConnection', readonly totalCount: number }, readonly comments: { readonly __typename?: 'CommentConnection', readonly totalCount: number }, readonly sharedNote?: { readonly __typename?: 'SharedNote', readonly id: string } | null }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean } } } };

export type FolderContainerGetNoteFoldersQueryVariables = Exact<{
  noteId: Scalars['ID']['input'];
  allCount: Scalars['Int']['input'];
}>;


export type FolderContainerGetNoteFoldersQuery = { readonly __typename?: 'Query', readonly note: { readonly __typename?: 'Note', readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fixedPath: string, readonly name: string, readonly fullName: string, readonly newNotePath: string, readonly lastModifiedAt?: any | null, readonly archivedAt?: any | null, readonly canBeManaged: boolean, readonly parent?: { readonly __typename?: 'Folder', readonly id: string } | null, readonly group: { readonly __typename?: 'Group', readonly id: string }, readonly components: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly totalCount: number }, readonly notes: { readonly __typename?: 'NoteConnection', readonly totalCount: number } }> } } };

export type FolderContainerGetNotesInFolderQueryVariables = Exact<{
  folderId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy: NoteOrder;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FolderContainerGetNotesInFolderQuery = { readonly __typename?: 'Query', readonly folder: { readonly __typename?: 'Folder', readonly id: string, readonly notes: { readonly __typename?: 'NoteConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly editPath: string, readonly canBeUpdated: boolean, readonly canBeArchived: boolean, readonly contentUpdatedAt: any, readonly coediting: boolean, readonly isArchived: boolean, readonly isLikedByCurrentUser: boolean, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly isPrivate: boolean, readonly isArchived: boolean, readonly path: string }>, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly likers: { readonly __typename?: 'UserConnection', readonly totalCount: number }, readonly comments: { readonly __typename?: 'CommentConnection', readonly totalCount: number }, readonly sharedNote?: { readonly __typename?: 'SharedNote', readonly id: string } | null }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean } } } };

export type FolderContainerGetRootFoldersQueryVariables = Exact<{
  groupId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FolderContainerGetRootFoldersQuery = { readonly __typename?: 'Query', readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly isJoined: boolean, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fixedPath: string, readonly name: string, readonly fullName: string, readonly newNotePath: string, readonly lastModifiedAt?: any | null, readonly archivedAt?: any | null, readonly canBeManaged: boolean, readonly parent?: { readonly __typename?: 'Folder', readonly id: string } | null, readonly group: { readonly __typename?: 'Group', readonly id: string }, readonly components: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly totalCount: number }, readonly notes: { readonly __typename?: 'NoteConnection', readonly totalCount: number } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean } } } };

export type FolderContainerNotesFragmentFragment = { readonly __typename?: 'NoteConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly editPath: string, readonly canBeUpdated: boolean, readonly canBeArchived: boolean, readonly contentUpdatedAt: any, readonly coediting: boolean, readonly isArchived: boolean, readonly isLikedByCurrentUser: boolean, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly isPrivate: boolean, readonly isArchived: boolean, readonly path: string }>, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly likers: { readonly __typename?: 'UserConnection', readonly totalCount: number }, readonly comments: { readonly __typename?: 'CommentConnection', readonly totalCount: number }, readonly sharedNote?: { readonly __typename?: 'SharedNote', readonly id: string } | null }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean } };

export type FolderContainerPinnedNotesFragmentFragment = { readonly __typename?: 'NoteConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly fixedPath: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> }, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }> }> };

export type FolderContainerRemoveFolderPinMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  folder?: InputMaybe<FolderInput>;
  allCount: Scalars['Int']['input'];
}>;


export type FolderContainerRemoveFolderPinMutation = { readonly __typename?: 'Mutation', readonly removeFolderPin: { readonly __typename?: 'RemoveFolderPinPayload', readonly folder: { readonly __typename?: 'Folder', readonly id: string, readonly pinnedNotes: { readonly __typename?: 'NoteConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly fixedPath: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> }, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }> }> } } } };

export type FolderContainerUpdateFolderNameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type FolderContainerUpdateFolderNameMutation = { readonly __typename?: 'Mutation', readonly updateFolderName: { readonly __typename?: 'UpdateFolderNamePayload', readonly foldersCacheKey: string, readonly folder: { readonly __typename?: 'Folder', readonly id: string, readonly path: string, readonly name: string, readonly fullName: string, readonly components: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string }> } } };

export type FolderContainerUpdateFolderParentMutationVariables = Exact<{
  folderId: Scalars['ID']['input'];
  folderFullName?: InputMaybe<Scalars['String']['input']>;
}>;


export type FolderContainerUpdateFolderParentMutation = { readonly __typename?: 'Mutation', readonly updateFolderParent: { readonly __typename?: 'UpdateFolderParentPayload', readonly foldersCacheKey: string, readonly folder: { readonly __typename?: 'Folder', readonly parent?: { readonly __typename?: 'Folder', readonly id: string } | null, readonly group: { readonly __typename?: 'Group', readonly id: string } } } };

export type FolderSelectedItemActionBoxArchiveFoldersMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FolderSelectedItemActionBoxArchiveFoldersMutation = { readonly __typename?: 'Mutation', readonly archiveFolders: { readonly __typename?: 'ArchiveFoldersPayload', readonly foldersCacheKey: string, readonly folders: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly archivedAt?: any | null }> } };

export type FolderSelectedItemActionBoxArchiveNotesMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FolderSelectedItemActionBoxArchiveNotesMutation = { readonly __typename?: 'Mutation', readonly archiveNotes: { readonly __typename?: 'ArchiveNotesPayload', readonly notes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly isArchived: boolean }> } };

export type FolderSelectedItemActionBoxValidateToMoveQueryVariables = Exact<{
  parentId?: InputMaybe<Scalars['ID']['input']>;
  folderIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type FolderSelectedItemActionBoxValidateToMoveQuery = { readonly __typename?: 'Query', readonly validateToMove: boolean };

export type GroupListContainerJoinGroupMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GroupListContainerJoinGroupMutation = { readonly __typename?: 'Mutation', readonly joinGroup: { readonly __typename?: 'JoinGroupPayload', readonly clientMutationId?: string | null, readonly group: { readonly __typename?: 'Group', readonly canBeManaged: boolean } } };

export type GroupListContainerLeaveGroupMutationVariables = Exact<{
  groupId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GroupListContainerLeaveGroupMutation = { readonly __typename?: 'Mutation', readonly leaveGroup: { readonly __typename?: 'LeaveGroupPayload', readonly clientMutationId?: string | null, readonly group: { readonly __typename?: 'Group', readonly canBeManaged: boolean, readonly canBeJoined: boolean } } };

export type UserListInManageMembersDisableUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserListInManageMembersDisableUserMutation = { readonly __typename?: 'Mutation', readonly disableUser: { readonly __typename?: 'DisableUserPayload', readonly clientMutationId?: string | null } };

export type DisableUsersMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DisableUsersMutation = { readonly __typename?: 'Mutation', readonly disableUsers: { readonly __typename?: 'DisableUsersPayload', readonly clientMutationId?: string | null } };

export type UserListInManageMembersIgnoreMfaMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserListInManageMembersIgnoreMfaMutation = { readonly __typename?: 'Mutation', readonly ignoreMultiFactorAuthn: { readonly __typename?: 'IgnoreMultiFactorAuthnPayload', readonly clientMutationId?: string | null } };

export type IgnoreMfaForMultipleUsersMutationVariables = Exact<{
  ids: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type IgnoreMfaForMultipleUsersMutation = { readonly __typename?: 'Mutation', readonly ignoreMultiFactorAuthnForMultipleUsers: { readonly __typename?: 'IgnoreMultiFactorAuthnForMultipleUsersPayload', readonly clientMutationId?: string | null } };

export type ArchiveNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveNoteMutation = { readonly __typename?: 'Mutation', readonly archiveNote: { readonly __typename?: 'ArchiveNotePayload', readonly clientMutationId?: string | null } };

export type NoteContainerCollabModeDataQueryVariables = Exact<{
  noteId: Scalars['ID']['input'];
  allCount: Scalars['Int']['input'];
}>;


export type NoteContainerCollabModeDataQuery = { readonly __typename?: 'Query', readonly collabModeData?: { readonly __typename?: 'CollabModeData', readonly title: string, readonly content: string, readonly contentHtml: string, readonly contentTocHtml: string, readonly publishPlacesChanged: boolean, readonly memberCount: number, readonly groups?: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isJoined: boolean, readonly isArchived: boolean }> | null, readonly folders?: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly newNotePath: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> } | null } | null };

export type GetNoteForNoteContainerQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  allCount: Scalars['Int']['input'];
}>;


export type GetNoteForNoteContainerQuery = { readonly __typename?: 'Query', readonly note: { readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly content: string, readonly contentHtml: string, readonly contentTocHtml: string, readonly publishedAt?: any | null, readonly contentUpdatedAt: any, readonly isArchived: boolean, readonly canBeLiked: boolean, readonly isLikedByCurrentUser: boolean, readonly canBeUpdated: boolean, readonly hasCollabHistory: boolean, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isJoined: boolean, readonly isArchived: boolean }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly newNotePath: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> }, readonly selectableGroups: { readonly __typename?: 'GroupConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean }> }, readonly contributors: { readonly __typename?: 'UserConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly node?: { readonly __typename?: 'User', readonly id: string, readonly path?: string | null, readonly account: string, readonly realName: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null } | null> | null }, readonly likers: { readonly __typename?: 'UserConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly node?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null } | null> | null }, readonly coeditRoom?: { readonly __typename?: 'CoeditRoom', readonly activeUserAccounts: ReadonlyArray<string> } | null } };

export type UpdateNoteContentForTaskListMutationVariables = Exact<{
  input: UpdateNoteContentInput;
}>;


export type UpdateNoteContentForTaskListMutation = { readonly __typename?: 'Mutation', readonly updateNoteContent: { readonly __typename?: 'UpdateNoteContentPayload', readonly note: { readonly __typename?: 'Note', readonly content: string, readonly contentHtml: string } } };

export type GetRelatedNotesQueryVariables = Exact<{
  noteId: Scalars['ID']['input'];
  trackbackNoteCount: Scalars['Int']['input'];
  lastTrackbackNote?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRelatedNotesQuery = { readonly __typename?: 'Query', readonly note: { readonly __typename?: 'Note', readonly id: string, readonly relatedNotes: { readonly __typename?: 'SearchResultConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'SearchResult', readonly title: string, readonly path: string, readonly author: { readonly __typename?: 'User', readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } }, readonly document: { readonly __typename?: 'Comment' } | { readonly __typename?: 'CommentReply' } | { readonly __typename?: 'Note', readonly id: string, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> } } }> }, readonly trackbackNotes: { readonly __typename?: 'NoteConnection', readonly totalCount: number, readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean } } } };

export type GetTrackbackNotesQueryVariables = Exact<{
  noteId: Scalars['ID']['input'];
  trackbackNoteCount: Scalars['Int']['input'];
  lastTrackbackNote: Scalars['String']['input'];
}>;


export type GetTrackbackNotesQuery = { readonly __typename?: 'Query', readonly note: { readonly __typename?: 'Note', readonly id: string, readonly trackbackNotes: { readonly __typename?: 'NoteConnection', readonly totalCount: number, readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean } } } };

export type TrackbackNoteForRelatedNoteContainerFragment = { readonly __typename?: 'Note', readonly id: string, readonly trackbackNotes: { readonly __typename?: 'NoteConnection', readonly totalCount: number, readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string, readonly author?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean }>, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly path: string, readonly isPrivate: boolean, readonly isArchived: boolean } }> } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean } } };

export type RestoreNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RestoreNoteMutation = { readonly __typename?: 'Mutation', readonly restoreNote: { readonly __typename?: 'RestoreNotePayload', readonly clientMutationId?: string | null } };

export type ListServiceNotificationsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type ListServiceNotificationsQuery = { readonly __typename?: 'Query', readonly serviceNotifications: { readonly __typename?: 'ServiceNotificationConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'ServiceNotification', readonly id: string, readonly titleJa: string, readonly titleEn?: string | null, readonly messageJa: string, readonly messageEn?: string | null, readonly urlJa?: string | null, readonly urlEn?: string | null, readonly notificationKind: ServiceNotificationKind, readonly read: boolean, readonly startAt: any }> } };

export type MarkServiceNotificationAsReadMutationVariables = Exact<{
  serviceNotificationIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkServiceNotificationAsReadMutation = { readonly __typename?: 'Mutation', readonly markServiceNotificationsAsRead: { readonly __typename?: 'MarkServiceNotificationsAsReadPayload', readonly clientMutationId?: string | null } };

export type GetCoeditTokenQueryVariables = Exact<{
  noteId: Scalars['ID']['input'];
}>;


export type GetCoeditTokenQuery = { readonly __typename?: 'Query', readonly coeditToken: string };

export type GetExternalUrlDataQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type GetExternalUrlDataQuery = { readonly __typename?: 'Query', readonly externalUrlData: { readonly __typename?: 'ExternalUrlData', readonly title?: string | null, readonly description?: string | null, readonly favicon?: string | null, readonly og?: { readonly __typename?: 'OpenGraph', readonly title?: string | null, readonly description?: string | null, readonly url?: string | null, readonly image?: { readonly __typename?: 'OpenGraphImage', readonly url?: string | null, readonly secureUrl?: string | null, readonly alt?: string | null, readonly width?: number | null, readonly height?: number | null } | null } | null } };

export type GetInternalUrlDataQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type GetInternalUrlDataQuery = { readonly __typename?: 'Query', readonly internalUrlData?: { readonly __typename?: 'InternalUrlData', readonly title: string, readonly linkType: string, readonly isCoediting: boolean, readonly avatar1xUrl?: string | null, readonly avatar2xUrl?: string | null } | null };

export type GetSearchMemberResultQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetSearchMemberResultQuery = { readonly __typename?: 'Query', readonly users: { readonly __typename?: 'UserConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly node?: { readonly __typename?: 'User', readonly account: string, readonly realName: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null } | null> | null } };

export type GetSearchResultQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetSearchResultQuery = { readonly __typename?: 'Query', readonly search: { readonly __typename?: 'SearchResultConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'SearchResultEdge', readonly node?: { readonly __typename?: 'SearchResult', readonly path: string, readonly titleHtml: string, readonly contentUpdatedAt: any, readonly contributors: { readonly __typename?: 'UserConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly node?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null } | null> | null }, readonly document: { readonly __typename: 'Comment' } | { readonly __typename: 'CommentReply' } | { readonly __typename: 'Note' } } | null } | null> | null } };

export type GetNoteBrowsingHistoryQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type GetNoteBrowsingHistoryQuery = { readonly __typename?: 'Query', readonly noteBrowsingHistories: { readonly __typename?: 'NoteBrowsingHistoryConnection', readonly edges?: ReadonlyArray<{ readonly __typename?: 'NoteBrowsingHistoryEdge', readonly node?: { readonly __typename?: 'NoteBrowsingHistory', readonly note?: { readonly __typename?: 'Note', readonly path: string, readonly title: string, readonly contributors: { readonly __typename?: 'UserConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly node?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null } | null> | null } } | null } | null } | null> | null } };

export type CreateSearchFilterSetMutationVariables = Exact<{
  input: CreateSearchFilterSetInput;
}>;


export type CreateSearchFilterSetMutation = { readonly __typename?: 'Mutation', readonly createSearchFilterSet: { readonly __typename?: 'CreateSearchFilterSetPayload', readonly clientMutationId?: string | null } };

export type GetSearchFilterSetsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
}>;


export type GetSearchFilterSetsQuery = { readonly __typename?: 'Query', readonly searchFilterSets: { readonly __typename?: 'SearchFilterSetConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'SearchFilterSetEdge', readonly node?: { readonly __typename?: 'SearchFilterSet', readonly id: string, readonly excludeKeywords: ReadonlyArray<string>, readonly dateGte?: string | null, readonly isLikedByMe: boolean, readonly resourceTypes: ReadonlyArray<string>, readonly isArchived: boolean, readonly authorUsers: ReadonlyArray<{ readonly __typename?: 'User', readonly account: string }>, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly databaseId: number, readonly name: string, readonly isPrivate: boolean }>, readonly folders: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly databaseId: number } }> } | null } | null> | null } };

export type DeleteSearchFilterSetMutationVariables = Exact<{
  input: DeleteSearchFilterSetInput;
}>;


export type DeleteSearchFilterSetMutation = { readonly __typename?: 'Mutation', readonly deleteSearchFilterSet: { readonly __typename?: 'DeleteSearchFilterSetPayload', readonly clientMutationId?: string | null } };

export type GetSearchFolderResultQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetSearchFolderResultQuery = { readonly __typename?: 'Query', readonly searchFolder: { readonly __typename?: 'SearchFolderResultConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'SearchFolderResultEdge', readonly node?: { readonly __typename?: 'SearchFolderResult', readonly name: string, readonly fixedPath: string, readonly group: { readonly __typename?: 'Group', readonly path: string, readonly name: string, readonly isPrivate: boolean } } | null } | null> | null } };

export type GetSearchHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSearchHistoryQuery = { readonly __typename?: 'Query', readonly searchHistory: { readonly __typename?: 'SearchHistory', readonly entries: ReadonlyArray<{ readonly __typename?: 'SearchHistoryEntry', readonly id: string, readonly hasCustomFilterSet: boolean, readonly keywords: ReadonlyArray<string>, readonly excludeKeywords: ReadonlyArray<string>, readonly dateGte?: string | null, readonly isLikedByMe: boolean, readonly resourceTypes: ReadonlyArray<string>, readonly isArchived: boolean, readonly authorUsers: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly account: string }>, readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly databaseId: number, readonly name: string, readonly isPrivate: boolean }>, readonly folders: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly fullName: string, readonly group: { readonly __typename?: 'Group', readonly databaseId: number } }> }> } };

export type DeleteSearchHistoryEntryMutationVariables = Exact<{
  input: DeleteSearchHistoryEntryInput;
}>;


export type DeleteSearchHistoryEntryMutation = { readonly __typename?: 'Mutation', readonly deleteSearchHistoryEntry: { readonly __typename?: 'DeleteSearchHistoryEntryPayload', readonly clientMutationId?: string | null } };

export type ShareMenuShareNoteWithOutsideOfTeamMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
}>;


export type ShareMenuShareNoteWithOutsideOfTeamMutation = { readonly __typename?: 'Mutation', readonly shareNoteWithOutsideOfTeam: { readonly __typename?: 'ShareNoteWithOutsideOfTeamPayload', readonly note: { readonly __typename?: 'Note', readonly id: string, readonly sharedNote?: { readonly __typename?: 'SharedNote', readonly id: string, readonly url: string } | null } } };

export type ShareMenuUnshareNoteWithOutsideOfTeamMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
}>;


export type ShareMenuUnshareNoteWithOutsideOfTeamMutation = { readonly __typename?: 'Mutation', readonly unshareNoteWithOutsideOfTeam: { readonly __typename?: 'UnshareNoteWithOutsideOfTeamPayload', readonly clientMutationId?: string | null } };

export type GetCurrentUserGroupsQueryVariables = Exact<{
  allCount: Scalars['Int']['input'];
}>;


export type GetCurrentUserGroupsQuery = { readonly __typename?: 'Query', readonly currentUser: { readonly __typename?: 'User', readonly id: string, readonly groups: { readonly __typename?: 'GroupConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string }> } } };

export type UpdateUsersGroupsMutationVariables = Exact<{
  input: UpdateUsersGroupsInput;
}>;


export type UpdateUsersGroupsMutation = { readonly __typename?: 'Mutation', readonly updateUsersGroups: { readonly __typename?: 'UpdateUsersGroupsPayload', readonly clientMutationId?: string | null } };

export type UserAvatarQueryFragmentFragment = { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } };

export type UserAvatarWithPopupQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserAvatarWithPopupQuery = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly path?: string | null, readonly account: string, readonly realName: string, readonly shortBio?: string | null, readonly coverImage?: { readonly __typename?: 'UserCoverImage', readonly url: string } | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly popularNotes: { readonly __typename?: 'NoteConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string }> } } };

export type UserAvatarsQueryFragmentFragment = { readonly __typename?: 'UserConnection', readonly totalCount: number, readonly edges?: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly node?: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } | null } | null> | null };

export type ProfilePopupUserFragment = { readonly __typename?: 'User', readonly id: string, readonly path?: string | null, readonly account: string, readonly realName: string, readonly shortBio?: string | null, readonly coverImage?: { readonly __typename?: 'UserCoverImage', readonly url: string } | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly popularNotes: { readonly __typename?: 'NoteConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title: string, readonly path: string }> } };

export type EditorContainerCoeditorAvatarsQueryVariables = Exact<{
  accounts: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
  allCount: Scalars['Int']['input'];
}>;


export type EditorContainerCoeditorAvatarsQuery = { readonly __typename?: 'Query', readonly usersFromAccounts: { readonly __typename?: 'UserConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'User', readonly realName: string, readonly id: string, readonly account: string, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } }> } };

export type CustomEmojiFragmentFragment = { readonly __typename?: 'CustomEmoji', readonly id: string, readonly emojiCode: string, readonly imageUrl: string, readonly createdAt: any, readonly createUser: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } };

export type CreateCustomEmojiMutationVariables = Exact<{
  input: CreateCustomEmojiInput;
}>;


export type CreateCustomEmojiMutation = { readonly __typename?: 'Mutation', readonly createCustomEmoji: { readonly __typename?: 'CreateCustomEmojiPayload', readonly customEmoji: { readonly __typename?: 'CustomEmoji', readonly id: string, readonly emojiCode: string, readonly imageUrl: string, readonly createdAt: any, readonly createUser: { readonly __typename?: 'User', readonly id: string, readonly account: string, readonly path?: string | null, readonly avatar1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatar2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } } } };

export type DeleteCustomEmojiMutationVariables = Exact<{
  input: DeleteCustomEmojiInput;
}>;


export type DeleteCustomEmojiMutation = { readonly __typename?: 'Mutation', readonly deleteCustomEmoji: { readonly __typename?: 'DeleteCustomEmojiPayload', readonly clientMutationId?: string | null } };

export type InviteMutationVariables = Exact<{
  email: Scalars['String']['input'];
  role: Role;
  message: Scalars['String']['input'];
  groupIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type InviteMutation = { readonly __typename?: 'Mutation', readonly invite: { readonly __typename?: 'InvitePayload', readonly email: string, readonly hint: InvitationHint } };

export type GetNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsQuery = { readonly __typename?: 'Query', readonly notifications: { readonly __typename?: 'NotificationConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Notification', readonly id: string, readonly state: NotificationState, readonly messageHtml: string, readonly sourcePath: string, readonly updatedAt: any, readonly sender: { readonly __typename?: 'User', readonly account: string, readonly avatarSrc1x: { readonly __typename?: 'UserAvatarImage', readonly url: string }, readonly avatarSrc2x: { readonly __typename?: 'UserAvatarImage', readonly url: string } } }> } };

export type GetUnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadNotificationsCountQuery = { readonly __typename?: 'Query', readonly notifications: { readonly __typename?: 'NotificationConnection', readonly totalCount: number } };

export type MarkNotificationsAsReadMutationVariables = Exact<{ [key: string]: never; }>;


export type MarkNotificationsAsReadMutation = { readonly __typename?: 'Mutation', readonly markNotificationsAsRead: { readonly __typename?: 'MarkNotificationsAsReadPayload', readonly clientMutationId?: string | null } };

export type AttachNoteToFolderMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  folder: FolderInput;
}>;


export type AttachNoteToFolderMutation = { readonly __typename?: 'Mutation', readonly attachNoteToFolder: { readonly __typename?: 'AttachNoteToFolderPayload', readonly attachedFolder: { readonly __typename?: 'Folder', readonly id: string } } };

export type DeleteNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNoteMutation = { readonly __typename?: 'Mutation', readonly deleteNote: { readonly __typename?: 'DeleteNotePayload', readonly clientMutationId?: string | null } };

export type DetachNoteFromFolderMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  folder: FolderInput;
}>;


export type DetachNoteFromFolderMutation = { readonly __typename?: 'Mutation', readonly detachNoteFromFolder: { readonly __typename?: 'DetachNoteFromFolderPayload', readonly detachedFolder: { readonly __typename?: 'Folder', readonly id: string } } };

export type LeaveGroupMutationVariables = Exact<{
  input: LeaveGroupInput;
}>;


export type LeaveGroupMutation = { readonly __typename?: 'Mutation', readonly leaveGroup: { readonly __typename?: 'LeaveGroupPayload', readonly clientMutationId?: string | null } };

export type MoveNoteToAnotherFolderMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  fromFolder: FolderInput;
  toFolder: FolderInput;
}>;


export type MoveNoteToAnotherFolderMutation = { readonly __typename?: 'Mutation', readonly moveNoteToAnotherFolder: { readonly __typename?: 'MoveNoteToAnotherFolderPayload', readonly beforeFolder?: { readonly __typename?: 'Folder', readonly id: string } | null, readonly afterFolder: { readonly __typename?: 'Folder', readonly id: string } } };

export type MoveNoteToAnotherGroupMutationVariables = Exact<{
  noteId: Scalars['ID']['input'];
  fromGroupId: Scalars['ID']['input'];
  fromFolderId?: InputMaybe<Scalars['ID']['input']>;
  toGroupId: Scalars['ID']['input'];
}>;


export type MoveNoteToAnotherGroupMutation = { readonly __typename?: 'Mutation', readonly moveNoteToAnotherGroup: { readonly __typename?: 'MoveNoteToAnotherGroupPayload', readonly note: { readonly __typename?: 'Note', readonly id: string } } };

export type SyncUserLastUsedEditorMutationVariables = Exact<{
  input: SyncUserLastUsedEditorInput;
}>;


export type SyncUserLastUsedEditorMutation = { readonly __typename?: 'Mutation', readonly syncUserLastUsedEditor: { readonly __typename?: 'SyncUserLastUsedEditorPayload', readonly clientMutationId?: string | null } };

export type EnableSharedNoteCommentsFeatureMutationVariables = Exact<{ [key: string]: never; }>;


export type EnableSharedNoteCommentsFeatureMutation = { readonly __typename?: 'Mutation', readonly enableSharedNoteCommentsFeature: { readonly __typename?: 'EnableSharedNoteCommentsFeaturePayload', readonly clientMutationId?: string | null } };

export type DisableSharedNoteCommentsFeatureMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableSharedNoteCommentsFeatureMutation = { readonly __typename?: 'Mutation', readonly disableSharedNoteCommentsFeature: { readonly __typename?: 'DisableSharedNoteCommentsFeaturePayload', readonly clientMutationId?: string | null } };

export type EnableSharedNotesFeatureMutationVariables = Exact<{ [key: string]: never; }>;


export type EnableSharedNotesFeatureMutation = { readonly __typename?: 'Mutation', readonly enableSharedNotesFeature: { readonly __typename?: 'EnableSharedNotesFeaturePayload', readonly clientMutationId?: string | null } };

export type DisableSharedNotesFeatureMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableSharedNotesFeatureMutation = { readonly __typename?: 'Mutation', readonly disableSharedNotesFeature: { readonly __typename?: 'DisableSharedNotesFeaturePayload', readonly clientMutationId?: string | null } };

export type FetchCustomEmojisQueryVariables = Exact<{
  allCount: Scalars['Int']['input'];
}>;


export type FetchCustomEmojisQuery = { readonly __typename?: 'Query', readonly customEmojisCacheKey: string, readonly customEmojis: { readonly __typename?: 'CustomEmojiConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'CustomEmoji', readonly name: string, readonly src: string }> } };

export type GetFoldersForTreeQueryVariables = Exact<{
  allCount: Scalars['Int']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type GetFoldersForTreeQuery = { readonly __typename?: 'Query', readonly foldersCacheKey: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string, readonly fullName: string }> } } };

export type GetRootWithChildrenFoldersForTreeQueryVariables = Exact<{
  allCount: Scalars['Int']['input'];
  groupId: Scalars['ID']['input'];
}>;


export type GetRootWithChildrenFoldersForTreeQuery = { readonly __typename?: 'Query', readonly foldersCacheKey: string, readonly group: { readonly __typename?: 'Group', readonly id: string, readonly folders: { readonly __typename?: 'FolderConnection', readonly nodes: ReadonlyArray<{ readonly __typename?: 'Folder', readonly id: string, readonly name: string, readonly fullName: string }> } } };

export const FolderForIndicatorFragmentDoc = gql`
    fragment FolderForIndicator on Folder {
  id
  fullName
  fixedPath
  group {
    id
    name
    path
    isPrivate
    isArchived
  }
}
    `;
export const FolderForIndicatorWithReadMoreFragmentDoc = gql`
    fragment FolderForIndicatorWithReadMore on Folder {
  ...FolderForIndicator
  group {
    id
  }
}
    ${FolderForIndicatorFragmentDoc}`;
export const GroupSelectorGroupFragmentFragmentDoc = gql`
    fragment GroupSelectorGroupFragment on Group {
  id
  name
}
    `;
export const FolderForNoteHeaderFragmentDoc = gql`
    fragment FolderForNoteHeader on Folder {
  id
  newNotePath
  ...FolderForIndicator
  group {
    id
  }
}
    ${FolderForIndicatorFragmentDoc}`;
export const MutateReviewableDraftFragmentDoc = gql`
    fragment MutateReviewableDraft on ReviewableDraft {
  url
  isEnabled
}
    `;
export const MutateNoteInEditorFragmentDoc = gql`
    fragment MutateNoteInEditor on Note {
  id
  databaseId
  title
  content
  coediting
  path
  editPath
  updatedAt
  publishedAt
  reviewableDraft {
    url
    isEnabled
  }
  folders(first: $allCount) {
    nodes {
      id
      fullName
      group {
        id
        name
        isPrivate
      }
    }
  }
  groups {
    id
    databaseId
    name
  }
}
    `;
export const FeedGroupPinFragmentDoc = gql`
    fragment FeedGroupPin on Group {
  pinnedNotes {
    id
    title
    path
    coediting
    groups {
      id
      name
      path
      isPrivate
      isArchived
    }
    folders(first: 10) {
      nodes {
        ...FolderForIndicator
      }
    }
  }
}
    ${FolderForIndicatorFragmentDoc}`;
export const FolderContainerFolderFragmentFragmentDoc = gql`
    fragment FolderContainerFolderFragment on Folder {
  id
  fixedPath
  name
  fullName
  newNotePath
  lastModifiedAt
  archivedAt
  canBeManaged
  parent {
    id
  }
  group {
    id
  }
  components {
    id
    name
  }
  folders {
    totalCount
  }
  notes {
    totalCount
  }
}
    `;
export const FolderContainerNotesFragmentFragmentDoc = gql`
    fragment FolderContainerNotesFragment on NoteConnection {
  nodes {
    id
    title
    path
    editPath
    canBeUpdated
    canBeArchived
    contentUpdatedAt
    coediting
    isArchived
    isLikedByCurrentUser
    groups {
      id
      name
      isPrivate
      isArchived
      path
    }
    author {
      id
      account
      path
      avatar1x: avatarImage(size: SMALL, density: 1) {
        url
      }
      avatar2x: avatarImage(size: SMALL, density: 2) {
        url
      }
    }
    likers {
      totalCount
    }
    comments {
      totalCount
    }
    sharedNote {
      id
    }
  }
  pageInfo {
    endCursor
    hasNextPage
  }
}
    `;
export const FolderContainerPinnedNotesFragmentFragmentDoc = gql`
    fragment FolderContainerPinnedNotesFragment on NoteConnection {
  nodes {
    id
    title
    path
    author {
      id
      account
      path
      avatar1x: avatarImage(size: SMALL, density: 1) {
        url
      }
      avatar2x: avatarImage(size: SMALL, density: 2) {
        url
      }
    }
    folders(first: 10) {
      nodes {
        fixedPath
        fullName
        group {
          id
          name
          path
          isPrivate
          isArchived
        }
      }
    }
    groups {
      id
      name
      path
      isPrivate
      isArchived
    }
  }
}
    `;
export const TrackbackNoteForRelatedNoteContainerFragmentDoc = gql`
    fragment TrackbackNoteForRelatedNoteContainer on Note {
  id
  trackbackNotes(first: $trackbackNoteCount, after: $lastTrackbackNote) {
    nodes {
      id
      title
      path
      author {
        id
        account
        path
        avatar1x: avatarImage(size: SMALL, density: 1) {
          url
        }
        avatar2x: avatarImage(size: SMALL, density: 2) {
          url
        }
      }
      groups {
        id
        name
        path
        isPrivate
        isArchived
      }
      folders(first: 10) {
        nodes {
          ...FolderForIndicator
        }
      }
    }
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${FolderForIndicatorFragmentDoc}`;
export const UserAvatarQueryFragmentFragmentDoc = gql`
    fragment UserAvatarQueryFragment on User {
  id
  account
  avatar1x: avatarImage(size: MEDIUM, density: 1) {
    url
  }
  avatar2x: avatarImage(size: MEDIUM, density: 2) {
    url
  }
}
    `;
export const UserAvatarsQueryFragmentFragmentDoc = gql`
    fragment UserAvatarsQueryFragment on UserConnection {
  totalCount
  edges {
    node {
      ...UserAvatarQueryFragment
    }
  }
}
    ${UserAvatarQueryFragmentFragmentDoc}`;
export const ProfilePopupUserFragmentDoc = gql`
    fragment ProfilePopupUser on User {
  id
  path
  account
  realName
  shortBio
  coverImage {
    url
  }
  avatar1x: avatarImage(size: LARGE, density: 1) {
    url
  }
  avatar2x: avatarImage(size: LARGE, density: 2) {
    url
  }
  popularNotes(first: 3) {
    nodes {
      id
      title
      path
    }
  }
}
    `;
export const CustomEmojiFragmentFragmentDoc = gql`
    fragment CustomEmojiFragment on CustomEmoji {
  id
  emojiCode
  imageUrl
  createUser {
    id
    account
    avatar1x: avatarImage(size: MEDIUM, density: 1) {
      url
    }
    avatar2x: avatarImage(size: MEDIUM, density: 2) {
      url
    }
    path
  }
  createdAt
}
    `;
export const AttachmentWithFilePreviewDocument = gql`
    query AttachmentWithFilePreview($path: String!) {
  attachmentFromPath(path: $path) {
    id
    key
    filePreview {
      conversionState
      attemptsCount
      lastPreviewedAt
      asset {
        id
        width
        height
      }
    }
  }
}
    `;

/**
 * __useAttachmentWithFilePreviewQuery__
 *
 * To run a query within a React component, call `useAttachmentWithFilePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttachmentWithFilePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttachmentWithFilePreviewQuery({
 *   variables: {
 *      path: // value for 'path'
 *   },
 * });
 */
export function useAttachmentWithFilePreviewQuery(baseOptions: Apollo.QueryHookOptions<AttachmentWithFilePreviewQuery, AttachmentWithFilePreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttachmentWithFilePreviewQuery, AttachmentWithFilePreviewQueryVariables>(AttachmentWithFilePreviewDocument, options);
      }
export function useAttachmentWithFilePreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttachmentWithFilePreviewQuery, AttachmentWithFilePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttachmentWithFilePreviewQuery, AttachmentWithFilePreviewQueryVariables>(AttachmentWithFilePreviewDocument, options);
        }
export type AttachmentWithFilePreviewQueryHookResult = ReturnType<typeof useAttachmentWithFilePreviewQuery>;
export type AttachmentWithFilePreviewLazyQueryHookResult = ReturnType<typeof useAttachmentWithFilePreviewLazyQuery>;
export type AttachmentWithFilePreviewQueryResult = Apollo.QueryResult<AttachmentWithFilePreviewQuery, AttachmentWithFilePreviewQueryVariables>;
export const RequestAttachmentConversionDocument = gql`
    mutation RequestAttachmentConversion($input: RequestAttachmentConversionInput!) {
  requestAttachmentConversion(input: $input) {
    conversionState
  }
}
    `;
export type RequestAttachmentConversionMutationFn = Apollo.MutationFunction<RequestAttachmentConversionMutation, RequestAttachmentConversionMutationVariables>;

/**
 * __useRequestAttachmentConversionMutation__
 *
 * To run a mutation, you first call `useRequestAttachmentConversionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAttachmentConversionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAttachmentConversionMutation, { data, loading, error }] = useRequestAttachmentConversionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestAttachmentConversionMutation(baseOptions?: Apollo.MutationHookOptions<RequestAttachmentConversionMutation, RequestAttachmentConversionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAttachmentConversionMutation, RequestAttachmentConversionMutationVariables>(RequestAttachmentConversionDocument, options);
      }
export type RequestAttachmentConversionMutationHookResult = ReturnType<typeof useRequestAttachmentConversionMutation>;
export type RequestAttachmentConversionMutationResult = Apollo.MutationResult<RequestAttachmentConversionMutation>;
export type RequestAttachmentConversionMutationOptions = Apollo.BaseMutationOptions<RequestAttachmentConversionMutation, RequestAttachmentConversionMutationVariables>;
export const SetFeedToHomeDocument = gql`
    mutation SetFeedToHome($input: SetFeedToHomeInput!) {
  setFeedToHome(input: $input) {
    clientMutationId
    feed
  }
}
    `;
export type SetFeedToHomeMutationFn = Apollo.MutationFunction<SetFeedToHomeMutation, SetFeedToHomeMutationVariables>;

/**
 * __useSetFeedToHomeMutation__
 *
 * To run a mutation, you first call `useSetFeedToHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetFeedToHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setFeedToHomeMutation, { data, loading, error }] = useSetFeedToHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetFeedToHomeMutation(baseOptions?: Apollo.MutationHookOptions<SetFeedToHomeMutation, SetFeedToHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetFeedToHomeMutation, SetFeedToHomeMutationVariables>(SetFeedToHomeDocument, options);
      }
export type SetFeedToHomeMutationHookResult = ReturnType<typeof useSetFeedToHomeMutation>;
export type SetFeedToHomeMutationResult = Apollo.MutationResult<SetFeedToHomeMutation>;
export type SetFeedToHomeMutationOptions = Apollo.BaseMutationOptions<SetFeedToHomeMutation, SetFeedToHomeMutationVariables>;
export const SetGroupToHomeDocument = gql`
    mutation SetGroupToHome($input: SetGroupToHomeInput!) {
  setGroupToHome(input: $input) {
    clientMutationId
    group {
      id
      path
    }
  }
}
    `;
export type SetGroupToHomeMutationFn = Apollo.MutationFunction<SetGroupToHomeMutation, SetGroupToHomeMutationVariables>;

/**
 * __useSetGroupToHomeMutation__
 *
 * To run a mutation, you first call `useSetGroupToHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGroupToHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGroupToHomeMutation, { data, loading, error }] = useSetGroupToHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetGroupToHomeMutation(baseOptions?: Apollo.MutationHookOptions<SetGroupToHomeMutation, SetGroupToHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGroupToHomeMutation, SetGroupToHomeMutationVariables>(SetGroupToHomeDocument, options);
      }
export type SetGroupToHomeMutationHookResult = ReturnType<typeof useSetGroupToHomeMutation>;
export type SetGroupToHomeMutationResult = Apollo.MutationResult<SetGroupToHomeMutation>;
export type SetGroupToHomeMutationOptions = Apollo.BaseMutationOptions<SetGroupToHomeMutation, SetGroupToHomeMutationVariables>;
export const FetchImportableUsersDocument = gql`
    query FetchImportableUsers($serviceType: String!, $teamName: String!, $encryptedAccessToken: String!, $page: Int!) {
  importableUsers(
    serviceType: $serviceType
    teamName: $teamName
    encryptedAccessToken: $encryptedAccessToken
    page: $page
  ) {
    account
  }
}
    `;

/**
 * __useFetchImportableUsersQuery__
 *
 * To run a query within a React component, call `useFetchImportableUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchImportableUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchImportableUsersQuery({
 *   variables: {
 *      serviceType: // value for 'serviceType'
 *      teamName: // value for 'teamName'
 *      encryptedAccessToken: // value for 'encryptedAccessToken'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useFetchImportableUsersQuery(baseOptions: Apollo.QueryHookOptions<FetchImportableUsersQuery, FetchImportableUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchImportableUsersQuery, FetchImportableUsersQueryVariables>(FetchImportableUsersDocument, options);
      }
export function useFetchImportableUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchImportableUsersQuery, FetchImportableUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchImportableUsersQuery, FetchImportableUsersQueryVariables>(FetchImportableUsersDocument, options);
        }
export type FetchImportableUsersQueryHookResult = ReturnType<typeof useFetchImportableUsersQuery>;
export type FetchImportableUsersLazyQueryHookResult = ReturnType<typeof useFetchImportableUsersLazyQuery>;
export type FetchImportableUsersQueryResult = Apollo.QueryResult<FetchImportableUsersQuery, FetchImportableUsersQueryVariables>;
export const GetNoteTemplateFolderDocument = gql`
    query GetNoteTemplateFolder($noteTemplateId: ID!) {
  noteTemplate(id: $noteTemplateId) {
    groups {
      id
      name
      path
      isPrivate
    }
    folders {
      id
      group {
        id
      }
      fullName
    }
  }
}
    `;

/**
 * __useGetNoteTemplateFolderQuery__
 *
 * To run a query within a React component, call `useGetNoteTemplateFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteTemplateFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteTemplateFolderQuery({
 *   variables: {
 *      noteTemplateId: // value for 'noteTemplateId'
 *   },
 * });
 */
export function useGetNoteTemplateFolderQuery(baseOptions: Apollo.QueryHookOptions<GetNoteTemplateFolderQuery, GetNoteTemplateFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteTemplateFolderQuery, GetNoteTemplateFolderQueryVariables>(GetNoteTemplateFolderDocument, options);
      }
export function useGetNoteTemplateFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteTemplateFolderQuery, GetNoteTemplateFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteTemplateFolderQuery, GetNoteTemplateFolderQueryVariables>(GetNoteTemplateFolderDocument, options);
        }
export type GetNoteTemplateFolderQueryHookResult = ReturnType<typeof useGetNoteTemplateFolderQuery>;
export type GetNoteTemplateFolderLazyQueryHookResult = ReturnType<typeof useGetNoteTemplateFolderLazyQuery>;
export type GetNoteTemplateFolderQueryResult = Apollo.QueryResult<GetNoteTemplateFolderQuery, GetNoteTemplateFolderQueryVariables>;
export const UpdateSaml2SsoSettingDocument = gql`
    mutation updateSaml2SsoSetting($mode: Saml2SsoMode!, $readOnlyUserPasswordAuthnEnabled: Boolean) {
  updateSaml2SsoSetting(
    input: {mode: $mode, readOnlyUserPasswordAuthnEnabled: $readOnlyUserPasswordAuthnEnabled}
  ) {
    clientMutationId
  }
}
    `;
export type UpdateSaml2SsoSettingMutationFn = Apollo.MutationFunction<UpdateSaml2SsoSettingMutation, UpdateSaml2SsoSettingMutationVariables>;

/**
 * __useUpdateSaml2SsoSettingMutation__
 *
 * To run a mutation, you first call `useUpdateSaml2SsoSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSaml2SsoSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSaml2SsoSettingMutation, { data, loading, error }] = useUpdateSaml2SsoSettingMutation({
 *   variables: {
 *      mode: // value for 'mode'
 *      readOnlyUserPasswordAuthnEnabled: // value for 'readOnlyUserPasswordAuthnEnabled'
 *   },
 * });
 */
export function useUpdateSaml2SsoSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSaml2SsoSettingMutation, UpdateSaml2SsoSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSaml2SsoSettingMutation, UpdateSaml2SsoSettingMutationVariables>(UpdateSaml2SsoSettingDocument, options);
      }
export type UpdateSaml2SsoSettingMutationHookResult = ReturnType<typeof useUpdateSaml2SsoSettingMutation>;
export type UpdateSaml2SsoSettingMutationResult = Apollo.MutationResult<UpdateSaml2SsoSettingMutation>;
export type UpdateSaml2SsoSettingMutationOptions = Apollo.BaseMutationOptions<UpdateSaml2SsoSettingMutation, UpdateSaml2SsoSettingMutationVariables>;
export const DisableCollabModeStartDialogDocument = gql`
    mutation DisableCollabModeStartDialog($account: String!) {
  disableCollabModeStartDialog(input: {account: $account}) {
    clientMutationId
  }
}
    `;
export type DisableCollabModeStartDialogMutationFn = Apollo.MutationFunction<DisableCollabModeStartDialogMutation, DisableCollabModeStartDialogMutationVariables>;

/**
 * __useDisableCollabModeStartDialogMutation__
 *
 * To run a mutation, you first call `useDisableCollabModeStartDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableCollabModeStartDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableCollabModeStartDialogMutation, { data, loading, error }] = useDisableCollabModeStartDialogMutation({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useDisableCollabModeStartDialogMutation(baseOptions?: Apollo.MutationHookOptions<DisableCollabModeStartDialogMutation, DisableCollabModeStartDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableCollabModeStartDialogMutation, DisableCollabModeStartDialogMutationVariables>(DisableCollabModeStartDialogDocument, options);
      }
export type DisableCollabModeStartDialogMutationHookResult = ReturnType<typeof useDisableCollabModeStartDialogMutation>;
export type DisableCollabModeStartDialogMutationResult = Apollo.MutationResult<DisableCollabModeStartDialogMutation>;
export type DisableCollabModeStartDialogMutationOptions = Apollo.BaseMutationOptions<DisableCollabModeStartDialogMutation, DisableCollabModeStartDialogMutationVariables>;
export const EnableCollabModeStartDialogDocument = gql`
    mutation EnableCollabModeStartDialog($account: String!) {
  enableCollabModeStartDialog(input: {account: $account}) {
    clientMutationId
  }
}
    `;
export type EnableCollabModeStartDialogMutationFn = Apollo.MutationFunction<EnableCollabModeStartDialogMutation, EnableCollabModeStartDialogMutationVariables>;

/**
 * __useEnableCollabModeStartDialogMutation__
 *
 * To run a mutation, you first call `useEnableCollabModeStartDialogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableCollabModeStartDialogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableCollabModeStartDialogMutation, { data, loading, error }] = useEnableCollabModeStartDialogMutation({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useEnableCollabModeStartDialogMutation(baseOptions?: Apollo.MutationHookOptions<EnableCollabModeStartDialogMutation, EnableCollabModeStartDialogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableCollabModeStartDialogMutation, EnableCollabModeStartDialogMutationVariables>(EnableCollabModeStartDialogDocument, options);
      }
export type EnableCollabModeStartDialogMutationHookResult = ReturnType<typeof useEnableCollabModeStartDialogMutation>;
export type EnableCollabModeStartDialogMutationResult = Apollo.MutationResult<EnableCollabModeStartDialogMutation>;
export type EnableCollabModeStartDialogMutationOptions = Apollo.BaseMutationOptions<EnableCollabModeStartDialogMutation, EnableCollabModeStartDialogMutationVariables>;
export const UpdateUserNotificationSettingDocument = gql`
    mutation UpdateUserNotificationSetting($input: UpdateUserNotificationSettingInput!) {
  updateUserNotificationSetting(input: $input) {
    clientMutationId
  }
}
    `;
export type UpdateUserNotificationSettingMutationFn = Apollo.MutationFunction<UpdateUserNotificationSettingMutation, UpdateUserNotificationSettingMutationVariables>;

/**
 * __useUpdateUserNotificationSettingMutation__
 *
 * To run a mutation, you first call `useUpdateUserNotificationSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotificationSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotificationSettingMutation, { data, loading, error }] = useUpdateUserNotificationSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNotificationSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNotificationSettingMutation, UpdateUserNotificationSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNotificationSettingMutation, UpdateUserNotificationSettingMutationVariables>(UpdateUserNotificationSettingDocument, options);
      }
export type UpdateUserNotificationSettingMutationHookResult = ReturnType<typeof useUpdateUserNotificationSettingMutation>;
export type UpdateUserNotificationSettingMutationResult = Apollo.MutationResult<UpdateUserNotificationSettingMutation>;
export type UpdateUserNotificationSettingMutationOptions = Apollo.BaseMutationOptions<UpdateUserNotificationSettingMutation, UpdateUserNotificationSettingMutationVariables>;
export const GetAssistantMessageDocument = gql`
    query GetAssistantMessage($id: String!, $first: Int!) {
  assistantMessage(id: $id) {
    id
    content
    contentHtml
    status
    assistantReferenceDocuments(first: $first) {
      nodes {
        id
        source {
          id
          title
          url
          path
          type
          author {
            account
            path
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAssistantMessageQuery__
 *
 * To run a query within a React component, call `useGetAssistantMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssistantMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssistantMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetAssistantMessageQuery(baseOptions: Apollo.QueryHookOptions<GetAssistantMessageQuery, GetAssistantMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssistantMessageQuery, GetAssistantMessageQueryVariables>(GetAssistantMessageDocument, options);
      }
export function useGetAssistantMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssistantMessageQuery, GetAssistantMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssistantMessageQuery, GetAssistantMessageQueryVariables>(GetAssistantMessageDocument, options);
        }
export type GetAssistantMessageQueryHookResult = ReturnType<typeof useGetAssistantMessageQuery>;
export type GetAssistantMessageLazyQueryHookResult = ReturnType<typeof useGetAssistantMessageLazyQuery>;
export type GetAssistantMessageQueryResult = Apollo.QueryResult<GetAssistantMessageQuery, GetAssistantMessageQueryVariables>;
export const CreateAssistantMessageDocument = gql`
    mutation CreateAssistantMessage($input: CreateAssistantMessageInput!) {
  createAssistantMessage(input: $input) {
    assistantMessage {
      id
    }
  }
}
    `;
export type CreateAssistantMessageMutationFn = Apollo.MutationFunction<CreateAssistantMessageMutation, CreateAssistantMessageMutationVariables>;

/**
 * __useCreateAssistantMessageMutation__
 *
 * To run a mutation, you first call `useCreateAssistantMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssistantMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssistantMessageMutation, { data, loading, error }] = useCreateAssistantMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssistantMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateAssistantMessageMutation, CreateAssistantMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAssistantMessageMutation, CreateAssistantMessageMutationVariables>(CreateAssistantMessageDocument, options);
      }
export type CreateAssistantMessageMutationHookResult = ReturnType<typeof useCreateAssistantMessageMutation>;
export type CreateAssistantMessageMutationResult = Apollo.MutationResult<CreateAssistantMessageMutation>;
export type CreateAssistantMessageMutationOptions = Apollo.BaseMutationOptions<CreateAssistantMessageMutation, CreateAssistantMessageMutationVariables>;
export const UpdateCommentReplyDocument = gql`
    mutation UpdateCommentReply($input: UpdateCommentReplyInput!) {
  updateCommentReply(input: $input) {
    reply {
      id
      content
      contentHtml
      isEdited
    }
  }
}
    `;
export type UpdateCommentReplyMutationFn = Apollo.MutationFunction<UpdateCommentReplyMutation, UpdateCommentReplyMutationVariables>;

/**
 * __useUpdateCommentReplyMutation__
 *
 * To run a mutation, you first call `useUpdateCommentReplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentReplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentReplyMutation, { data, loading, error }] = useUpdateCommentReplyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommentReplyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentReplyMutation, UpdateCommentReplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentReplyMutation, UpdateCommentReplyMutationVariables>(UpdateCommentReplyDocument, options);
      }
export type UpdateCommentReplyMutationHookResult = ReturnType<typeof useUpdateCommentReplyMutation>;
export type UpdateCommentReplyMutationResult = Apollo.MutationResult<UpdateCommentReplyMutation>;
export type UpdateCommentReplyMutationOptions = Apollo.BaseMutationOptions<UpdateCommentReplyMutation, UpdateCommentReplyMutationVariables>;
export const LikeCommentDocument = gql`
    mutation LikeComment($input: LikeInput!) {
  like(input: $input) {
    likers(first: 5) {
      ...UserAvatarsQueryFragment
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${UserAvatarsQueryFragmentFragmentDoc}`;
export type LikeCommentMutationFn = Apollo.MutationFunction<LikeCommentMutation, LikeCommentMutationVariables>;

/**
 * __useLikeCommentMutation__
 *
 * To run a mutation, you first call `useLikeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeCommentMutation, { data, loading, error }] = useLikeCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLikeCommentMutation(baseOptions?: Apollo.MutationHookOptions<LikeCommentMutation, LikeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeCommentMutation, LikeCommentMutationVariables>(LikeCommentDocument, options);
      }
export type LikeCommentMutationHookResult = ReturnType<typeof useLikeCommentMutation>;
export type LikeCommentMutationResult = Apollo.MutationResult<LikeCommentMutation>;
export type LikeCommentMutationOptions = Apollo.BaseMutationOptions<LikeCommentMutation, LikeCommentMutationVariables>;
export const UnlikeCommentDocument = gql`
    mutation UnlikeComment($input: UnlikeInput!) {
  unlike(input: $input) {
    likers(first: 5) {
      ...UserAvatarsQueryFragment
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${UserAvatarsQueryFragmentFragmentDoc}`;
export type UnlikeCommentMutationFn = Apollo.MutationFunction<UnlikeCommentMutation, UnlikeCommentMutationVariables>;

/**
 * __useUnlikeCommentMutation__
 *
 * To run a mutation, you first call `useUnlikeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlikeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlikeCommentMutation, { data, loading, error }] = useUnlikeCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlikeCommentMutation(baseOptions?: Apollo.MutationHookOptions<UnlikeCommentMutation, UnlikeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlikeCommentMutation, UnlikeCommentMutationVariables>(UnlikeCommentDocument, options);
      }
export type UnlikeCommentMutationHookResult = ReturnType<typeof useUnlikeCommentMutation>;
export type UnlikeCommentMutationResult = Apollo.MutationResult<UnlikeCommentMutation>;
export type UnlikeCommentMutationOptions = Apollo.BaseMutationOptions<UnlikeCommentMutation, UnlikeCommentMutationVariables>;
export const EnableDraftReviewDocument = gql`
    mutation EnableDraftReview($input: EnableDraftReviewInput!) {
  enableDraftReview(input: $input) {
    reviewableDraft {
      ...MutateReviewableDraft
    }
  }
}
    ${MutateReviewableDraftFragmentDoc}`;
export type EnableDraftReviewMutationFn = Apollo.MutationFunction<EnableDraftReviewMutation, EnableDraftReviewMutationVariables>;

/**
 * __useEnableDraftReviewMutation__
 *
 * To run a mutation, you first call `useEnableDraftReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableDraftReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableDraftReviewMutation, { data, loading, error }] = useEnableDraftReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEnableDraftReviewMutation(baseOptions?: Apollo.MutationHookOptions<EnableDraftReviewMutation, EnableDraftReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableDraftReviewMutation, EnableDraftReviewMutationVariables>(EnableDraftReviewDocument, options);
      }
export type EnableDraftReviewMutationHookResult = ReturnType<typeof useEnableDraftReviewMutation>;
export type EnableDraftReviewMutationResult = Apollo.MutationResult<EnableDraftReviewMutation>;
export type EnableDraftReviewMutationOptions = Apollo.BaseMutationOptions<EnableDraftReviewMutation, EnableDraftReviewMutationVariables>;
export const DisableDraftReviewDocument = gql`
    mutation DisableDraftReview($input: DisableDraftReviewInput!) {
  disableDraftReview(input: $input) {
    reviewableDraft {
      ...MutateReviewableDraft
    }
  }
}
    ${MutateReviewableDraftFragmentDoc}`;
export type DisableDraftReviewMutationFn = Apollo.MutationFunction<DisableDraftReviewMutation, DisableDraftReviewMutationVariables>;

/**
 * __useDisableDraftReviewMutation__
 *
 * To run a mutation, you first call `useDisableDraftReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableDraftReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableDraftReviewMutation, { data, loading, error }] = useDisableDraftReviewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDisableDraftReviewMutation(baseOptions?: Apollo.MutationHookOptions<DisableDraftReviewMutation, DisableDraftReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableDraftReviewMutation, DisableDraftReviewMutationVariables>(DisableDraftReviewDocument, options);
      }
export type DisableDraftReviewMutationHookResult = ReturnType<typeof useDisableDraftReviewMutation>;
export type DisableDraftReviewMutationResult = Apollo.MutationResult<DisableDraftReviewMutation>;
export type DisableDraftReviewMutationOptions = Apollo.BaseMutationOptions<DisableDraftReviewMutation, DisableDraftReviewMutationVariables>;
export const EditorCreateNoteDocument = gql`
    mutation EditorCreateNote($note: CreateNoteInput!, $allCount: Int!) {
  createOrUpdateNote: createNote(input: $note) {
    note {
      ...MutateNoteInEditor
    }
  }
}
    ${MutateNoteInEditorFragmentDoc}`;
export type EditorCreateNoteMutationFn = Apollo.MutationFunction<EditorCreateNoteMutation, EditorCreateNoteMutationVariables>;

/**
 * __useEditorCreateNoteMutation__
 *
 * To run a mutation, you first call `useEditorCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditorCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editorCreateNoteMutation, { data, loading, error }] = useEditorCreateNoteMutation({
 *   variables: {
 *      note: // value for 'note'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useEditorCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<EditorCreateNoteMutation, EditorCreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditorCreateNoteMutation, EditorCreateNoteMutationVariables>(EditorCreateNoteDocument, options);
      }
export type EditorCreateNoteMutationHookResult = ReturnType<typeof useEditorCreateNoteMutation>;
export type EditorCreateNoteMutationResult = Apollo.MutationResult<EditorCreateNoteMutation>;
export type EditorCreateNoteMutationOptions = Apollo.BaseMutationOptions<EditorCreateNoteMutation, EditorCreateNoteMutationVariables>;
export const EditorUpdateNoteDocument = gql`
    mutation EditorUpdateNote($input: UpdateNoteInput!, $allCount: Int!) {
  createOrUpdateNote: updateNote(input: $input) {
    note {
      ...MutateNoteInEditor
    }
  }
}
    ${MutateNoteInEditorFragmentDoc}`;
export type EditorUpdateNoteMutationFn = Apollo.MutationFunction<EditorUpdateNoteMutation, EditorUpdateNoteMutationVariables>;

/**
 * __useEditorUpdateNoteMutation__
 *
 * To run a mutation, you first call `useEditorUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditorUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editorUpdateNoteMutation, { data, loading, error }] = useEditorUpdateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useEditorUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<EditorUpdateNoteMutation, EditorUpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditorUpdateNoteMutation, EditorUpdateNoteMutationVariables>(EditorUpdateNoteDocument, options);
      }
export type EditorUpdateNoteMutationHookResult = ReturnType<typeof useEditorUpdateNoteMutation>;
export type EditorUpdateNoteMutationResult = Apollo.MutationResult<EditorUpdateNoteMutation>;
export type EditorUpdateNoteMutationOptions = Apollo.BaseMutationOptions<EditorUpdateNoteMutation, EditorUpdateNoteMutationVariables>;
export const GetRenderMarkdownToHtmlDocument = gql`
    query GetRenderMarkdownToHtml($content: String!, $isMain: Boolean!) {
  renderMarkdownToHtml(content: $content, isMain: $isMain)
}
    `;

/**
 * __useGetRenderMarkdownToHtmlQuery__
 *
 * To run a query within a React component, call `useGetRenderMarkdownToHtmlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRenderMarkdownToHtmlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRenderMarkdownToHtmlQuery({
 *   variables: {
 *      content: // value for 'content'
 *      isMain: // value for 'isMain'
 *   },
 * });
 */
export function useGetRenderMarkdownToHtmlQuery(baseOptions: Apollo.QueryHookOptions<GetRenderMarkdownToHtmlQuery, GetRenderMarkdownToHtmlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRenderMarkdownToHtmlQuery, GetRenderMarkdownToHtmlQueryVariables>(GetRenderMarkdownToHtmlDocument, options);
      }
export function useGetRenderMarkdownToHtmlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRenderMarkdownToHtmlQuery, GetRenderMarkdownToHtmlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRenderMarkdownToHtmlQuery, GetRenderMarkdownToHtmlQueryVariables>(GetRenderMarkdownToHtmlDocument, options);
        }
export type GetRenderMarkdownToHtmlQueryHookResult = ReturnType<typeof useGetRenderMarkdownToHtmlQuery>;
export type GetRenderMarkdownToHtmlLazyQueryHookResult = ReturnType<typeof useGetRenderMarkdownToHtmlLazyQuery>;
export type GetRenderMarkdownToHtmlQueryResult = Apollo.QueryResult<GetRenderMarkdownToHtmlQuery, GetRenderMarkdownToHtmlQueryVariables>;
export const AttachNoteToFolderForEntryActionDropdownDocument = gql`
    mutation AttachNoteToFolderForEntryActionDropdown($noteId: ID!, $folder: FolderInput!) {
  attachNoteToFolder(input: {noteId: $noteId, folder: $folder}) {
    clientMutationId
  }
}
    `;
export type AttachNoteToFolderForEntryActionDropdownMutationFn = Apollo.MutationFunction<AttachNoteToFolderForEntryActionDropdownMutation, AttachNoteToFolderForEntryActionDropdownMutationVariables>;

/**
 * __useAttachNoteToFolderForEntryActionDropdownMutation__
 *
 * To run a mutation, you first call `useAttachNoteToFolderForEntryActionDropdownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachNoteToFolderForEntryActionDropdownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachNoteToFolderForEntryActionDropdownMutation, { data, loading, error }] = useAttachNoteToFolderForEntryActionDropdownMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useAttachNoteToFolderForEntryActionDropdownMutation(baseOptions?: Apollo.MutationHookOptions<AttachNoteToFolderForEntryActionDropdownMutation, AttachNoteToFolderForEntryActionDropdownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachNoteToFolderForEntryActionDropdownMutation, AttachNoteToFolderForEntryActionDropdownMutationVariables>(AttachNoteToFolderForEntryActionDropdownDocument, options);
      }
export type AttachNoteToFolderForEntryActionDropdownMutationHookResult = ReturnType<typeof useAttachNoteToFolderForEntryActionDropdownMutation>;
export type AttachNoteToFolderForEntryActionDropdownMutationResult = Apollo.MutationResult<AttachNoteToFolderForEntryActionDropdownMutation>;
export type AttachNoteToFolderForEntryActionDropdownMutationOptions = Apollo.BaseMutationOptions<AttachNoteToFolderForEntryActionDropdownMutation, AttachNoteToFolderForEntryActionDropdownMutationVariables>;
export const DeleteNoteVersionForNoteVersionItemActionDropdownButtonDocument = gql`
    mutation DeleteNoteVersionForNoteVersionItemActionDropdownButton($input: DeleteNoteVersionInput!) {
  deleteNoteVersion(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutationFn = Apollo.MutationFunction<DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation, DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutationVariables>;

/**
 * __useDeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation__
 *
 * To run a mutation, you first call `useDeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteVersionForNoteVersionItemActionDropdownButtonMutation, { data, loading, error }] = useDeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation, DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation, DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutationVariables>(DeleteNoteVersionForNoteVersionItemActionDropdownButtonDocument, options);
      }
export type DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutationHookResult = ReturnType<typeof useDeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation>;
export type DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutationResult = Apollo.MutationResult<DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation>;
export type DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutationOptions = Apollo.BaseMutationOptions<DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutation, DeleteNoteVersionForNoteVersionItemActionDropdownButtonMutationVariables>;
export const FeedCreateGroupPinDocument = gql`
    mutation FeedCreateGroupPin($groupId: ID!, $noteId: ID!) {
  createGroupPin(input: {groupId: $groupId, noteId: $noteId}) {
    group {
      ...FeedGroupPin
    }
  }
}
    ${FeedGroupPinFragmentDoc}`;
export type FeedCreateGroupPinMutationFn = Apollo.MutationFunction<FeedCreateGroupPinMutation, FeedCreateGroupPinMutationVariables>;

/**
 * __useFeedCreateGroupPinMutation__
 *
 * To run a mutation, you first call `useFeedCreateGroupPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeedCreateGroupPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feedCreateGroupPinMutation, { data, loading, error }] = useFeedCreateGroupPinMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useFeedCreateGroupPinMutation(baseOptions?: Apollo.MutationHookOptions<FeedCreateGroupPinMutation, FeedCreateGroupPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeedCreateGroupPinMutation, FeedCreateGroupPinMutationVariables>(FeedCreateGroupPinDocument, options);
      }
export type FeedCreateGroupPinMutationHookResult = ReturnType<typeof useFeedCreateGroupPinMutation>;
export type FeedCreateGroupPinMutationResult = Apollo.MutationResult<FeedCreateGroupPinMutation>;
export type FeedCreateGroupPinMutationOptions = Apollo.BaseMutationOptions<FeedCreateGroupPinMutation, FeedCreateGroupPinMutationVariables>;
export const FeedRemoveGroupPinDocument = gql`
    mutation FeedRemoveGroupPin($groupId: ID!, $noteId: ID!) {
  removeGroupPin(input: {groupId: $groupId, noteId: $noteId}) {
    group {
      ...FeedGroupPin
    }
  }
}
    ${FeedGroupPinFragmentDoc}`;
export type FeedRemoveGroupPinMutationFn = Apollo.MutationFunction<FeedRemoveGroupPinMutation, FeedRemoveGroupPinMutationVariables>;

/**
 * __useFeedRemoveGroupPinMutation__
 *
 * To run a mutation, you first call `useFeedRemoveGroupPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFeedRemoveGroupPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [feedRemoveGroupPinMutation, { data, loading, error }] = useFeedRemoveGroupPinMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useFeedRemoveGroupPinMutation(baseOptions?: Apollo.MutationHookOptions<FeedRemoveGroupPinMutation, FeedRemoveGroupPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FeedRemoveGroupPinMutation, FeedRemoveGroupPinMutationVariables>(FeedRemoveGroupPinDocument, options);
      }
export type FeedRemoveGroupPinMutationHookResult = ReturnType<typeof useFeedRemoveGroupPinMutation>;
export type FeedRemoveGroupPinMutationResult = Apollo.MutationResult<FeedRemoveGroupPinMutation>;
export type FeedRemoveGroupPinMutationOptions = Apollo.BaseMutationOptions<FeedRemoveGroupPinMutation, FeedRemoveGroupPinMutationVariables>;
export const FolderContainerCreateFolderDocument = gql`
    mutation FolderContainerCreateFolder($folder: FolderInput) {
  createFolder(input: {folder: $folder}) {
    foldersCacheKey
    folder {
      ...FolderContainerFolderFragment
    }
  }
}
    ${FolderContainerFolderFragmentFragmentDoc}`;
export type FolderContainerCreateFolderMutationFn = Apollo.MutationFunction<FolderContainerCreateFolderMutation, FolderContainerCreateFolderMutationVariables>;

/**
 * __useFolderContainerCreateFolderMutation__
 *
 * To run a mutation, you first call `useFolderContainerCreateFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerCreateFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderContainerCreateFolderMutation, { data, loading, error }] = useFolderContainerCreateFolderMutation({
 *   variables: {
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useFolderContainerCreateFolderMutation(baseOptions?: Apollo.MutationHookOptions<FolderContainerCreateFolderMutation, FolderContainerCreateFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderContainerCreateFolderMutation, FolderContainerCreateFolderMutationVariables>(FolderContainerCreateFolderDocument, options);
      }
export type FolderContainerCreateFolderMutationHookResult = ReturnType<typeof useFolderContainerCreateFolderMutation>;
export type FolderContainerCreateFolderMutationResult = Apollo.MutationResult<FolderContainerCreateFolderMutation>;
export type FolderContainerCreateFolderMutationOptions = Apollo.BaseMutationOptions<FolderContainerCreateFolderMutation, FolderContainerCreateFolderMutationVariables>;
export const FolderContainerCreateFolderPinDocument = gql`
    mutation FolderContainerCreateFolderPin($noteId: ID!, $folder: FolderInput, $allCount: Int!) {
  createFolderPin(input: {noteId: $noteId, folder: $folder}) {
    folder {
      id
      pinnedNotes(first: $allCount) {
        ...FolderContainerPinnedNotesFragment
      }
    }
  }
}
    ${FolderContainerPinnedNotesFragmentFragmentDoc}`;
export type FolderContainerCreateFolderPinMutationFn = Apollo.MutationFunction<FolderContainerCreateFolderPinMutation, FolderContainerCreateFolderPinMutationVariables>;

/**
 * __useFolderContainerCreateFolderPinMutation__
 *
 * To run a mutation, you first call `useFolderContainerCreateFolderPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerCreateFolderPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderContainerCreateFolderPinMutation, { data, loading, error }] = useFolderContainerCreateFolderPinMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      folder: // value for 'folder'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useFolderContainerCreateFolderPinMutation(baseOptions?: Apollo.MutationHookOptions<FolderContainerCreateFolderPinMutation, FolderContainerCreateFolderPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderContainerCreateFolderPinMutation, FolderContainerCreateFolderPinMutationVariables>(FolderContainerCreateFolderPinDocument, options);
      }
export type FolderContainerCreateFolderPinMutationHookResult = ReturnType<typeof useFolderContainerCreateFolderPinMutation>;
export type FolderContainerCreateFolderPinMutationResult = Apollo.MutationResult<FolderContainerCreateFolderPinMutation>;
export type FolderContainerCreateFolderPinMutationOptions = Apollo.BaseMutationOptions<FolderContainerCreateFolderPinMutation, FolderContainerCreateFolderPinMutationVariables>;
export const GetDescendantNotesDocument = gql`
    query GetDescendantNotes($id: ID!) {
  folder(id: $id) {
    descendantNotes {
      totalCount
    }
    unarchivableDescendantNotes {
      totalCount
    }
    unarchivableDescendantNoteTitles
  }
}
    `;

/**
 * __useGetDescendantNotesQuery__
 *
 * To run a query within a React component, call `useGetDescendantNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDescendantNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDescendantNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDescendantNotesQuery(baseOptions: Apollo.QueryHookOptions<GetDescendantNotesQuery, GetDescendantNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDescendantNotesQuery, GetDescendantNotesQueryVariables>(GetDescendantNotesDocument, options);
      }
export function useGetDescendantNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDescendantNotesQuery, GetDescendantNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDescendantNotesQuery, GetDescendantNotesQueryVariables>(GetDescendantNotesDocument, options);
        }
export type GetDescendantNotesQueryHookResult = ReturnType<typeof useGetDescendantNotesQuery>;
export type GetDescendantNotesLazyQueryHookResult = ReturnType<typeof useGetDescendantNotesLazyQuery>;
export type GetDescendantNotesQueryResult = Apollo.QueryResult<GetDescendantNotesQuery, GetDescendantNotesQueryVariables>;
export const FolderContainerGetFoldersBySelectedNotesDocument = gql`
    query FolderContainerGetFoldersBySelectedNotes($noteIds: [ID!]!, $allCount: Int!) {
  nodes(ids: $noteIds) {
    ... on Note {
      id
      folders(first: $allCount) {
        nodes {
          ...FolderContainerFolderFragment
        }
      }
    }
  }
}
    ${FolderContainerFolderFragmentFragmentDoc}`;

/**
 * __useFolderContainerGetFoldersBySelectedNotesQuery__
 *
 * To run a query within a React component, call `useFolderContainerGetFoldersBySelectedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerGetFoldersBySelectedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderContainerGetFoldersBySelectedNotesQuery({
 *   variables: {
 *      noteIds: // value for 'noteIds'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useFolderContainerGetFoldersBySelectedNotesQuery(baseOptions: Apollo.QueryHookOptions<FolderContainerGetFoldersBySelectedNotesQuery, FolderContainerGetFoldersBySelectedNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderContainerGetFoldersBySelectedNotesQuery, FolderContainerGetFoldersBySelectedNotesQueryVariables>(FolderContainerGetFoldersBySelectedNotesDocument, options);
      }
export function useFolderContainerGetFoldersBySelectedNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderContainerGetFoldersBySelectedNotesQuery, FolderContainerGetFoldersBySelectedNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderContainerGetFoldersBySelectedNotesQuery, FolderContainerGetFoldersBySelectedNotesQueryVariables>(FolderContainerGetFoldersBySelectedNotesDocument, options);
        }
export type FolderContainerGetFoldersBySelectedNotesQueryHookResult = ReturnType<typeof useFolderContainerGetFoldersBySelectedNotesQuery>;
export type FolderContainerGetFoldersBySelectedNotesLazyQueryHookResult = ReturnType<typeof useFolderContainerGetFoldersBySelectedNotesLazyQuery>;
export type FolderContainerGetFoldersBySelectedNotesQueryResult = Apollo.QueryResult<FolderContainerGetFoldersBySelectedNotesQuery, FolderContainerGetFoldersBySelectedNotesQueryVariables>;
export const FolderContainerGetInitialFolderDocument = gql`
    query FolderContainerGetInitialFolder($folderId: ID!, $active: Boolean, $foldersPerPage: Int!, $allCount: Int!) {
  folder(id: $folderId) {
    id
    fixedPath
    name
    fullName
    newNotePath
    lastModifiedAt
    archivedAt
    canBeManaged
    parent {
      id
    }
    components {
      id
      name
    }
    notes {
      totalCount
    }
    pinnedNotes(first: $allCount) {
      ...FolderContainerPinnedNotesFragment
    }
    folders(first: $foldersPerPage, active: $active) {
      totalCount
      nodes {
        ...FolderContainerFolderFragment
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${FolderContainerPinnedNotesFragmentFragmentDoc}
${FolderContainerFolderFragmentFragmentDoc}`;

/**
 * __useFolderContainerGetInitialFolderQuery__
 *
 * To run a query within a React component, call `useFolderContainerGetInitialFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerGetInitialFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderContainerGetInitialFolderQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      active: // value for 'active'
 *      foldersPerPage: // value for 'foldersPerPage'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useFolderContainerGetInitialFolderQuery(baseOptions: Apollo.QueryHookOptions<FolderContainerGetInitialFolderQuery, FolderContainerGetInitialFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderContainerGetInitialFolderQuery, FolderContainerGetInitialFolderQueryVariables>(FolderContainerGetInitialFolderDocument, options);
      }
export function useFolderContainerGetInitialFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderContainerGetInitialFolderQuery, FolderContainerGetInitialFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderContainerGetInitialFolderQuery, FolderContainerGetInitialFolderQueryVariables>(FolderContainerGetInitialFolderDocument, options);
        }
export type FolderContainerGetInitialFolderQueryHookResult = ReturnType<typeof useFolderContainerGetInitialFolderQuery>;
export type FolderContainerGetInitialFolderLazyQueryHookResult = ReturnType<typeof useFolderContainerGetInitialFolderLazyQuery>;
export type FolderContainerGetInitialFolderQueryResult = Apollo.QueryResult<FolderContainerGetInitialFolderQuery, FolderContainerGetInitialFolderQueryVariables>;
export const FolderContainerGetNotAttachedNotesDocument = gql`
    query FolderContainerGetNotAttachedNotes($groupId: ID!, $first: Int!, $after: String, $orderBy: NoteOrder!, $active: Boolean) {
  group(id: $groupId) {
    id
    notes(
      first: $first
      after: $after
      orderBy: $orderBy
      onlyNotAttachedFolder: true
      active: $active
    ) {
      ...FolderContainerNotesFragment
    }
  }
}
    ${FolderContainerNotesFragmentFragmentDoc}`;

/**
 * __useFolderContainerGetNotAttachedNotesQuery__
 *
 * To run a query within a React component, call `useFolderContainerGetNotAttachedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerGetNotAttachedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderContainerGetNotAttachedNotesQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useFolderContainerGetNotAttachedNotesQuery(baseOptions: Apollo.QueryHookOptions<FolderContainerGetNotAttachedNotesQuery, FolderContainerGetNotAttachedNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderContainerGetNotAttachedNotesQuery, FolderContainerGetNotAttachedNotesQueryVariables>(FolderContainerGetNotAttachedNotesDocument, options);
      }
export function useFolderContainerGetNotAttachedNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderContainerGetNotAttachedNotesQuery, FolderContainerGetNotAttachedNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderContainerGetNotAttachedNotesQuery, FolderContainerGetNotAttachedNotesQueryVariables>(FolderContainerGetNotAttachedNotesDocument, options);
        }
export type FolderContainerGetNotAttachedNotesQueryHookResult = ReturnType<typeof useFolderContainerGetNotAttachedNotesQuery>;
export type FolderContainerGetNotAttachedNotesLazyQueryHookResult = ReturnType<typeof useFolderContainerGetNotAttachedNotesLazyQuery>;
export type FolderContainerGetNotAttachedNotesQueryResult = Apollo.QueryResult<FolderContainerGetNotAttachedNotesQuery, FolderContainerGetNotAttachedNotesQueryVariables>;
export const FolderContainerGetNoteFoldersDocument = gql`
    query FolderContainerGetNoteFolders($noteId: ID!, $allCount: Int!) {
  note(id: $noteId) {
    folders(first: $allCount) {
      nodes {
        ...FolderContainerFolderFragment
      }
    }
  }
}
    ${FolderContainerFolderFragmentFragmentDoc}`;

/**
 * __useFolderContainerGetNoteFoldersQuery__
 *
 * To run a query within a React component, call `useFolderContainerGetNoteFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerGetNoteFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderContainerGetNoteFoldersQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useFolderContainerGetNoteFoldersQuery(baseOptions: Apollo.QueryHookOptions<FolderContainerGetNoteFoldersQuery, FolderContainerGetNoteFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderContainerGetNoteFoldersQuery, FolderContainerGetNoteFoldersQueryVariables>(FolderContainerGetNoteFoldersDocument, options);
      }
export function useFolderContainerGetNoteFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderContainerGetNoteFoldersQuery, FolderContainerGetNoteFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderContainerGetNoteFoldersQuery, FolderContainerGetNoteFoldersQueryVariables>(FolderContainerGetNoteFoldersDocument, options);
        }
export type FolderContainerGetNoteFoldersQueryHookResult = ReturnType<typeof useFolderContainerGetNoteFoldersQuery>;
export type FolderContainerGetNoteFoldersLazyQueryHookResult = ReturnType<typeof useFolderContainerGetNoteFoldersLazyQuery>;
export type FolderContainerGetNoteFoldersQueryResult = Apollo.QueryResult<FolderContainerGetNoteFoldersQuery, FolderContainerGetNoteFoldersQueryVariables>;
export const FolderContainerGetNotesInFolderDocument = gql`
    query FolderContainerGetNotesInFolder($folderId: ID!, $first: Int!, $after: String, $orderBy: NoteOrder!, $active: Boolean) {
  folder(id: $folderId) {
    id
    notes(first: $first, after: $after, orderBy: $orderBy, active: $active) {
      ...FolderContainerNotesFragment
    }
  }
}
    ${FolderContainerNotesFragmentFragmentDoc}`;

/**
 * __useFolderContainerGetNotesInFolderQuery__
 *
 * To run a query within a React component, call `useFolderContainerGetNotesInFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerGetNotesInFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderContainerGetNotesInFolderQuery({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useFolderContainerGetNotesInFolderQuery(baseOptions: Apollo.QueryHookOptions<FolderContainerGetNotesInFolderQuery, FolderContainerGetNotesInFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderContainerGetNotesInFolderQuery, FolderContainerGetNotesInFolderQueryVariables>(FolderContainerGetNotesInFolderDocument, options);
      }
export function useFolderContainerGetNotesInFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderContainerGetNotesInFolderQuery, FolderContainerGetNotesInFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderContainerGetNotesInFolderQuery, FolderContainerGetNotesInFolderQueryVariables>(FolderContainerGetNotesInFolderDocument, options);
        }
export type FolderContainerGetNotesInFolderQueryHookResult = ReturnType<typeof useFolderContainerGetNotesInFolderQuery>;
export type FolderContainerGetNotesInFolderLazyQueryHookResult = ReturnType<typeof useFolderContainerGetNotesInFolderLazyQuery>;
export type FolderContainerGetNotesInFolderQueryResult = Apollo.QueryResult<FolderContainerGetNotesInFolderQuery, FolderContainerGetNotesInFolderQueryVariables>;
export const FolderContainerGetRootFoldersDocument = gql`
    query FolderContainerGetRootFolders($groupId: ID!, $first: Int!, $after: String, $active: Boolean) {
  group(id: $groupId) {
    id
    name
    isJoined
    folders(parentFolderId: null, first: $first, after: $after, active: $active) {
      nodes {
        ...FolderContainerFolderFragment
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${FolderContainerFolderFragmentFragmentDoc}`;

/**
 * __useFolderContainerGetRootFoldersQuery__
 *
 * To run a query within a React component, call `useFolderContainerGetRootFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerGetRootFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderContainerGetRootFoldersQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useFolderContainerGetRootFoldersQuery(baseOptions: Apollo.QueryHookOptions<FolderContainerGetRootFoldersQuery, FolderContainerGetRootFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderContainerGetRootFoldersQuery, FolderContainerGetRootFoldersQueryVariables>(FolderContainerGetRootFoldersDocument, options);
      }
export function useFolderContainerGetRootFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderContainerGetRootFoldersQuery, FolderContainerGetRootFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderContainerGetRootFoldersQuery, FolderContainerGetRootFoldersQueryVariables>(FolderContainerGetRootFoldersDocument, options);
        }
export type FolderContainerGetRootFoldersQueryHookResult = ReturnType<typeof useFolderContainerGetRootFoldersQuery>;
export type FolderContainerGetRootFoldersLazyQueryHookResult = ReturnType<typeof useFolderContainerGetRootFoldersLazyQuery>;
export type FolderContainerGetRootFoldersQueryResult = Apollo.QueryResult<FolderContainerGetRootFoldersQuery, FolderContainerGetRootFoldersQueryVariables>;
export const FolderContainerRemoveFolderPinDocument = gql`
    mutation FolderContainerRemoveFolderPin($noteId: ID!, $folder: FolderInput, $allCount: Int!) {
  removeFolderPin(input: {noteId: $noteId, folder: $folder}) {
    folder {
      id
      pinnedNotes(first: $allCount) {
        ...FolderContainerPinnedNotesFragment
      }
    }
  }
}
    ${FolderContainerPinnedNotesFragmentFragmentDoc}`;
export type FolderContainerRemoveFolderPinMutationFn = Apollo.MutationFunction<FolderContainerRemoveFolderPinMutation, FolderContainerRemoveFolderPinMutationVariables>;

/**
 * __useFolderContainerRemoveFolderPinMutation__
 *
 * To run a mutation, you first call `useFolderContainerRemoveFolderPinMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerRemoveFolderPinMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderContainerRemoveFolderPinMutation, { data, loading, error }] = useFolderContainerRemoveFolderPinMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      folder: // value for 'folder'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useFolderContainerRemoveFolderPinMutation(baseOptions?: Apollo.MutationHookOptions<FolderContainerRemoveFolderPinMutation, FolderContainerRemoveFolderPinMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderContainerRemoveFolderPinMutation, FolderContainerRemoveFolderPinMutationVariables>(FolderContainerRemoveFolderPinDocument, options);
      }
export type FolderContainerRemoveFolderPinMutationHookResult = ReturnType<typeof useFolderContainerRemoveFolderPinMutation>;
export type FolderContainerRemoveFolderPinMutationResult = Apollo.MutationResult<FolderContainerRemoveFolderPinMutation>;
export type FolderContainerRemoveFolderPinMutationOptions = Apollo.BaseMutationOptions<FolderContainerRemoveFolderPinMutation, FolderContainerRemoveFolderPinMutationVariables>;
export const FolderContainerUpdateFolderNameDocument = gql`
    mutation FolderContainerUpdateFolderName($id: ID!, $name: String!) {
  updateFolderName(input: {id: $id, name: $name}) {
    foldersCacheKey
    folder {
      id
      path
      name
      fullName
      components {
        id
        name
      }
    }
  }
}
    `;
export type FolderContainerUpdateFolderNameMutationFn = Apollo.MutationFunction<FolderContainerUpdateFolderNameMutation, FolderContainerUpdateFolderNameMutationVariables>;

/**
 * __useFolderContainerUpdateFolderNameMutation__
 *
 * To run a mutation, you first call `useFolderContainerUpdateFolderNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerUpdateFolderNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderContainerUpdateFolderNameMutation, { data, loading, error }] = useFolderContainerUpdateFolderNameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useFolderContainerUpdateFolderNameMutation(baseOptions?: Apollo.MutationHookOptions<FolderContainerUpdateFolderNameMutation, FolderContainerUpdateFolderNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderContainerUpdateFolderNameMutation, FolderContainerUpdateFolderNameMutationVariables>(FolderContainerUpdateFolderNameDocument, options);
      }
export type FolderContainerUpdateFolderNameMutationHookResult = ReturnType<typeof useFolderContainerUpdateFolderNameMutation>;
export type FolderContainerUpdateFolderNameMutationResult = Apollo.MutationResult<FolderContainerUpdateFolderNameMutation>;
export type FolderContainerUpdateFolderNameMutationOptions = Apollo.BaseMutationOptions<FolderContainerUpdateFolderNameMutation, FolderContainerUpdateFolderNameMutationVariables>;
export const FolderContainerUpdateFolderParentDocument = gql`
    mutation FolderContainerUpdateFolderParent($folderId: ID!, $folderFullName: String) {
  updateFolderParent(
    input: {folderId: $folderId, folderFullName: $folderFullName}
  ) {
    foldersCacheKey
    folder {
      parent {
        id
      }
      group {
        id
      }
    }
  }
}
    `;
export type FolderContainerUpdateFolderParentMutationFn = Apollo.MutationFunction<FolderContainerUpdateFolderParentMutation, FolderContainerUpdateFolderParentMutationVariables>;

/**
 * __useFolderContainerUpdateFolderParentMutation__
 *
 * To run a mutation, you first call `useFolderContainerUpdateFolderParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderContainerUpdateFolderParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderContainerUpdateFolderParentMutation, { data, loading, error }] = useFolderContainerUpdateFolderParentMutation({
 *   variables: {
 *      folderId: // value for 'folderId'
 *      folderFullName: // value for 'folderFullName'
 *   },
 * });
 */
export function useFolderContainerUpdateFolderParentMutation(baseOptions?: Apollo.MutationHookOptions<FolderContainerUpdateFolderParentMutation, FolderContainerUpdateFolderParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderContainerUpdateFolderParentMutation, FolderContainerUpdateFolderParentMutationVariables>(FolderContainerUpdateFolderParentDocument, options);
      }
export type FolderContainerUpdateFolderParentMutationHookResult = ReturnType<typeof useFolderContainerUpdateFolderParentMutation>;
export type FolderContainerUpdateFolderParentMutationResult = Apollo.MutationResult<FolderContainerUpdateFolderParentMutation>;
export type FolderContainerUpdateFolderParentMutationOptions = Apollo.BaseMutationOptions<FolderContainerUpdateFolderParentMutation, FolderContainerUpdateFolderParentMutationVariables>;
export const FolderSelectedItemActionBoxArchiveFoldersDocument = gql`
    mutation FolderSelectedItemActionBoxArchiveFolders($ids: [ID!]!) {
  archiveFolders(input: {ids: $ids}) {
    foldersCacheKey
    folders {
      id
      archivedAt
    }
  }
}
    `;
export type FolderSelectedItemActionBoxArchiveFoldersMutationFn = Apollo.MutationFunction<FolderSelectedItemActionBoxArchiveFoldersMutation, FolderSelectedItemActionBoxArchiveFoldersMutationVariables>;

/**
 * __useFolderSelectedItemActionBoxArchiveFoldersMutation__
 *
 * To run a mutation, you first call `useFolderSelectedItemActionBoxArchiveFoldersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderSelectedItemActionBoxArchiveFoldersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderSelectedItemActionBoxArchiveFoldersMutation, { data, loading, error }] = useFolderSelectedItemActionBoxArchiveFoldersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFolderSelectedItemActionBoxArchiveFoldersMutation(baseOptions?: Apollo.MutationHookOptions<FolderSelectedItemActionBoxArchiveFoldersMutation, FolderSelectedItemActionBoxArchiveFoldersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderSelectedItemActionBoxArchiveFoldersMutation, FolderSelectedItemActionBoxArchiveFoldersMutationVariables>(FolderSelectedItemActionBoxArchiveFoldersDocument, options);
      }
export type FolderSelectedItemActionBoxArchiveFoldersMutationHookResult = ReturnType<typeof useFolderSelectedItemActionBoxArchiveFoldersMutation>;
export type FolderSelectedItemActionBoxArchiveFoldersMutationResult = Apollo.MutationResult<FolderSelectedItemActionBoxArchiveFoldersMutation>;
export type FolderSelectedItemActionBoxArchiveFoldersMutationOptions = Apollo.BaseMutationOptions<FolderSelectedItemActionBoxArchiveFoldersMutation, FolderSelectedItemActionBoxArchiveFoldersMutationVariables>;
export const FolderSelectedItemActionBoxArchiveNotesDocument = gql`
    mutation FolderSelectedItemActionBoxArchiveNotes($ids: [ID!]!) {
  archiveNotes(input: {ids: $ids}) {
    notes {
      id
      isArchived
    }
  }
}
    `;
export type FolderSelectedItemActionBoxArchiveNotesMutationFn = Apollo.MutationFunction<FolderSelectedItemActionBoxArchiveNotesMutation, FolderSelectedItemActionBoxArchiveNotesMutationVariables>;

/**
 * __useFolderSelectedItemActionBoxArchiveNotesMutation__
 *
 * To run a mutation, you first call `useFolderSelectedItemActionBoxArchiveNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFolderSelectedItemActionBoxArchiveNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [folderSelectedItemActionBoxArchiveNotesMutation, { data, loading, error }] = useFolderSelectedItemActionBoxArchiveNotesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useFolderSelectedItemActionBoxArchiveNotesMutation(baseOptions?: Apollo.MutationHookOptions<FolderSelectedItemActionBoxArchiveNotesMutation, FolderSelectedItemActionBoxArchiveNotesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FolderSelectedItemActionBoxArchiveNotesMutation, FolderSelectedItemActionBoxArchiveNotesMutationVariables>(FolderSelectedItemActionBoxArchiveNotesDocument, options);
      }
export type FolderSelectedItemActionBoxArchiveNotesMutationHookResult = ReturnType<typeof useFolderSelectedItemActionBoxArchiveNotesMutation>;
export type FolderSelectedItemActionBoxArchiveNotesMutationResult = Apollo.MutationResult<FolderSelectedItemActionBoxArchiveNotesMutation>;
export type FolderSelectedItemActionBoxArchiveNotesMutationOptions = Apollo.BaseMutationOptions<FolderSelectedItemActionBoxArchiveNotesMutation, FolderSelectedItemActionBoxArchiveNotesMutationVariables>;
export const FolderSelectedItemActionBoxValidateToMoveDocument = gql`
    query FolderSelectedItemActionBoxValidateToMove($parentId: ID, $folderIds: [ID!]!) {
  validateToMove(parentId: $parentId, folderIds: $folderIds)
}
    `;

/**
 * __useFolderSelectedItemActionBoxValidateToMoveQuery__
 *
 * To run a query within a React component, call `useFolderSelectedItemActionBoxValidateToMoveQuery` and pass it any options that fit your needs.
 * When your component renders, `useFolderSelectedItemActionBoxValidateToMoveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFolderSelectedItemActionBoxValidateToMoveQuery({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      folderIds: // value for 'folderIds'
 *   },
 * });
 */
export function useFolderSelectedItemActionBoxValidateToMoveQuery(baseOptions: Apollo.QueryHookOptions<FolderSelectedItemActionBoxValidateToMoveQuery, FolderSelectedItemActionBoxValidateToMoveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FolderSelectedItemActionBoxValidateToMoveQuery, FolderSelectedItemActionBoxValidateToMoveQueryVariables>(FolderSelectedItemActionBoxValidateToMoveDocument, options);
      }
export function useFolderSelectedItemActionBoxValidateToMoveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FolderSelectedItemActionBoxValidateToMoveQuery, FolderSelectedItemActionBoxValidateToMoveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FolderSelectedItemActionBoxValidateToMoveQuery, FolderSelectedItemActionBoxValidateToMoveQueryVariables>(FolderSelectedItemActionBoxValidateToMoveDocument, options);
        }
export type FolderSelectedItemActionBoxValidateToMoveQueryHookResult = ReturnType<typeof useFolderSelectedItemActionBoxValidateToMoveQuery>;
export type FolderSelectedItemActionBoxValidateToMoveLazyQueryHookResult = ReturnType<typeof useFolderSelectedItemActionBoxValidateToMoveLazyQuery>;
export type FolderSelectedItemActionBoxValidateToMoveQueryResult = Apollo.QueryResult<FolderSelectedItemActionBoxValidateToMoveQuery, FolderSelectedItemActionBoxValidateToMoveQueryVariables>;
export const GroupListContainerJoinGroupDocument = gql`
    mutation GroupListContainerJoinGroup($groupId: ID!, $userId: ID!) {
  joinGroup(input: {groupId: $groupId, userId: $userId}) {
    clientMutationId
    group {
      canBeManaged
    }
  }
}
    `;
export type GroupListContainerJoinGroupMutationFn = Apollo.MutationFunction<GroupListContainerJoinGroupMutation, GroupListContainerJoinGroupMutationVariables>;

/**
 * __useGroupListContainerJoinGroupMutation__
 *
 * To run a mutation, you first call `useGroupListContainerJoinGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupListContainerJoinGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupListContainerJoinGroupMutation, { data, loading, error }] = useGroupListContainerJoinGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGroupListContainerJoinGroupMutation(baseOptions?: Apollo.MutationHookOptions<GroupListContainerJoinGroupMutation, GroupListContainerJoinGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupListContainerJoinGroupMutation, GroupListContainerJoinGroupMutationVariables>(GroupListContainerJoinGroupDocument, options);
      }
export type GroupListContainerJoinGroupMutationHookResult = ReturnType<typeof useGroupListContainerJoinGroupMutation>;
export type GroupListContainerJoinGroupMutationResult = Apollo.MutationResult<GroupListContainerJoinGroupMutation>;
export type GroupListContainerJoinGroupMutationOptions = Apollo.BaseMutationOptions<GroupListContainerJoinGroupMutation, GroupListContainerJoinGroupMutationVariables>;
export const GroupListContainerLeaveGroupDocument = gql`
    mutation GroupListContainerLeaveGroup($groupId: ID!, $userId: ID!) {
  leaveGroup(input: {groupId: $groupId, userId: $userId}) {
    clientMutationId
    group {
      canBeManaged
      canBeJoined
    }
  }
}
    `;
export type GroupListContainerLeaveGroupMutationFn = Apollo.MutationFunction<GroupListContainerLeaveGroupMutation, GroupListContainerLeaveGroupMutationVariables>;

/**
 * __useGroupListContainerLeaveGroupMutation__
 *
 * To run a mutation, you first call `useGroupListContainerLeaveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGroupListContainerLeaveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [groupListContainerLeaveGroupMutation, { data, loading, error }] = useGroupListContainerLeaveGroupMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGroupListContainerLeaveGroupMutation(baseOptions?: Apollo.MutationHookOptions<GroupListContainerLeaveGroupMutation, GroupListContainerLeaveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GroupListContainerLeaveGroupMutation, GroupListContainerLeaveGroupMutationVariables>(GroupListContainerLeaveGroupDocument, options);
      }
export type GroupListContainerLeaveGroupMutationHookResult = ReturnType<typeof useGroupListContainerLeaveGroupMutation>;
export type GroupListContainerLeaveGroupMutationResult = Apollo.MutationResult<GroupListContainerLeaveGroupMutation>;
export type GroupListContainerLeaveGroupMutationOptions = Apollo.BaseMutationOptions<GroupListContainerLeaveGroupMutation, GroupListContainerLeaveGroupMutationVariables>;
export const UserListInManageMembersDisableUserDocument = gql`
    mutation UserListInManageMembersDisableUser($userId: ID!) {
  disableUser(input: {id: $userId}) {
    clientMutationId
  }
}
    `;
export type UserListInManageMembersDisableUserMutationFn = Apollo.MutationFunction<UserListInManageMembersDisableUserMutation, UserListInManageMembersDisableUserMutationVariables>;

/**
 * __useUserListInManageMembersDisableUserMutation__
 *
 * To run a mutation, you first call `useUserListInManageMembersDisableUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserListInManageMembersDisableUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userListInManageMembersDisableUserMutation, { data, loading, error }] = useUserListInManageMembersDisableUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserListInManageMembersDisableUserMutation(baseOptions?: Apollo.MutationHookOptions<UserListInManageMembersDisableUserMutation, UserListInManageMembersDisableUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserListInManageMembersDisableUserMutation, UserListInManageMembersDisableUserMutationVariables>(UserListInManageMembersDisableUserDocument, options);
      }
export type UserListInManageMembersDisableUserMutationHookResult = ReturnType<typeof useUserListInManageMembersDisableUserMutation>;
export type UserListInManageMembersDisableUserMutationResult = Apollo.MutationResult<UserListInManageMembersDisableUserMutation>;
export type UserListInManageMembersDisableUserMutationOptions = Apollo.BaseMutationOptions<UserListInManageMembersDisableUserMutation, UserListInManageMembersDisableUserMutationVariables>;
export const DisableUsersDocument = gql`
    mutation DisableUsers($ids: [ID!]!) {
  disableUsers(input: {ids: $ids}) {
    clientMutationId
  }
}
    `;
export type DisableUsersMutationFn = Apollo.MutationFunction<DisableUsersMutation, DisableUsersMutationVariables>;

/**
 * __useDisableUsersMutation__
 *
 * To run a mutation, you first call `useDisableUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableUsersMutation, { data, loading, error }] = useDisableUsersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDisableUsersMutation(baseOptions?: Apollo.MutationHookOptions<DisableUsersMutation, DisableUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableUsersMutation, DisableUsersMutationVariables>(DisableUsersDocument, options);
      }
export type DisableUsersMutationHookResult = ReturnType<typeof useDisableUsersMutation>;
export type DisableUsersMutationResult = Apollo.MutationResult<DisableUsersMutation>;
export type DisableUsersMutationOptions = Apollo.BaseMutationOptions<DisableUsersMutation, DisableUsersMutationVariables>;
export const UserListInManageMembersIgnoreMfaDocument = gql`
    mutation UserListInManageMembersIgnoreMfa($userId: ID!) {
  ignoreMultiFactorAuthn(input: {userId: $userId}) {
    clientMutationId
  }
}
    `;
export type UserListInManageMembersIgnoreMfaMutationFn = Apollo.MutationFunction<UserListInManageMembersIgnoreMfaMutation, UserListInManageMembersIgnoreMfaMutationVariables>;

/**
 * __useUserListInManageMembersIgnoreMfaMutation__
 *
 * To run a mutation, you first call `useUserListInManageMembersIgnoreMfaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserListInManageMembersIgnoreMfaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userListInManageMembersIgnoreMfaMutation, { data, loading, error }] = useUserListInManageMembersIgnoreMfaMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserListInManageMembersIgnoreMfaMutation(baseOptions?: Apollo.MutationHookOptions<UserListInManageMembersIgnoreMfaMutation, UserListInManageMembersIgnoreMfaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserListInManageMembersIgnoreMfaMutation, UserListInManageMembersIgnoreMfaMutationVariables>(UserListInManageMembersIgnoreMfaDocument, options);
      }
export type UserListInManageMembersIgnoreMfaMutationHookResult = ReturnType<typeof useUserListInManageMembersIgnoreMfaMutation>;
export type UserListInManageMembersIgnoreMfaMutationResult = Apollo.MutationResult<UserListInManageMembersIgnoreMfaMutation>;
export type UserListInManageMembersIgnoreMfaMutationOptions = Apollo.BaseMutationOptions<UserListInManageMembersIgnoreMfaMutation, UserListInManageMembersIgnoreMfaMutationVariables>;
export const IgnoreMfaForMultipleUsersDocument = gql`
    mutation IgnoreMfaForMultipleUsers($ids: [ID!]!) {
  ignoreMultiFactorAuthnForMultipleUsers(input: {userIds: $ids}) {
    clientMutationId
  }
}
    `;
export type IgnoreMfaForMultipleUsersMutationFn = Apollo.MutationFunction<IgnoreMfaForMultipleUsersMutation, IgnoreMfaForMultipleUsersMutationVariables>;

/**
 * __useIgnoreMfaForMultipleUsersMutation__
 *
 * To run a mutation, you first call `useIgnoreMfaForMultipleUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreMfaForMultipleUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreMfaForMultipleUsersMutation, { data, loading, error }] = useIgnoreMfaForMultipleUsersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useIgnoreMfaForMultipleUsersMutation(baseOptions?: Apollo.MutationHookOptions<IgnoreMfaForMultipleUsersMutation, IgnoreMfaForMultipleUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnoreMfaForMultipleUsersMutation, IgnoreMfaForMultipleUsersMutationVariables>(IgnoreMfaForMultipleUsersDocument, options);
      }
export type IgnoreMfaForMultipleUsersMutationHookResult = ReturnType<typeof useIgnoreMfaForMultipleUsersMutation>;
export type IgnoreMfaForMultipleUsersMutationResult = Apollo.MutationResult<IgnoreMfaForMultipleUsersMutation>;
export type IgnoreMfaForMultipleUsersMutationOptions = Apollo.BaseMutationOptions<IgnoreMfaForMultipleUsersMutation, IgnoreMfaForMultipleUsersMutationVariables>;
export const ArchiveNoteDocument = gql`
    mutation ArchiveNote($id: ID!) {
  archiveNote(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type ArchiveNoteMutationFn = Apollo.MutationFunction<ArchiveNoteMutation, ArchiveNoteMutationVariables>;

/**
 * __useArchiveNoteMutation__
 *
 * To run a mutation, you first call `useArchiveNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveNoteMutation, { data, loading, error }] = useArchiveNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveNoteMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveNoteMutation, ArchiveNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveNoteMutation, ArchiveNoteMutationVariables>(ArchiveNoteDocument, options);
      }
export type ArchiveNoteMutationHookResult = ReturnType<typeof useArchiveNoteMutation>;
export type ArchiveNoteMutationResult = Apollo.MutationResult<ArchiveNoteMutation>;
export type ArchiveNoteMutationOptions = Apollo.BaseMutationOptions<ArchiveNoteMutation, ArchiveNoteMutationVariables>;
export const NoteContainerCollabModeDataDocument = gql`
    query NoteContainerCollabModeData($noteId: ID!, $allCount: Int!) {
  collabModeData(noteId: $noteId) {
    title
    content
    contentHtml
    contentTocHtml
    publishPlacesChanged
    groups {
      id
      name
      path
      isPrivate
      isJoined
      isArchived
    }
    folders(first: $allCount) {
      nodes {
        ...FolderForNoteHeader
      }
    }
    memberCount
  }
}
    ${FolderForNoteHeaderFragmentDoc}`;

/**
 * __useNoteContainerCollabModeDataQuery__
 *
 * To run a query within a React component, call `useNoteContainerCollabModeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteContainerCollabModeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteContainerCollabModeDataQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useNoteContainerCollabModeDataQuery(baseOptions: Apollo.QueryHookOptions<NoteContainerCollabModeDataQuery, NoteContainerCollabModeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteContainerCollabModeDataQuery, NoteContainerCollabModeDataQueryVariables>(NoteContainerCollabModeDataDocument, options);
      }
export function useNoteContainerCollabModeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteContainerCollabModeDataQuery, NoteContainerCollabModeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteContainerCollabModeDataQuery, NoteContainerCollabModeDataQueryVariables>(NoteContainerCollabModeDataDocument, options);
        }
export type NoteContainerCollabModeDataQueryHookResult = ReturnType<typeof useNoteContainerCollabModeDataQuery>;
export type NoteContainerCollabModeDataLazyQueryHookResult = ReturnType<typeof useNoteContainerCollabModeDataLazyQuery>;
export type NoteContainerCollabModeDataQueryResult = Apollo.QueryResult<NoteContainerCollabModeDataQuery, NoteContainerCollabModeDataQueryVariables>;
export const GetNoteForNoteContainerDocument = gql`
    query GetNoteForNoteContainer($id: ID!, $allCount: Int!) {
  note(id: $id) {
    id
    title
    content
    contentHtml
    contentTocHtml
    publishedAt
    contentUpdatedAt
    isArchived
    groups {
      id
      name
      path
      isPrivate
      isJoined
      isArchived
    }
    folders(first: $allCount) {
      nodes {
        ...FolderForNoteHeader
      }
    }
    selectableGroups(first: $allCount) {
      nodes {
        id
        name
        path
        isPrivate
      }
    }
    contributors(first: $allCount) {
      totalCount
      edges {
        node {
          id
          path
          account
          realName
          avatar1x: avatarImage(size: LARGE, density: 1) {
            url
          }
          avatar2x: avatarImage(size: LARGE, density: 2) {
            url
          }
        }
      }
    }
    likers(first: $allCount) {
      totalCount
      edges {
        node {
          id
          account
          avatar1x: avatarImage(size: SMALL, density: 1) {
            url
          }
          avatar2x: avatarImage(size: SMALL, density: 2) {
            url
          }
        }
      }
    }
    canBeLiked
    isLikedByCurrentUser
    canBeUpdated
    coeditRoom {
      activeUserAccounts
    }
    hasCollabHistory
  }
}
    ${FolderForNoteHeaderFragmentDoc}`;

/**
 * __useGetNoteForNoteContainerQuery__
 *
 * To run a query within a React component, call `useGetNoteForNoteContainerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteForNoteContainerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteForNoteContainerQuery({
 *   variables: {
 *      id: // value for 'id'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useGetNoteForNoteContainerQuery(baseOptions: Apollo.QueryHookOptions<GetNoteForNoteContainerQuery, GetNoteForNoteContainerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteForNoteContainerQuery, GetNoteForNoteContainerQueryVariables>(GetNoteForNoteContainerDocument, options);
      }
export function useGetNoteForNoteContainerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteForNoteContainerQuery, GetNoteForNoteContainerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteForNoteContainerQuery, GetNoteForNoteContainerQueryVariables>(GetNoteForNoteContainerDocument, options);
        }
export type GetNoteForNoteContainerQueryHookResult = ReturnType<typeof useGetNoteForNoteContainerQuery>;
export type GetNoteForNoteContainerLazyQueryHookResult = ReturnType<typeof useGetNoteForNoteContainerLazyQuery>;
export type GetNoteForNoteContainerQueryResult = Apollo.QueryResult<GetNoteForNoteContainerQuery, GetNoteForNoteContainerQueryVariables>;
export const UpdateNoteContentForTaskListDocument = gql`
    mutation UpdateNoteContentForTaskList($input: UpdateNoteContentInput!) {
  updateNoteContent(input: $input) {
    note {
      content
      contentHtml
    }
  }
}
    `;
export type UpdateNoteContentForTaskListMutationFn = Apollo.MutationFunction<UpdateNoteContentForTaskListMutation, UpdateNoteContentForTaskListMutationVariables>;

/**
 * __useUpdateNoteContentForTaskListMutation__
 *
 * To run a mutation, you first call `useUpdateNoteContentForTaskListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteContentForTaskListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteContentForTaskListMutation, { data, loading, error }] = useUpdateNoteContentForTaskListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteContentForTaskListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteContentForTaskListMutation, UpdateNoteContentForTaskListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteContentForTaskListMutation, UpdateNoteContentForTaskListMutationVariables>(UpdateNoteContentForTaskListDocument, options);
      }
export type UpdateNoteContentForTaskListMutationHookResult = ReturnType<typeof useUpdateNoteContentForTaskListMutation>;
export type UpdateNoteContentForTaskListMutationResult = Apollo.MutationResult<UpdateNoteContentForTaskListMutation>;
export type UpdateNoteContentForTaskListMutationOptions = Apollo.BaseMutationOptions<UpdateNoteContentForTaskListMutation, UpdateNoteContentForTaskListMutationVariables>;
export const GetRelatedNotesDocument = gql`
    query GetRelatedNotes($noteId: ID!, $trackbackNoteCount: Int!, $lastTrackbackNote: String) {
  note(id: $noteId) {
    ...TrackbackNoteForRelatedNoteContainer
    relatedNotes(first: 3) {
      nodes {
        title
        path
        author {
          account
          path
          avatar1x: avatarImage(size: SMALL, density: 1) {
            url
          }
          avatar2x: avatarImage(size: SMALL, density: 2) {
            url
          }
        }
        document {
          ... on Note {
            id
            groups {
              id
              name
              path
              isPrivate
              isArchived
            }
            folders(first: 10) {
              nodes {
                ...FolderForIndicator
              }
            }
          }
        }
      }
    }
  }
}
    ${TrackbackNoteForRelatedNoteContainerFragmentDoc}
${FolderForIndicatorFragmentDoc}`;

/**
 * __useGetRelatedNotesQuery__
 *
 * To run a query within a React component, call `useGetRelatedNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedNotesQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      trackbackNoteCount: // value for 'trackbackNoteCount'
 *      lastTrackbackNote: // value for 'lastTrackbackNote'
 *   },
 * });
 */
export function useGetRelatedNotesQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedNotesQuery, GetRelatedNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedNotesQuery, GetRelatedNotesQueryVariables>(GetRelatedNotesDocument, options);
      }
export function useGetRelatedNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedNotesQuery, GetRelatedNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedNotesQuery, GetRelatedNotesQueryVariables>(GetRelatedNotesDocument, options);
        }
export type GetRelatedNotesQueryHookResult = ReturnType<typeof useGetRelatedNotesQuery>;
export type GetRelatedNotesLazyQueryHookResult = ReturnType<typeof useGetRelatedNotesLazyQuery>;
export type GetRelatedNotesQueryResult = Apollo.QueryResult<GetRelatedNotesQuery, GetRelatedNotesQueryVariables>;
export const GetTrackbackNotesDocument = gql`
    query GetTrackbackNotes($noteId: ID!, $trackbackNoteCount: Int!, $lastTrackbackNote: String!) {
  note(id: $noteId) {
    ...TrackbackNoteForRelatedNoteContainer
  }
}
    ${TrackbackNoteForRelatedNoteContainerFragmentDoc}`;

/**
 * __useGetTrackbackNotesQuery__
 *
 * To run a query within a React component, call `useGetTrackbackNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrackbackNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrackbackNotesQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      trackbackNoteCount: // value for 'trackbackNoteCount'
 *      lastTrackbackNote: // value for 'lastTrackbackNote'
 *   },
 * });
 */
export function useGetTrackbackNotesQuery(baseOptions: Apollo.QueryHookOptions<GetTrackbackNotesQuery, GetTrackbackNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrackbackNotesQuery, GetTrackbackNotesQueryVariables>(GetTrackbackNotesDocument, options);
      }
export function useGetTrackbackNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrackbackNotesQuery, GetTrackbackNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrackbackNotesQuery, GetTrackbackNotesQueryVariables>(GetTrackbackNotesDocument, options);
        }
export type GetTrackbackNotesQueryHookResult = ReturnType<typeof useGetTrackbackNotesQuery>;
export type GetTrackbackNotesLazyQueryHookResult = ReturnType<typeof useGetTrackbackNotesLazyQuery>;
export type GetTrackbackNotesQueryResult = Apollo.QueryResult<GetTrackbackNotesQuery, GetTrackbackNotesQueryVariables>;
export const RestoreNoteDocument = gql`
    mutation RestoreNote($id: ID!) {
  restoreNote(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type RestoreNoteMutationFn = Apollo.MutationFunction<RestoreNoteMutation, RestoreNoteMutationVariables>;

/**
 * __useRestoreNoteMutation__
 *
 * To run a mutation, you first call `useRestoreNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreNoteMutation, { data, loading, error }] = useRestoreNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRestoreNoteMutation(baseOptions?: Apollo.MutationHookOptions<RestoreNoteMutation, RestoreNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreNoteMutation, RestoreNoteMutationVariables>(RestoreNoteDocument, options);
      }
export type RestoreNoteMutationHookResult = ReturnType<typeof useRestoreNoteMutation>;
export type RestoreNoteMutationResult = Apollo.MutationResult<RestoreNoteMutation>;
export type RestoreNoteMutationOptions = Apollo.BaseMutationOptions<RestoreNoteMutation, RestoreNoteMutationVariables>;
export const ListServiceNotificationsDocument = gql`
    query ListServiceNotifications($first: Int!) {
  serviceNotifications(first: $first) {
    nodes {
      id
      titleJa
      titleEn
      messageJa
      messageEn
      urlJa
      urlEn
      notificationKind
      read
      startAt
    }
  }
}
    `;

/**
 * __useListServiceNotificationsQuery__
 *
 * To run a query within a React component, call `useListServiceNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListServiceNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListServiceNotificationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListServiceNotificationsQuery(baseOptions: Apollo.QueryHookOptions<ListServiceNotificationsQuery, ListServiceNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListServiceNotificationsQuery, ListServiceNotificationsQueryVariables>(ListServiceNotificationsDocument, options);
      }
export function useListServiceNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListServiceNotificationsQuery, ListServiceNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListServiceNotificationsQuery, ListServiceNotificationsQueryVariables>(ListServiceNotificationsDocument, options);
        }
export type ListServiceNotificationsQueryHookResult = ReturnType<typeof useListServiceNotificationsQuery>;
export type ListServiceNotificationsLazyQueryHookResult = ReturnType<typeof useListServiceNotificationsLazyQuery>;
export type ListServiceNotificationsQueryResult = Apollo.QueryResult<ListServiceNotificationsQuery, ListServiceNotificationsQueryVariables>;
export const MarkServiceNotificationAsReadDocument = gql`
    mutation markServiceNotificationAsRead($serviceNotificationIds: [ID!]!) {
  markServiceNotificationsAsRead(
    input: {serviceNotificationIds: $serviceNotificationIds}
  ) {
    clientMutationId
  }
}
    `;
export type MarkServiceNotificationAsReadMutationFn = Apollo.MutationFunction<MarkServiceNotificationAsReadMutation, MarkServiceNotificationAsReadMutationVariables>;

/**
 * __useMarkServiceNotificationAsReadMutation__
 *
 * To run a mutation, you first call `useMarkServiceNotificationAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkServiceNotificationAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markServiceNotificationAsReadMutation, { data, loading, error }] = useMarkServiceNotificationAsReadMutation({
 *   variables: {
 *      serviceNotificationIds: // value for 'serviceNotificationIds'
 *   },
 * });
 */
export function useMarkServiceNotificationAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkServiceNotificationAsReadMutation, MarkServiceNotificationAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkServiceNotificationAsReadMutation, MarkServiceNotificationAsReadMutationVariables>(MarkServiceNotificationAsReadDocument, options);
      }
export type MarkServiceNotificationAsReadMutationHookResult = ReturnType<typeof useMarkServiceNotificationAsReadMutation>;
export type MarkServiceNotificationAsReadMutationResult = Apollo.MutationResult<MarkServiceNotificationAsReadMutation>;
export type MarkServiceNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<MarkServiceNotificationAsReadMutation, MarkServiceNotificationAsReadMutationVariables>;
export const GetCoeditTokenDocument = gql`
    query GetCoeditToken($noteId: ID!) {
  coeditToken(noteId: $noteId)
}
    `;

/**
 * __useGetCoeditTokenQuery__
 *
 * To run a query within a React component, call `useGetCoeditTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoeditTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoeditTokenQuery({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useGetCoeditTokenQuery(baseOptions: Apollo.QueryHookOptions<GetCoeditTokenQuery, GetCoeditTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoeditTokenQuery, GetCoeditTokenQueryVariables>(GetCoeditTokenDocument, options);
      }
export function useGetCoeditTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoeditTokenQuery, GetCoeditTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoeditTokenQuery, GetCoeditTokenQueryVariables>(GetCoeditTokenDocument, options);
        }
export type GetCoeditTokenQueryHookResult = ReturnType<typeof useGetCoeditTokenQuery>;
export type GetCoeditTokenLazyQueryHookResult = ReturnType<typeof useGetCoeditTokenLazyQuery>;
export type GetCoeditTokenQueryResult = Apollo.QueryResult<GetCoeditTokenQuery, GetCoeditTokenQueryVariables>;
export const GetExternalUrlDataDocument = gql`
    query GetExternalUrlData($url: String!) {
  externalUrlData(url: $url) {
    title
    description
    favicon
    og {
      title
      description
      url
      image {
        url
        secureUrl
        alt
        width
        height
      }
    }
  }
}
    `;

/**
 * __useGetExternalUrlDataQuery__
 *
 * To run a query within a React component, call `useGetExternalUrlDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalUrlDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalUrlDataQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetExternalUrlDataQuery(baseOptions: Apollo.QueryHookOptions<GetExternalUrlDataQuery, GetExternalUrlDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalUrlDataQuery, GetExternalUrlDataQueryVariables>(GetExternalUrlDataDocument, options);
      }
export function useGetExternalUrlDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalUrlDataQuery, GetExternalUrlDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalUrlDataQuery, GetExternalUrlDataQueryVariables>(GetExternalUrlDataDocument, options);
        }
export type GetExternalUrlDataQueryHookResult = ReturnType<typeof useGetExternalUrlDataQuery>;
export type GetExternalUrlDataLazyQueryHookResult = ReturnType<typeof useGetExternalUrlDataLazyQuery>;
export type GetExternalUrlDataQueryResult = Apollo.QueryResult<GetExternalUrlDataQuery, GetExternalUrlDataQueryVariables>;
export const GetInternalUrlDataDocument = gql`
    query GetInternalUrlData($url: String!) {
  internalUrlData(url: $url) {
    title
    linkType
    isCoediting
    avatar1xUrl
    avatar2xUrl
  }
}
    `;

/**
 * __useGetInternalUrlDataQuery__
 *
 * To run a query within a React component, call `useGetInternalUrlDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternalUrlDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternalUrlDataQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetInternalUrlDataQuery(baseOptions: Apollo.QueryHookOptions<GetInternalUrlDataQuery, GetInternalUrlDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternalUrlDataQuery, GetInternalUrlDataQueryVariables>(GetInternalUrlDataDocument, options);
      }
export function useGetInternalUrlDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternalUrlDataQuery, GetInternalUrlDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternalUrlDataQuery, GetInternalUrlDataQueryVariables>(GetInternalUrlDataDocument, options);
        }
export type GetInternalUrlDataQueryHookResult = ReturnType<typeof useGetInternalUrlDataQuery>;
export type GetInternalUrlDataLazyQueryHookResult = ReturnType<typeof useGetInternalUrlDataLazyQuery>;
export type GetInternalUrlDataQueryResult = Apollo.QueryResult<GetInternalUrlDataQuery, GetInternalUrlDataQueryVariables>;
export const GetSearchMemberResultDocument = gql`
    query GetSearchMemberResult($query: String!) {
  users(query: $query, confirmed: true, enabled: true, first: 3) {
    totalCount
    edges {
      node {
        account
        realName
        avatar1x: avatarImage(size: MEDIUM, density: 1) {
          url
        }
        avatar2x: avatarImage(size: MEDIUM, density: 2) {
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetSearchMemberResultQuery__
 *
 * To run a query within a React component, call `useGetSearchMemberResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchMemberResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchMemberResultQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetSearchMemberResultQuery(baseOptions: Apollo.QueryHookOptions<GetSearchMemberResultQuery, GetSearchMemberResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchMemberResultQuery, GetSearchMemberResultQueryVariables>(GetSearchMemberResultDocument, options);
      }
export function useGetSearchMemberResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchMemberResultQuery, GetSearchMemberResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchMemberResultQuery, GetSearchMemberResultQueryVariables>(GetSearchMemberResultDocument, options);
        }
export type GetSearchMemberResultQueryHookResult = ReturnType<typeof useGetSearchMemberResultQuery>;
export type GetSearchMemberResultLazyQueryHookResult = ReturnType<typeof useGetSearchMemberResultLazyQuery>;
export type GetSearchMemberResultQueryResult = Apollo.QueryResult<GetSearchMemberResultQuery, GetSearchMemberResultQueryVariables>;
export const GetSearchResultDocument = gql`
    query GetSearchResult($query: String!) {
  search(query: $query, first: 8) {
    totalCount
    edges {
      node {
        path
        titleHtml
        contentUpdatedAt
        contributors(first: 2) {
          totalCount
          edges {
            node {
              id
              account
              avatar1x: avatarImage(size: SMALL, density: 1) {
                url
              }
              avatar2x: avatarImage(size: SMALL, density: 2) {
                url
              }
            }
          }
        }
        document {
          __typename
        }
      }
    }
  }
}
    `;

/**
 * __useGetSearchResultQuery__
 *
 * To run a query within a React component, call `useGetSearchResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchResultQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetSearchResultQuery(baseOptions: Apollo.QueryHookOptions<GetSearchResultQuery, GetSearchResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchResultQuery, GetSearchResultQueryVariables>(GetSearchResultDocument, options);
      }
export function useGetSearchResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchResultQuery, GetSearchResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchResultQuery, GetSearchResultQueryVariables>(GetSearchResultDocument, options);
        }
export type GetSearchResultQueryHookResult = ReturnType<typeof useGetSearchResultQuery>;
export type GetSearchResultLazyQueryHookResult = ReturnType<typeof useGetSearchResultLazyQuery>;
export type GetSearchResultQueryResult = Apollo.QueryResult<GetSearchResultQuery, GetSearchResultQueryVariables>;
export const GetNoteBrowsingHistoryDocument = gql`
    query GetNoteBrowsingHistory($first: Int!) {
  noteBrowsingHistories(first: $first) {
    edges {
      node {
        note {
          path
          title
          contributors(first: 2) {
            totalCount
            edges {
              node {
                id
                account
                avatar1x: avatarImage(size: SMALL, density: 1) {
                  url
                }
                avatar2x: avatarImage(size: SMALL, density: 2) {
                  url
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetNoteBrowsingHistoryQuery__
 *
 * To run a query within a React component, call `useGetNoteBrowsingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNoteBrowsingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNoteBrowsingHistoryQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetNoteBrowsingHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetNoteBrowsingHistoryQuery, GetNoteBrowsingHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNoteBrowsingHistoryQuery, GetNoteBrowsingHistoryQueryVariables>(GetNoteBrowsingHistoryDocument, options);
      }
export function useGetNoteBrowsingHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNoteBrowsingHistoryQuery, GetNoteBrowsingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNoteBrowsingHistoryQuery, GetNoteBrowsingHistoryQueryVariables>(GetNoteBrowsingHistoryDocument, options);
        }
export type GetNoteBrowsingHistoryQueryHookResult = ReturnType<typeof useGetNoteBrowsingHistoryQuery>;
export type GetNoteBrowsingHistoryLazyQueryHookResult = ReturnType<typeof useGetNoteBrowsingHistoryLazyQuery>;
export type GetNoteBrowsingHistoryQueryResult = Apollo.QueryResult<GetNoteBrowsingHistoryQuery, GetNoteBrowsingHistoryQueryVariables>;
export const CreateSearchFilterSetDocument = gql`
    mutation CreateSearchFilterSet($input: CreateSearchFilterSetInput!) {
  createSearchFilterSet(input: $input) {
    clientMutationId
  }
}
    `;
export type CreateSearchFilterSetMutationFn = Apollo.MutationFunction<CreateSearchFilterSetMutation, CreateSearchFilterSetMutationVariables>;

/**
 * __useCreateSearchFilterSetMutation__
 *
 * To run a mutation, you first call `useCreateSearchFilterSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSearchFilterSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSearchFilterSetMutation, { data, loading, error }] = useCreateSearchFilterSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSearchFilterSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateSearchFilterSetMutation, CreateSearchFilterSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSearchFilterSetMutation, CreateSearchFilterSetMutationVariables>(CreateSearchFilterSetDocument, options);
      }
export type CreateSearchFilterSetMutationHookResult = ReturnType<typeof useCreateSearchFilterSetMutation>;
export type CreateSearchFilterSetMutationResult = Apollo.MutationResult<CreateSearchFilterSetMutation>;
export type CreateSearchFilterSetMutationOptions = Apollo.BaseMutationOptions<CreateSearchFilterSetMutation, CreateSearchFilterSetMutationVariables>;
export const GetSearchFilterSetsDocument = gql`
    query GetSearchFilterSets($first: Int!) {
  searchFilterSets(first: $first) {
    totalCount
    edges {
      node {
        id
        excludeKeywords
        authorUsers {
          account
        }
        groups {
          databaseId
          name
          isPrivate
        }
        folders {
          id
          fullName
          group {
            databaseId
          }
        }
        dateGte
        isLikedByMe
        resourceTypes
        isArchived
      }
    }
  }
}
    `;

/**
 * __useGetSearchFilterSetsQuery__
 *
 * To run a query within a React component, call `useGetSearchFilterSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchFilterSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchFilterSetsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetSearchFilterSetsQuery(baseOptions: Apollo.QueryHookOptions<GetSearchFilterSetsQuery, GetSearchFilterSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchFilterSetsQuery, GetSearchFilterSetsQueryVariables>(GetSearchFilterSetsDocument, options);
      }
export function useGetSearchFilterSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchFilterSetsQuery, GetSearchFilterSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchFilterSetsQuery, GetSearchFilterSetsQueryVariables>(GetSearchFilterSetsDocument, options);
        }
export type GetSearchFilterSetsQueryHookResult = ReturnType<typeof useGetSearchFilterSetsQuery>;
export type GetSearchFilterSetsLazyQueryHookResult = ReturnType<typeof useGetSearchFilterSetsLazyQuery>;
export type GetSearchFilterSetsQueryResult = Apollo.QueryResult<GetSearchFilterSetsQuery, GetSearchFilterSetsQueryVariables>;
export const DeleteSearchFilterSetDocument = gql`
    mutation DeleteSearchFilterSet($input: DeleteSearchFilterSetInput!) {
  deleteSearchFilterSet(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteSearchFilterSetMutationFn = Apollo.MutationFunction<DeleteSearchFilterSetMutation, DeleteSearchFilterSetMutationVariables>;

/**
 * __useDeleteSearchFilterSetMutation__
 *
 * To run a mutation, you first call `useDeleteSearchFilterSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSearchFilterSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSearchFilterSetMutation, { data, loading, error }] = useDeleteSearchFilterSetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSearchFilterSetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSearchFilterSetMutation, DeleteSearchFilterSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSearchFilterSetMutation, DeleteSearchFilterSetMutationVariables>(DeleteSearchFilterSetDocument, options);
      }
export type DeleteSearchFilterSetMutationHookResult = ReturnType<typeof useDeleteSearchFilterSetMutation>;
export type DeleteSearchFilterSetMutationResult = Apollo.MutationResult<DeleteSearchFilterSetMutation>;
export type DeleteSearchFilterSetMutationOptions = Apollo.BaseMutationOptions<DeleteSearchFilterSetMutation, DeleteSearchFilterSetMutationVariables>;
export const GetSearchFolderResultDocument = gql`
    query GetSearchFolderResult($query: String!) {
  searchFolder(query: $query, first: 3) {
    totalCount
    edges {
      node {
        name
        fixedPath
        group {
          path
          name
          isPrivate
        }
      }
    }
  }
}
    `;

/**
 * __useGetSearchFolderResultQuery__
 *
 * To run a query within a React component, call `useGetSearchFolderResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchFolderResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchFolderResultQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetSearchFolderResultQuery(baseOptions: Apollo.QueryHookOptions<GetSearchFolderResultQuery, GetSearchFolderResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchFolderResultQuery, GetSearchFolderResultQueryVariables>(GetSearchFolderResultDocument, options);
      }
export function useGetSearchFolderResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchFolderResultQuery, GetSearchFolderResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchFolderResultQuery, GetSearchFolderResultQueryVariables>(GetSearchFolderResultDocument, options);
        }
export type GetSearchFolderResultQueryHookResult = ReturnType<typeof useGetSearchFolderResultQuery>;
export type GetSearchFolderResultLazyQueryHookResult = ReturnType<typeof useGetSearchFolderResultLazyQuery>;
export type GetSearchFolderResultQueryResult = Apollo.QueryResult<GetSearchFolderResultQuery, GetSearchFolderResultQueryVariables>;
export const GetSearchHistoryDocument = gql`
    query GetSearchHistory {
  searchHistory {
    entries {
      id
      hasCustomFilterSet
      keywords
      excludeKeywords
      authorUsers {
        id
        account
      }
      groups {
        id
        databaseId
        name
        isPrivate
      }
      folders {
        id
        fullName
        group {
          databaseId
        }
      }
      dateGte
      isLikedByMe
      resourceTypes
      isArchived
    }
  }
}
    `;

/**
 * __useGetSearchHistoryQuery__
 *
 * To run a query within a React component, call `useGetSearchHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSearchHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSearchHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSearchHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetSearchHistoryQuery, GetSearchHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSearchHistoryQuery, GetSearchHistoryQueryVariables>(GetSearchHistoryDocument, options);
      }
export function useGetSearchHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSearchHistoryQuery, GetSearchHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSearchHistoryQuery, GetSearchHistoryQueryVariables>(GetSearchHistoryDocument, options);
        }
export type GetSearchHistoryQueryHookResult = ReturnType<typeof useGetSearchHistoryQuery>;
export type GetSearchHistoryLazyQueryHookResult = ReturnType<typeof useGetSearchHistoryLazyQuery>;
export type GetSearchHistoryQueryResult = Apollo.QueryResult<GetSearchHistoryQuery, GetSearchHistoryQueryVariables>;
export const DeleteSearchHistoryEntryDocument = gql`
    mutation DeleteSearchHistoryEntry($input: DeleteSearchHistoryEntryInput!) {
  deleteSearchHistoryEntry(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteSearchHistoryEntryMutationFn = Apollo.MutationFunction<DeleteSearchHistoryEntryMutation, DeleteSearchHistoryEntryMutationVariables>;

/**
 * __useDeleteSearchHistoryEntryMutation__
 *
 * To run a mutation, you first call `useDeleteSearchHistoryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSearchHistoryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSearchHistoryEntryMutation, { data, loading, error }] = useDeleteSearchHistoryEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSearchHistoryEntryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSearchHistoryEntryMutation, DeleteSearchHistoryEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSearchHistoryEntryMutation, DeleteSearchHistoryEntryMutationVariables>(DeleteSearchHistoryEntryDocument, options);
      }
export type DeleteSearchHistoryEntryMutationHookResult = ReturnType<typeof useDeleteSearchHistoryEntryMutation>;
export type DeleteSearchHistoryEntryMutationResult = Apollo.MutationResult<DeleteSearchHistoryEntryMutation>;
export type DeleteSearchHistoryEntryMutationOptions = Apollo.BaseMutationOptions<DeleteSearchHistoryEntryMutation, DeleteSearchHistoryEntryMutationVariables>;
export const ShareMenuShareNoteWithOutsideOfTeamDocument = gql`
    mutation ShareMenuShareNoteWithOutsideOfTeam($noteId: ID!) {
  shareNoteWithOutsideOfTeam(input: {noteId: $noteId}) {
    note {
      id
      sharedNote {
        id
        url
      }
    }
  }
}
    `;
export type ShareMenuShareNoteWithOutsideOfTeamMutationFn = Apollo.MutationFunction<ShareMenuShareNoteWithOutsideOfTeamMutation, ShareMenuShareNoteWithOutsideOfTeamMutationVariables>;

/**
 * __useShareMenuShareNoteWithOutsideOfTeamMutation__
 *
 * To run a mutation, you first call `useShareMenuShareNoteWithOutsideOfTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareMenuShareNoteWithOutsideOfTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareMenuShareNoteWithOutsideOfTeamMutation, { data, loading, error }] = useShareMenuShareNoteWithOutsideOfTeamMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useShareMenuShareNoteWithOutsideOfTeamMutation(baseOptions?: Apollo.MutationHookOptions<ShareMenuShareNoteWithOutsideOfTeamMutation, ShareMenuShareNoteWithOutsideOfTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareMenuShareNoteWithOutsideOfTeamMutation, ShareMenuShareNoteWithOutsideOfTeamMutationVariables>(ShareMenuShareNoteWithOutsideOfTeamDocument, options);
      }
export type ShareMenuShareNoteWithOutsideOfTeamMutationHookResult = ReturnType<typeof useShareMenuShareNoteWithOutsideOfTeamMutation>;
export type ShareMenuShareNoteWithOutsideOfTeamMutationResult = Apollo.MutationResult<ShareMenuShareNoteWithOutsideOfTeamMutation>;
export type ShareMenuShareNoteWithOutsideOfTeamMutationOptions = Apollo.BaseMutationOptions<ShareMenuShareNoteWithOutsideOfTeamMutation, ShareMenuShareNoteWithOutsideOfTeamMutationVariables>;
export const ShareMenuUnshareNoteWithOutsideOfTeamDocument = gql`
    mutation ShareMenuUnshareNoteWithOutsideOfTeam($noteId: ID!) {
  unshareNoteWithOutsideOfTeam(input: {noteId: $noteId}) {
    clientMutationId
  }
}
    `;
export type ShareMenuUnshareNoteWithOutsideOfTeamMutationFn = Apollo.MutationFunction<ShareMenuUnshareNoteWithOutsideOfTeamMutation, ShareMenuUnshareNoteWithOutsideOfTeamMutationVariables>;

/**
 * __useShareMenuUnshareNoteWithOutsideOfTeamMutation__
 *
 * To run a mutation, you first call `useShareMenuUnshareNoteWithOutsideOfTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareMenuUnshareNoteWithOutsideOfTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareMenuUnshareNoteWithOutsideOfTeamMutation, { data, loading, error }] = useShareMenuUnshareNoteWithOutsideOfTeamMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *   },
 * });
 */
export function useShareMenuUnshareNoteWithOutsideOfTeamMutation(baseOptions?: Apollo.MutationHookOptions<ShareMenuUnshareNoteWithOutsideOfTeamMutation, ShareMenuUnshareNoteWithOutsideOfTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareMenuUnshareNoteWithOutsideOfTeamMutation, ShareMenuUnshareNoteWithOutsideOfTeamMutationVariables>(ShareMenuUnshareNoteWithOutsideOfTeamDocument, options);
      }
export type ShareMenuUnshareNoteWithOutsideOfTeamMutationHookResult = ReturnType<typeof useShareMenuUnshareNoteWithOutsideOfTeamMutation>;
export type ShareMenuUnshareNoteWithOutsideOfTeamMutationResult = Apollo.MutationResult<ShareMenuUnshareNoteWithOutsideOfTeamMutation>;
export type ShareMenuUnshareNoteWithOutsideOfTeamMutationOptions = Apollo.BaseMutationOptions<ShareMenuUnshareNoteWithOutsideOfTeamMutation, ShareMenuUnshareNoteWithOutsideOfTeamMutationVariables>;
export const GetCurrentUserGroupsDocument = gql`
    query GetCurrentUserGroups($allCount: Int!) {
  currentUser {
    id
    groups(first: $allCount) {
      nodes {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetCurrentUserGroupsQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserGroupsQuery({
 *   variables: {
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useGetCurrentUserGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserGroupsQuery, GetCurrentUserGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserGroupsQuery, GetCurrentUserGroupsQueryVariables>(GetCurrentUserGroupsDocument, options);
      }
export function useGetCurrentUserGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserGroupsQuery, GetCurrentUserGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserGroupsQuery, GetCurrentUserGroupsQueryVariables>(GetCurrentUserGroupsDocument, options);
        }
export type GetCurrentUserGroupsQueryHookResult = ReturnType<typeof useGetCurrentUserGroupsQuery>;
export type GetCurrentUserGroupsLazyQueryHookResult = ReturnType<typeof useGetCurrentUserGroupsLazyQuery>;
export type GetCurrentUserGroupsQueryResult = Apollo.QueryResult<GetCurrentUserGroupsQuery, GetCurrentUserGroupsQueryVariables>;
export const UpdateUsersGroupsDocument = gql`
    mutation UpdateUsersGroups($input: UpdateUsersGroupsInput!) {
  updateUsersGroups(input: $input) {
    clientMutationId
  }
}
    `;
export type UpdateUsersGroupsMutationFn = Apollo.MutationFunction<UpdateUsersGroupsMutation, UpdateUsersGroupsMutationVariables>;

/**
 * __useUpdateUsersGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateUsersGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersGroupsMutation, { data, loading, error }] = useUpdateUsersGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUsersGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUsersGroupsMutation, UpdateUsersGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUsersGroupsMutation, UpdateUsersGroupsMutationVariables>(UpdateUsersGroupsDocument, options);
      }
export type UpdateUsersGroupsMutationHookResult = ReturnType<typeof useUpdateUsersGroupsMutation>;
export type UpdateUsersGroupsMutationResult = Apollo.MutationResult<UpdateUsersGroupsMutation>;
export type UpdateUsersGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateUsersGroupsMutation, UpdateUsersGroupsMutationVariables>;
export const UserAvatarWithPopupDocument = gql`
    query UserAvatarWithPopup($userId: ID!) {
  user(id: $userId) {
    ...ProfilePopupUser
  }
}
    ${ProfilePopupUserFragmentDoc}`;

/**
 * __useUserAvatarWithPopupQuery__
 *
 * To run a query within a React component, call `useUserAvatarWithPopupQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAvatarWithPopupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAvatarWithPopupQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserAvatarWithPopupQuery(baseOptions: Apollo.QueryHookOptions<UserAvatarWithPopupQuery, UserAvatarWithPopupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAvatarWithPopupQuery, UserAvatarWithPopupQueryVariables>(UserAvatarWithPopupDocument, options);
      }
export function useUserAvatarWithPopupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAvatarWithPopupQuery, UserAvatarWithPopupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAvatarWithPopupQuery, UserAvatarWithPopupQueryVariables>(UserAvatarWithPopupDocument, options);
        }
export type UserAvatarWithPopupQueryHookResult = ReturnType<typeof useUserAvatarWithPopupQuery>;
export type UserAvatarWithPopupLazyQueryHookResult = ReturnType<typeof useUserAvatarWithPopupLazyQuery>;
export type UserAvatarWithPopupQueryResult = Apollo.QueryResult<UserAvatarWithPopupQuery, UserAvatarWithPopupQueryVariables>;
export const EditorContainerCoeditorAvatarsDocument = gql`
    query EditorContainerCoeditorAvatars($accounts: [String!]!, $allCount: Int!) {
  usersFromAccounts(accounts: $accounts, first: $allCount) {
    nodes {
      ...UserAvatarQueryFragment
      realName
    }
  }
}
    ${UserAvatarQueryFragmentFragmentDoc}`;

/**
 * __useEditorContainerCoeditorAvatarsQuery__
 *
 * To run a query within a React component, call `useEditorContainerCoeditorAvatarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditorContainerCoeditorAvatarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorContainerCoeditorAvatarsQuery({
 *   variables: {
 *      accounts: // value for 'accounts'
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useEditorContainerCoeditorAvatarsQuery(baseOptions: Apollo.QueryHookOptions<EditorContainerCoeditorAvatarsQuery, EditorContainerCoeditorAvatarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditorContainerCoeditorAvatarsQuery, EditorContainerCoeditorAvatarsQueryVariables>(EditorContainerCoeditorAvatarsDocument, options);
      }
export function useEditorContainerCoeditorAvatarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditorContainerCoeditorAvatarsQuery, EditorContainerCoeditorAvatarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditorContainerCoeditorAvatarsQuery, EditorContainerCoeditorAvatarsQueryVariables>(EditorContainerCoeditorAvatarsDocument, options);
        }
export type EditorContainerCoeditorAvatarsQueryHookResult = ReturnType<typeof useEditorContainerCoeditorAvatarsQuery>;
export type EditorContainerCoeditorAvatarsLazyQueryHookResult = ReturnType<typeof useEditorContainerCoeditorAvatarsLazyQuery>;
export type EditorContainerCoeditorAvatarsQueryResult = Apollo.QueryResult<EditorContainerCoeditorAvatarsQuery, EditorContainerCoeditorAvatarsQueryVariables>;
export const CreateCustomEmojiDocument = gql`
    mutation CreateCustomEmoji($input: CreateCustomEmojiInput!) {
  createCustomEmoji(input: $input) {
    customEmoji {
      ...CustomEmojiFragment
    }
  }
}
    ${CustomEmojiFragmentFragmentDoc}`;
export type CreateCustomEmojiMutationFn = Apollo.MutationFunction<CreateCustomEmojiMutation, CreateCustomEmojiMutationVariables>;

/**
 * __useCreateCustomEmojiMutation__
 *
 * To run a mutation, you first call `useCreateCustomEmojiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomEmojiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomEmojiMutation, { data, loading, error }] = useCreateCustomEmojiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomEmojiMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomEmojiMutation, CreateCustomEmojiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomEmojiMutation, CreateCustomEmojiMutationVariables>(CreateCustomEmojiDocument, options);
      }
export type CreateCustomEmojiMutationHookResult = ReturnType<typeof useCreateCustomEmojiMutation>;
export type CreateCustomEmojiMutationResult = Apollo.MutationResult<CreateCustomEmojiMutation>;
export type CreateCustomEmojiMutationOptions = Apollo.BaseMutationOptions<CreateCustomEmojiMutation, CreateCustomEmojiMutationVariables>;
export const DeleteCustomEmojiDocument = gql`
    mutation DeleteCustomEmoji($input: DeleteCustomEmojiInput!) {
  deleteCustomEmoji(input: $input) {
    clientMutationId
  }
}
    `;
export type DeleteCustomEmojiMutationFn = Apollo.MutationFunction<DeleteCustomEmojiMutation, DeleteCustomEmojiMutationVariables>;

/**
 * __useDeleteCustomEmojiMutation__
 *
 * To run a mutation, you first call `useDeleteCustomEmojiMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCustomEmojiMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCustomEmojiMutation, { data, loading, error }] = useDeleteCustomEmojiMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCustomEmojiMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCustomEmojiMutation, DeleteCustomEmojiMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCustomEmojiMutation, DeleteCustomEmojiMutationVariables>(DeleteCustomEmojiDocument, options);
      }
export type DeleteCustomEmojiMutationHookResult = ReturnType<typeof useDeleteCustomEmojiMutation>;
export type DeleteCustomEmojiMutationResult = Apollo.MutationResult<DeleteCustomEmojiMutation>;
export type DeleteCustomEmojiMutationOptions = Apollo.BaseMutationOptions<DeleteCustomEmojiMutation, DeleteCustomEmojiMutationVariables>;
export const InviteDocument = gql`
    mutation Invite($email: String!, $role: Role!, $message: String!, $groupIds: [ID!]!) {
  invite(
    input: {email: $email, role: $role, message: $message, groupIds: $groupIds}
  ) {
    email
    hint
  }
}
    `;
export type InviteMutationFn = Apollo.MutationFunction<InviteMutation, InviteMutationVariables>;

/**
 * __useInviteMutation__
 *
 * To run a mutation, you first call `useInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteMutation, { data, loading, error }] = useInviteMutation({
 *   variables: {
 *      email: // value for 'email'
 *      role: // value for 'role'
 *      message: // value for 'message'
 *      groupIds: // value for 'groupIds'
 *   },
 * });
 */
export function useInviteMutation(baseOptions?: Apollo.MutationHookOptions<InviteMutation, InviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteMutation, InviteMutationVariables>(InviteDocument, options);
      }
export type InviteMutationHookResult = ReturnType<typeof useInviteMutation>;
export type InviteMutationResult = Apollo.MutationResult<InviteMutation>;
export type InviteMutationOptions = Apollo.BaseMutationOptions<InviteMutation, InviteMutationVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications {
  notifications(first: 25) {
    nodes {
      id
      sender {
        account
        avatarSrc1x: avatarImage {
          url
        }
        avatarSrc2x: avatarImage(density: 2) {
          url
        }
      }
      state
      messageHtml
      sourcePath
      updatedAt
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetUnreadNotificationsCountDocument = gql`
    query getUnreadNotificationsCount {
  notifications(state: UNREAD) {
    totalCount
  }
}
    `;

/**
 * __useGetUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>(GetUnreadNotificationsCountDocument, options);
      }
export function useGetUnreadNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>(GetUnreadNotificationsCountDocument, options);
        }
export type GetUnreadNotificationsCountQueryHookResult = ReturnType<typeof useGetUnreadNotificationsCountQuery>;
export type GetUnreadNotificationsCountLazyQueryHookResult = ReturnType<typeof useGetUnreadNotificationsCountLazyQuery>;
export type GetUnreadNotificationsCountQueryResult = Apollo.QueryResult<GetUnreadNotificationsCountQuery, GetUnreadNotificationsCountQueryVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead {
  markNotificationsAsRead(input: {}) {
    clientMutationId
  }
}
    `;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const AttachNoteToFolderDocument = gql`
    mutation AttachNoteToFolder($noteId: ID!, $folder: FolderInput!) {
  attachNoteToFolder(input: {noteId: $noteId, folder: $folder}) {
    attachedFolder {
      id
    }
  }
}
    `;
export type AttachNoteToFolderMutationFn = Apollo.MutationFunction<AttachNoteToFolderMutation, AttachNoteToFolderMutationVariables>;

/**
 * __useAttachNoteToFolderMutation__
 *
 * To run a mutation, you first call `useAttachNoteToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachNoteToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachNoteToFolderMutation, { data, loading, error }] = useAttachNoteToFolderMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useAttachNoteToFolderMutation(baseOptions?: Apollo.MutationHookOptions<AttachNoteToFolderMutation, AttachNoteToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachNoteToFolderMutation, AttachNoteToFolderMutationVariables>(AttachNoteToFolderDocument, options);
      }
export type AttachNoteToFolderMutationHookResult = ReturnType<typeof useAttachNoteToFolderMutation>;
export type AttachNoteToFolderMutationResult = Apollo.MutationResult<AttachNoteToFolderMutation>;
export type AttachNoteToFolderMutationOptions = Apollo.BaseMutationOptions<AttachNoteToFolderMutation, AttachNoteToFolderMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation DeleteNote($id: ID!) {
  deleteNote(input: {id: $id}) {
    clientMutationId
  }
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const DetachNoteFromFolderDocument = gql`
    mutation DetachNoteFromFolder($noteId: ID!, $folder: FolderInput!) {
  detachNoteFromFolder(input: {noteId: $noteId, folder: $folder}) {
    detachedFolder {
      id
    }
  }
}
    `;
export type DetachNoteFromFolderMutationFn = Apollo.MutationFunction<DetachNoteFromFolderMutation, DetachNoteFromFolderMutationVariables>;

/**
 * __useDetachNoteFromFolderMutation__
 *
 * To run a mutation, you first call `useDetachNoteFromFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetachNoteFromFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detachNoteFromFolderMutation, { data, loading, error }] = useDetachNoteFromFolderMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      folder: // value for 'folder'
 *   },
 * });
 */
export function useDetachNoteFromFolderMutation(baseOptions?: Apollo.MutationHookOptions<DetachNoteFromFolderMutation, DetachNoteFromFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DetachNoteFromFolderMutation, DetachNoteFromFolderMutationVariables>(DetachNoteFromFolderDocument, options);
      }
export type DetachNoteFromFolderMutationHookResult = ReturnType<typeof useDetachNoteFromFolderMutation>;
export type DetachNoteFromFolderMutationResult = Apollo.MutationResult<DetachNoteFromFolderMutation>;
export type DetachNoteFromFolderMutationOptions = Apollo.BaseMutationOptions<DetachNoteFromFolderMutation, DetachNoteFromFolderMutationVariables>;
export const LeaveGroupDocument = gql`
    mutation LeaveGroup($input: LeaveGroupInput!) {
  leaveGroup(input: $input) {
    clientMutationId
  }
}
    `;
export type LeaveGroupMutationFn = Apollo.MutationFunction<LeaveGroupMutation, LeaveGroupMutationVariables>;

/**
 * __useLeaveGroupMutation__
 *
 * To run a mutation, you first call `useLeaveGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveGroupMutation, { data, loading, error }] = useLeaveGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeaveGroupMutation(baseOptions?: Apollo.MutationHookOptions<LeaveGroupMutation, LeaveGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeaveGroupMutation, LeaveGroupMutationVariables>(LeaveGroupDocument, options);
      }
export type LeaveGroupMutationHookResult = ReturnType<typeof useLeaveGroupMutation>;
export type LeaveGroupMutationResult = Apollo.MutationResult<LeaveGroupMutation>;
export type LeaveGroupMutationOptions = Apollo.BaseMutationOptions<LeaveGroupMutation, LeaveGroupMutationVariables>;
export const MoveNoteToAnotherFolderDocument = gql`
    mutation MoveNoteToAnotherFolder($noteId: ID!, $fromFolder: FolderInput!, $toFolder: FolderInput!) {
  moveNoteToAnotherFolder(
    input: {noteId: $noteId, fromFolder: $fromFolder, toFolder: $toFolder}
  ) {
    beforeFolder {
      id
    }
    afterFolder {
      id
    }
  }
}
    `;
export type MoveNoteToAnotherFolderMutationFn = Apollo.MutationFunction<MoveNoteToAnotherFolderMutation, MoveNoteToAnotherFolderMutationVariables>;

/**
 * __useMoveNoteToAnotherFolderMutation__
 *
 * To run a mutation, you first call `useMoveNoteToAnotherFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveNoteToAnotherFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveNoteToAnotherFolderMutation, { data, loading, error }] = useMoveNoteToAnotherFolderMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      fromFolder: // value for 'fromFolder'
 *      toFolder: // value for 'toFolder'
 *   },
 * });
 */
export function useMoveNoteToAnotherFolderMutation(baseOptions?: Apollo.MutationHookOptions<MoveNoteToAnotherFolderMutation, MoveNoteToAnotherFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveNoteToAnotherFolderMutation, MoveNoteToAnotherFolderMutationVariables>(MoveNoteToAnotherFolderDocument, options);
      }
export type MoveNoteToAnotherFolderMutationHookResult = ReturnType<typeof useMoveNoteToAnotherFolderMutation>;
export type MoveNoteToAnotherFolderMutationResult = Apollo.MutationResult<MoveNoteToAnotherFolderMutation>;
export type MoveNoteToAnotherFolderMutationOptions = Apollo.BaseMutationOptions<MoveNoteToAnotherFolderMutation, MoveNoteToAnotherFolderMutationVariables>;
export const MoveNoteToAnotherGroupDocument = gql`
    mutation MoveNoteToAnotherGroup($noteId: ID!, $fromGroupId: ID!, $fromFolderId: ID, $toGroupId: ID!) {
  moveNoteToAnotherGroup(
    input: {noteId: $noteId, fromGroupId: $fromGroupId, fromFolderId: $fromFolderId, toGroupId: $toGroupId}
  ) {
    note {
      id
    }
  }
}
    `;
export type MoveNoteToAnotherGroupMutationFn = Apollo.MutationFunction<MoveNoteToAnotherGroupMutation, MoveNoteToAnotherGroupMutationVariables>;

/**
 * __useMoveNoteToAnotherGroupMutation__
 *
 * To run a mutation, you first call `useMoveNoteToAnotherGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveNoteToAnotherGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveNoteToAnotherGroupMutation, { data, loading, error }] = useMoveNoteToAnotherGroupMutation({
 *   variables: {
 *      noteId: // value for 'noteId'
 *      fromGroupId: // value for 'fromGroupId'
 *      fromFolderId: // value for 'fromFolderId'
 *      toGroupId: // value for 'toGroupId'
 *   },
 * });
 */
export function useMoveNoteToAnotherGroupMutation(baseOptions?: Apollo.MutationHookOptions<MoveNoteToAnotherGroupMutation, MoveNoteToAnotherGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveNoteToAnotherGroupMutation, MoveNoteToAnotherGroupMutationVariables>(MoveNoteToAnotherGroupDocument, options);
      }
export type MoveNoteToAnotherGroupMutationHookResult = ReturnType<typeof useMoveNoteToAnotherGroupMutation>;
export type MoveNoteToAnotherGroupMutationResult = Apollo.MutationResult<MoveNoteToAnotherGroupMutation>;
export type MoveNoteToAnotherGroupMutationOptions = Apollo.BaseMutationOptions<MoveNoteToAnotherGroupMutation, MoveNoteToAnotherGroupMutationVariables>;
export const SyncUserLastUsedEditorDocument = gql`
    mutation SyncUserLastUsedEditor($input: SyncUserLastUsedEditorInput!) {
  syncUserLastUsedEditor(input: $input) {
    clientMutationId
  }
}
    `;
export type SyncUserLastUsedEditorMutationFn = Apollo.MutationFunction<SyncUserLastUsedEditorMutation, SyncUserLastUsedEditorMutationVariables>;

/**
 * __useSyncUserLastUsedEditorMutation__
 *
 * To run a mutation, you first call `useSyncUserLastUsedEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncUserLastUsedEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncUserLastUsedEditorMutation, { data, loading, error }] = useSyncUserLastUsedEditorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncUserLastUsedEditorMutation(baseOptions?: Apollo.MutationHookOptions<SyncUserLastUsedEditorMutation, SyncUserLastUsedEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncUserLastUsedEditorMutation, SyncUserLastUsedEditorMutationVariables>(SyncUserLastUsedEditorDocument, options);
      }
export type SyncUserLastUsedEditorMutationHookResult = ReturnType<typeof useSyncUserLastUsedEditorMutation>;
export type SyncUserLastUsedEditorMutationResult = Apollo.MutationResult<SyncUserLastUsedEditorMutation>;
export type SyncUserLastUsedEditorMutationOptions = Apollo.BaseMutationOptions<SyncUserLastUsedEditorMutation, SyncUserLastUsedEditorMutationVariables>;
export const EnableSharedNoteCommentsFeatureDocument = gql`
    mutation EnableSharedNoteCommentsFeature {
  enableSharedNoteCommentsFeature(input: {}) {
    clientMutationId
  }
}
    `;
export type EnableSharedNoteCommentsFeatureMutationFn = Apollo.MutationFunction<EnableSharedNoteCommentsFeatureMutation, EnableSharedNoteCommentsFeatureMutationVariables>;

/**
 * __useEnableSharedNoteCommentsFeatureMutation__
 *
 * To run a mutation, you first call `useEnableSharedNoteCommentsFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableSharedNoteCommentsFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableSharedNoteCommentsFeatureMutation, { data, loading, error }] = useEnableSharedNoteCommentsFeatureMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnableSharedNoteCommentsFeatureMutation(baseOptions?: Apollo.MutationHookOptions<EnableSharedNoteCommentsFeatureMutation, EnableSharedNoteCommentsFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableSharedNoteCommentsFeatureMutation, EnableSharedNoteCommentsFeatureMutationVariables>(EnableSharedNoteCommentsFeatureDocument, options);
      }
export type EnableSharedNoteCommentsFeatureMutationHookResult = ReturnType<typeof useEnableSharedNoteCommentsFeatureMutation>;
export type EnableSharedNoteCommentsFeatureMutationResult = Apollo.MutationResult<EnableSharedNoteCommentsFeatureMutation>;
export type EnableSharedNoteCommentsFeatureMutationOptions = Apollo.BaseMutationOptions<EnableSharedNoteCommentsFeatureMutation, EnableSharedNoteCommentsFeatureMutationVariables>;
export const DisableSharedNoteCommentsFeatureDocument = gql`
    mutation DisableSharedNoteCommentsFeature {
  disableSharedNoteCommentsFeature(input: {}) {
    clientMutationId
  }
}
    `;
export type DisableSharedNoteCommentsFeatureMutationFn = Apollo.MutationFunction<DisableSharedNoteCommentsFeatureMutation, DisableSharedNoteCommentsFeatureMutationVariables>;

/**
 * __useDisableSharedNoteCommentsFeatureMutation__
 *
 * To run a mutation, you first call `useDisableSharedNoteCommentsFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSharedNoteCommentsFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSharedNoteCommentsFeatureMutation, { data, loading, error }] = useDisableSharedNoteCommentsFeatureMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableSharedNoteCommentsFeatureMutation(baseOptions?: Apollo.MutationHookOptions<DisableSharedNoteCommentsFeatureMutation, DisableSharedNoteCommentsFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableSharedNoteCommentsFeatureMutation, DisableSharedNoteCommentsFeatureMutationVariables>(DisableSharedNoteCommentsFeatureDocument, options);
      }
export type DisableSharedNoteCommentsFeatureMutationHookResult = ReturnType<typeof useDisableSharedNoteCommentsFeatureMutation>;
export type DisableSharedNoteCommentsFeatureMutationResult = Apollo.MutationResult<DisableSharedNoteCommentsFeatureMutation>;
export type DisableSharedNoteCommentsFeatureMutationOptions = Apollo.BaseMutationOptions<DisableSharedNoteCommentsFeatureMutation, DisableSharedNoteCommentsFeatureMutationVariables>;
export const EnableSharedNotesFeatureDocument = gql`
    mutation EnableSharedNotesFeature {
  enableSharedNotesFeature(input: {}) {
    clientMutationId
  }
}
    `;
export type EnableSharedNotesFeatureMutationFn = Apollo.MutationFunction<EnableSharedNotesFeatureMutation, EnableSharedNotesFeatureMutationVariables>;

/**
 * __useEnableSharedNotesFeatureMutation__
 *
 * To run a mutation, you first call `useEnableSharedNotesFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableSharedNotesFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableSharedNotesFeatureMutation, { data, loading, error }] = useEnableSharedNotesFeatureMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnableSharedNotesFeatureMutation(baseOptions?: Apollo.MutationHookOptions<EnableSharedNotesFeatureMutation, EnableSharedNotesFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableSharedNotesFeatureMutation, EnableSharedNotesFeatureMutationVariables>(EnableSharedNotesFeatureDocument, options);
      }
export type EnableSharedNotesFeatureMutationHookResult = ReturnType<typeof useEnableSharedNotesFeatureMutation>;
export type EnableSharedNotesFeatureMutationResult = Apollo.MutationResult<EnableSharedNotesFeatureMutation>;
export type EnableSharedNotesFeatureMutationOptions = Apollo.BaseMutationOptions<EnableSharedNotesFeatureMutation, EnableSharedNotesFeatureMutationVariables>;
export const DisableSharedNotesFeatureDocument = gql`
    mutation DisableSharedNotesFeature {
  disableSharedNotesFeature(input: {}) {
    clientMutationId
  }
}
    `;
export type DisableSharedNotesFeatureMutationFn = Apollo.MutationFunction<DisableSharedNotesFeatureMutation, DisableSharedNotesFeatureMutationVariables>;

/**
 * __useDisableSharedNotesFeatureMutation__
 *
 * To run a mutation, you first call `useDisableSharedNotesFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableSharedNotesFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableSharedNotesFeatureMutation, { data, loading, error }] = useDisableSharedNotesFeatureMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableSharedNotesFeatureMutation(baseOptions?: Apollo.MutationHookOptions<DisableSharedNotesFeatureMutation, DisableSharedNotesFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableSharedNotesFeatureMutation, DisableSharedNotesFeatureMutationVariables>(DisableSharedNotesFeatureDocument, options);
      }
export type DisableSharedNotesFeatureMutationHookResult = ReturnType<typeof useDisableSharedNotesFeatureMutation>;
export type DisableSharedNotesFeatureMutationResult = Apollo.MutationResult<DisableSharedNotesFeatureMutation>;
export type DisableSharedNotesFeatureMutationOptions = Apollo.BaseMutationOptions<DisableSharedNotesFeatureMutation, DisableSharedNotesFeatureMutationVariables>;
export const FetchCustomEmojisDocument = gql`
    query FetchCustomEmojis($allCount: Int!) {
  customEmojisCacheKey
  customEmojis(first: $allCount) {
    nodes {
      name: emojiCode
      src: imageUrl
    }
  }
}
    `;

/**
 * __useFetchCustomEmojisQuery__
 *
 * To run a query within a React component, call `useFetchCustomEmojisQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCustomEmojisQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCustomEmojisQuery({
 *   variables: {
 *      allCount: // value for 'allCount'
 *   },
 * });
 */
export function useFetchCustomEmojisQuery(baseOptions: Apollo.QueryHookOptions<FetchCustomEmojisQuery, FetchCustomEmojisQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCustomEmojisQuery, FetchCustomEmojisQueryVariables>(FetchCustomEmojisDocument, options);
      }
export function useFetchCustomEmojisLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCustomEmojisQuery, FetchCustomEmojisQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCustomEmojisQuery, FetchCustomEmojisQueryVariables>(FetchCustomEmojisDocument, options);
        }
export type FetchCustomEmojisQueryHookResult = ReturnType<typeof useFetchCustomEmojisQuery>;
export type FetchCustomEmojisLazyQueryHookResult = ReturnType<typeof useFetchCustomEmojisLazyQuery>;
export type FetchCustomEmojisQueryResult = Apollo.QueryResult<FetchCustomEmojisQuery, FetchCustomEmojisQueryVariables>;
export const GetFoldersForTreeDocument = gql`
    query GetFoldersForTree($allCount: Int!, $groupId: ID!) {
  foldersCacheKey
  group(id: $groupId) {
    id
    folders(first: $allCount) {
      nodes {
        id
        name
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetFoldersForTreeQuery__
 *
 * To run a query within a React component, call `useGetFoldersForTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFoldersForTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFoldersForTreeQuery({
 *   variables: {
 *      allCount: // value for 'allCount'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetFoldersForTreeQuery(baseOptions: Apollo.QueryHookOptions<GetFoldersForTreeQuery, GetFoldersForTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFoldersForTreeQuery, GetFoldersForTreeQueryVariables>(GetFoldersForTreeDocument, options);
      }
export function useGetFoldersForTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFoldersForTreeQuery, GetFoldersForTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFoldersForTreeQuery, GetFoldersForTreeQueryVariables>(GetFoldersForTreeDocument, options);
        }
export type GetFoldersForTreeQueryHookResult = ReturnType<typeof useGetFoldersForTreeQuery>;
export type GetFoldersForTreeLazyQueryHookResult = ReturnType<typeof useGetFoldersForTreeLazyQuery>;
export type GetFoldersForTreeQueryResult = Apollo.QueryResult<GetFoldersForTreeQuery, GetFoldersForTreeQueryVariables>;
export const GetRootWithChildrenFoldersForTreeDocument = gql`
    query GetRootWithChildrenFoldersForTree($allCount: Int!, $groupId: ID!) {
  foldersCacheKey
  group(id: $groupId) {
    id
    folders(first: $allCount, parentFolderId: null, withChildren: true) {
      nodes {
        id
        name
        fullName
      }
    }
  }
}
    `;

/**
 * __useGetRootWithChildrenFoldersForTreeQuery__
 *
 * To run a query within a React component, call `useGetRootWithChildrenFoldersForTreeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRootWithChildrenFoldersForTreeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRootWithChildrenFoldersForTreeQuery({
 *   variables: {
 *      allCount: // value for 'allCount'
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetRootWithChildrenFoldersForTreeQuery(baseOptions: Apollo.QueryHookOptions<GetRootWithChildrenFoldersForTreeQuery, GetRootWithChildrenFoldersForTreeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRootWithChildrenFoldersForTreeQuery, GetRootWithChildrenFoldersForTreeQueryVariables>(GetRootWithChildrenFoldersForTreeDocument, options);
      }
export function useGetRootWithChildrenFoldersForTreeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRootWithChildrenFoldersForTreeQuery, GetRootWithChildrenFoldersForTreeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRootWithChildrenFoldersForTreeQuery, GetRootWithChildrenFoldersForTreeQueryVariables>(GetRootWithChildrenFoldersForTreeDocument, options);
        }
export type GetRootWithChildrenFoldersForTreeQueryHookResult = ReturnType<typeof useGetRootWithChildrenFoldersForTreeQuery>;
export type GetRootWithChildrenFoldersForTreeLazyQueryHookResult = ReturnType<typeof useGetRootWithChildrenFoldersForTreeLazyQuery>;
export type GetRootWithChildrenFoldersForTreeQueryResult = Apollo.QueryResult<GetRootWithChildrenFoldersForTreeQuery, GetRootWithChildrenFoldersForTreeQueryVariables>;